const nb = {
  language: 'nb',
  aiChat: {
    title: 'Glow Intelligence',
    close: 'Lukk',
    resize: 'Endre bredden på panelet',
    move: 'Dra eller bruk piltastene for å flytte',
    send: 'Send',
    stop: 'Stopp',
    placeholder: 'Spør om hvordan Glow fungerer…',
    empty: 'Spør om hva som helst om hvordan Glow fungerer.',
    disclaimer: 'Svarene er generert av AI og kan være feil. Assistenten har ikke tilgang til dine sendingsdata.',
    error: 'Noe gikk galt under svaret.',
    retry: 'Prøv igjen',
    helpful: 'Nyttig',
    notHelpful: 'Ikke nyttig',
    commentLabel: 'Legg til en kommentar',
    commentOptional: 'valgfritt',
    commentPlaceholder: 'Hva var bra eller dårlig med svaret?',
    feedbackThanks: 'Takk for tilbakemeldingen.',
    beta: 'Beta',
    thinking: 'Tenker…',
    tools: {
      glossary: {
        running: 'Slår opp {{detail}} i ordlisten…',
        used: 'Slo opp {{detail}} i ordlisten'
      },
      fallback: {
        running: 'Henter informasjon…',
        used: 'Hentet informasjon'
      }
    },
    newChat: 'Ny samtale',
    language: 'Svarspråk',
    copyAnswer: 'Kopier svaret',
    sources: 'Kilder',
    sourceUpdated: 'Oppdatert {{date}}',
    app: { 'internal-frontend': 'Glow', 'customer-frontend': 'Kundeportalen', tracking: 'Sporing' },
    copied: 'Kopiert',
    history: {
      open: 'Samtalehistorikk',
      back: 'Tilbake til samtalen',
      empty: 'Ingen tidligere samtaler.',
      error: 'Kunne ikke laste samtalene dine.',
      loadError: 'Kunne ikke laste samtalen.',
      delete: 'Slett samtalen «{{title}}»',
      deleteConfirm: 'Slette samtalen «{{title}}»?',
      deleteYes: 'Slett',
      deleteCancel: 'Avbryt',
      deleteError: 'Kunne ikke slette samtalen.'
    },
    suggestions: {
      dispatch: 'Hvordan tildeler jeg sendinger til en rute?',
      statuses: 'Hva betyr de ulike sendingsstatusene?',
      recurring: 'Hvordan setter jeg opp en fast rute?',
      deviation: 'Hva betyr det at en sending har et avvik?'
    }
  },
  userRoles: {
    admin: 'Admin',
    planner: 'Normal',
    read_only_planner: 'Lesetilgang',
    plus_planner: 'Plus',
    partner: 'Partner',
    customer: 'Kunde',
    customs_agent: 'Tollagent',
    support: 'Support',
    handler: 'Behandler'
  },
  emptyStates: { notFoundTitle: 'Ingen resultater' },
  application: {
    save: 'Lagre',
    all: 'Alle',
    assigned: 'Tildelt',
    created: 'Opprettet',
    selected: 'Valgt',
    filter: 'Filter',
    reset: 'Tilbakestill',
    cluster: 'Klynge',
    update: 'Oppdater',
    required: '*Obligatorisk felt',
    requiredShort: '*Obligatorisk',
    endsNextDay: 'slutter neste dag',
    lastUpdated: 'Sist oppdatert',
    requiredLocation: '* Lokasjon mangler',
    search: 'Søk',
    logOut: 'Logg ut',
    courier: 'Sjåfør',
    drivers: 'Sjåfører',
    consignments: 'Leveranser',
    status: 'Status',
    address: 'Addresse',
    move: 'Flytt',
    estimatedDepartureTime: 'ETD',
    adjusted: 'Justert',
    actual: 'Faktisk',
    tracking: 'Sporing',
    trackingPage: 'Sporingsside',
    allSelected: 'Alle valgte',
    someSelected: '{{count}} valgt',
    noneSelected: 'Ingen valgt',
    appBuild: 'App-build',
    lastLogin: 'Sist innlogget',
    device: 'Enhet',
    model: 'Modell',
    os: 'OS',
    units: 'Enheter',
    phoneNumberShort: 'Tlf nr.',
    yes: 'Ja',
    no: 'Nei',
    notSelected: 'Ikke valgt',
    sms: 'SMS',
    httpErrorToString: 'HTTP-feil: kode {{status}} {{statusText}}',
    anErrorOccurred: 'En feil har oppstått!',
    noAccessTitle: 'Ingen tilgang',
    noAccessMessage: 'Du har ikke tilgang til å denne funksjonaliten',
    autoComplete: 'Søk etter adresse ...',
    autoCompleteWithoutDots: 'Søk etter adresse',
    totalWeight: 'Totalvekt',
    totalVolume: 'Totalt volum',
    validDeviationCode: 'Skriv inn en gyldig verdi',
    columns: 'Kolonner',
    title: {
      siteName: 'Glow',
      root: 'Velkommen',
      planner: 'Planlegger',
      admin: 'Administrasjon',
      settings: 'Innstillinger',
      plannerLive: 'Planlegger - Live',
      plannerLiveSlot: 'Planlegger - Live - Slot',
      plannerCouriers: 'Planlegger - Sjåfører',
      templateRouteRules: 'Planlegger - Administrer ruteregler',
      plannerUnits: 'Planlegger - Enheter',
      plannerImport: 'Planlegger - Import',
      plannerUnresolved: 'Planlegger - Uløste',
      plannerCoordinates: 'Planlegger - Angi koordinater',
      plannerConsignments: 'Planlegger - Leveranser',
      plannerSearch: 'Planlegger - Search',
      plannerPlanning: 'Planlegger - planlegging',
      waybills: 'Planlegger - Fraktbrev',
      deliveryNotes: 'Planlegger - Følgesedler',
      plannerInvoicing: 'Planlegger - fakturering',
      plannerCreateBillingOrder: 'Planlegger - Opprett faktureringsordre',
      plannerEditBillingOrder: 'Planlegger - Rediger faktureringsordre',
      plannerCreateCreditNote: 'Planlegger - Opprett kreditnota',
      plannerCopyToBillingOrder: 'Planlegger - Opprett kopi til faktureringsordre',
      plannerVehicle: 'Planlegger - Vehicles',
      report: 'Rapporter',
      customerDepartmentLive: 'Live-visning',
      recipient: 'Pakkesporing - sporing av pakker - sporing - Bring',
      instant: 'Instant',
      instantBooking: 'Booking',
      h2Booking: 'H2-booking',
      orderConfirmation: 'Ordrebekreftelse',
      instantMap: 'Instant-kart',
      instantMap2: '$t(application.title.instantMap)',
      recurringOrder: 'Gjentagende ordre',
      corrections: 'Ordrekorrigeringer',
      customerPortal: 'Kundeportal',
      financial: 'Økonomiske rettigheter',
      readAny: 'Lesetilgang til alt',
      jobs: 'Jobbovervåking',
      holidays: 'Helligdager',
      shipmentLabels: 'Labels',
      addresses: 'Adresser',
      shd: 'SHD',
      preadvice: 'Avisering',
      apollo: 'Apollo',
      routeReceiptList: 'Kvitteringsliste',
      routesOverview: 'Ruteoversikt',
      loadList: 'Lasteliste',
      pickupOrders: 'Opphentingsordre',
      customerBooking: 'Kundebooking',
      manageReturns: 'Administrer returer',
      preAdviceFollowup: 'Administrer forhåndsvarsel',
      integrations: '$t(apolloAdmin.title)',
      parcelHub: '$t(parcelHubAdmin.title)',
      recurring: 'Planlegger - Gjentagende'
    },
    language: { en: 'Engelsk', nb: 'Norsk', sv: 'Svensk', dk: 'Dansk', fi: 'Finsk', fr: 'Fransk' },
    country: {
      AllCountry: 'Alle land',
      Country: 'Land',
      AD: 'Andorra',
      AT: 'Østerrike',
      BE: 'Belgia',
      BA: 'Bosnia og Herzegovina',
      BG: 'Bulgaria',
      HR: 'Kroatia',
      CZ: 'Tsjekkia',
      DK: 'Danmark',
      GB: 'Storbritannia',
      EE: 'Estland',
      FO: 'Færøyene',
      FI: 'Finland',
      FR: 'Frankrike',
      DE: 'Tyskland',
      GI: 'Gibraltar',
      GR: 'Hellas',
      HU: 'Ungarn',
      IS: 'Island',
      IE: 'Irland',
      IT: 'Italia',
      LV: 'Latvia',
      LT: 'Litauen',
      LU: 'Luxembourg',
      MK: 'Nord-Makedonia',
      MT: 'Malta',
      MC: 'Monaco',
      ME: 'Montenegro',
      NL: 'Nederland',
      NO: 'Norge',
      PL: 'Polen',
      PT: 'Portugal',
      RO: 'Romania',
      RU: 'Russland',
      SM: 'San Marino',
      RS: 'Serbia',
      SK: 'Slovakia',
      SI: 'Slovenia',
      ES: 'Spania',
      SE: 'Sverige',
      CH: 'Sveits',
      UA: 'Ukraina'
    },
    timeDistance: 'Planlagt tid og avstand',
    driverReturnToAddress: 'Ikke spesifiser en returadresse',
    distance: 'Avstand',
    helpLink: '(Hva er dette?)',
    none: 'Ingen',
    noOptions: 'Ingen alternativer',
    groups: 'Grupper',
    departments: 'Avdelinger',
    selectAll: 'Velg alle',
    totalCustomerPrice: 'Totalt kundepris',
    totalUnitPrice: 'Totalt enhetspris',
    notFound: 'Ikke funnet'
  },
  serviceLevel: {
    notSet: 'Ikke valgt',
    none: 'Av',
    standard: 'Standard',
    premium: 'Premium',
    label: 'Nedgrader servicenivå',
    ingress: 'Angi en standard e-postadresse som kan motta varsel ved ordreregistrering, opphenting og/eller levering.'
  },
  dropdown: {
    nrSelected: '{{count}} valgt',
    nrSelected_other: '{{count}} valgt',
    selectedCustomers: '{{count}} kunde',
    selectedCustomers_other: '{{count}} kunder',
    allCustomers: 'Alle kunder',
    filterCustomers: 'Filtrer kunder',
    selectedDepartments: '{{count}} avdeling',
    selectedDepartments_other: '{{count}} avdelinger',
    allDepartments: 'Alle avdelinger',
    filterDepartments: 'Filtrer avdelinger',
    selectedServiceCodes: '{{count}} tjeneste',
    selectedServiceCodes_other: '{{count}} tjenester',
    allServiceCodes: 'Alle tjenester',
    filterServiceCodes: 'Filtrer tjenester',
    selectedVasCodes: '{{count}} vas',
    selectedVasCodes_other: '{{count}} vases',
    allVasCodes: 'Alle VAS-er',
    filterVasCodes: 'Filtrer VAS-er',
    selectedDestinations: '{{count}} destinasjon',
    selectedDestinations_other: '{{count}} destinasjoner',
    filterSelfBillingUnitIds: 'Filtrer selvfaktureringsenhets-id',
    allSelfBillingUnitIds: 'Alle selvfaktureringsenhets-id',
    selectedSelfBillingUnitIds: '{{count}} selvfaktureringsenhets-id',
    selectedSelfBillingUnitIds_other: '{{count}} selvfaktureringsenhets-id'
  },
  button: {
    actions: 'Handlinger',
    edit: 'Rediger',
    back: 'Tilbake',
    cancel: 'Avbryt',
    done: 'Ferdig',
    clear: 'Tøm',
    close: 'Lukk',
    save: 'Lagre',
    saveAndPublish: 'Lagre og publiser',
    delete: 'Slett',
    export: 'Eksport',
    new: 'Lag ny',
    search: 'Søk',
    add: 'Legg til',
    remove: 'Fjern',
    assign: 'Tildel',
    fullEdit: 'Full redigering',
    continue: 'Fortsett',
    copy: 'Kopier',
    continueAndSave: 'Fortsett og lagre',
    confirm: 'Bekreft',
    clearAll: 'Tøm alle',
    selectAll: 'Velg alle',
    triggerRollout: 'Utløs utrulling',
    triggerRolloutAgain: 'Rull ut igjen'
  },
  modals: {
    preplan: {
      create: 'Preplan sending',
      change: 'Bytt preplanned sjåfør',
      shipmentInfo: 'Preplan sending {{shipmentId}} ({{pickupName}} til {{deliveryName}})',
      pickDriver: 'Velg en sjåfør..',
      unpreplan: 'Unpreplan',
      preplan: 'Planlegg',
      error: 'Kunne ikke preplan sending',
      notification: {
        preplanned: 'Planlagt',
        unpreplanned: 'Planlegging fjernet',
        preplannedMessage: 'Sendingen var preplanned til {{courierId}}',
        unpreplannedMessage: 'Sendingen var unpreplanned'
      }
    },
    maps: {
      save: 'Lagre',
      cancel: 'Avbryt',
      delete: 'Slett',
      editMode: 'Rediger',
      mapArea: '{{routeName}} kartområde',
      saved: 'Lagret',
      deleted: 'Slettet'
    }
  },
  consignment: {
    packageType: 'Kollitype',
    palletFootprints: 'Pallplass',
    loadingMeters: 'Lastmeter',
    includePreAdvice: 'Preavisering',
    onlyFailedPreAdvice: 'Preavisering feilet',
    onlyReturnPreAdvice: 'Retur till avsender',
    search: 'Søk etter leveranser',
    noShipmentsFound: 'Fant ingen leveranser',
    clickButtonToSearch: 'Klikk på Søk-knappen for å søke',
    consignmentsForDate: 'Leveranser for {{date}}',
    showOnlyEditable: 'Kun redigerbare',
    showOnlyNotAssigned: 'Ikke tildelt',
    withoutDate: 'Uten dato',
    extendedSearch: 'Utvidet søk',
    showDeleted: 'Vis slettede',
    showDeviated: 'Vis avvik',
    deletedBy: 'Sletted av',
    deletionReason: 'Årsak',
    numberOfConsignments: 'Fant {{number}} leveranser',
    showAll: 'Alle',
    edit: 'Endre',
    deleteOrders: 'Slett',
    copyOrder: 'Kopier',
    duplicateOrder: 'Duplisere',
    duplicateConfirmation: 'Er du sikker på at du vil duplisere denne ordren?',
    orderDuplicated: 'Ordren er duplisert',
    orderDuplicatedFailed: 'Kunne ikke duplisere ordren',
    editOrder: 'Rediger',
    cantDeleteOfferedOrders: 'Du kan bare slette kommende ordre som ikke er lagt til en rute ennå',
    cantEditOfferedOrders: 'Du kan bare redigere kommende ordre som ikke er lagt til en rute ennå',
    onlyCopyOne: 'Du kan bare kopiere én ordre om gangen',
    onlyEditOne: 'Du kan bare redigere én ordre om gangen',
    deletedOrderNotCopyable: 'Den slettede ordren kan ikke kopieres grunnet manglende ordredetaljer i Glow',
    restoreOrder: 'Gjenopprett',
    deletedOrderNotRestorable: 'Den slettede ordren kan ikke gjenopprettes grunnet manglende ordredetaljer i Glow',
    preplan: 'Preplan',
    deleteConfirmation: 'Er du sikker på at du vil slette denne sendingen ?',
    deleteMultipleConfirmation: 'Er du sikker på at du vil slette valgte sendinger?',
    copyConfirmation: 'Er du sikker på at du vil kopiere denne sendingen ?',
    earliestPickupTime: 'Tidligste hentetidspunkt',
    latestPickupTime: 'Seneste hentetidspunkt',
    editConsignment: ' Rediger leveringsinformasjon',
    changeDateAndTime: 'Sett dato og tider',
    searchShipments: 'Søk i leveranser:',
    searchCustomers: 'Søk i kunder:',
    excelExportRemoved:
      'Det vil ikke lenger være mulig å eksportere til Excel fra denne siden. Bruk <0>Import / Export</0>-siden eller <0>SAGA</0> i stedet. Dette er en del av en større oppdatering der flere funksjoner vil bli fjernet over tid før siden til slutt legges ned. Alt arbeid skal gjøres på <1>denne siden</1>.',
    filterBy: 'Filtrer på:',
    limitedShipmentsShownMessage: 'Viser maksimalt {{count}} ordre, vurder å begrense ditt søk',
    limitedUnresolvedAddressesShownMessage: 'Viser maksimalt {{count}} ufullstendige adresser',
    bulkActions: 'Endre sendinger',
    bulkActionsMultiple: 'Endre sendinger ({{count}})',
    addToRecurringGroup: 'Legg til i recurring group',
    moveShipmentsToDifferentDepartment: 'Flytt til en annen avdeling',
    addEvents: 'Legg til hendelse',
    disabledEditDeleteHelperText:
      'Denne ordren kan ikke redigeres eller slettes, vennligst kontakt ditt lokale Bringkontor for å gjøre endringer på ordren.',
    editPickupConsignment: 'Oppdater henteinformasjon',
    editDeliveryConsignment: 'Oppdater leveringsinformasjon',
    editPickupAndDeliveryTime: 'Oppdater henting og leveringstid',
    editConsignmentLocation: ' Lokasjon',
    editConsignmentTime: ' Tid',
    editConsignmentName: ' Navn',
    editConsignmentPhone: ' Telefonnummer',
    editConsignmentInstructions: ' Instruksjoner',
    earliestDeliveryTime: 'Tidligste leveringstid',
    latestDeliveryTime: 'Seneste leveringstid',
    enterPickupInstructions: 'Angi henteinstruksjoner',
    enterDeliveryInstructions: 'Angi leveringsinstruksjoner',
    enterDeliveryName: 'Angi navn for levering',
    enterPickupName: 'Angi navn for henting',
    enterPickupPhone: 'Angi telefonnummer for henting',
    enterDeliveryPhone: 'Angi telefonnummer for Levering',
    specificationSize: 'Størrelse',
    enterSpecificationSize: 'Legg inn størrelse',
    editSpecificationSize: 'Rediger størrelse',
    enterSpecificationDescription: 'Legg inn detaljer',
    editSpecificationDescription: 'Rediger detaljer',
    editPickupInfoDescription: 'For å kunne redigere må du velge minst ett av valgene',
    updateLocationFor: 'Oppdater informasjon om {{count}} leveranser',
    updateLocationFor_other: 'Oppdater henteinformasjon for {{count}} leveranser',
    comment: 'Kommentar',
    filter: 'Filtrer leveranser',
    state: 'Status',
    show: 'Vis',
    delivery: 'Leveres',
    pickup: 'Hentes',
    pickups: '{{count}} opphenting',
    pickups_other: '{{count}} opphentinger',
    estimatedDelivery: 'Estimert levering',
    requestedTimePickup: 'Forventet hentet',
    requestedTimeDelivery: 'Forventet levering',
    customerReference: 'Kundereferanse',
    timeNotSet: 'Ikke satt',
    shipmentId: 'Sendingsnummer',
    packageId: 'Kollinummer',
    noCourier: 'Ingen sjåfør',
    noSlot: 'Ingen slot',
    showEvents: 'Vis hendelser →',
    hideEvents: 'Skjul hendelser ←',
    events: 'Hendelser',
    send: 'Send',
    sendMessage: 'Send melding',
    sendCommentFailed: 'Lagring av kommentar feilet',
    recipient: 'Mottaker',
    unresolved: 'Ufullstendige leveranser',
    description: 'Detaljer',
    pickupAddress: 'Henteadresse',
    numberOfPackages: 'Kolli',
    registeredPickupAddress: 'Registrert henteadresse',
    pickupZipCode: 'Postnummer',
    pickupZipArea: 'Område',
    deliveryAddress: 'Leveringsaddresse',
    deliveryZipCode: 'Postnummer',
    deliveryZipArea: 'Område',
    deliveryLocation: 'Lokasjon',
    registeredDeliveryAddress: 'Registrert leveringsadresse',
    updated: 'Forsendelsen ble oppdatert',
    moved: 'Sendingen har blitt flyttet',
    unresolvedMessage:
      'Det finnes {{count}} forsendelse der vi ikke finner posisjon i kartet. Vennligst oppdater disse..',
    unresolvedMessage_other:
      'Det finnes {{count}} forsendelser der vi ikke finner adressen. Vennligst legg inn adressene.',
    foundUnresolvedMessage:
      'Vi har funnet følgende gyldige adresser for forsendelsen, om de er korrekte trykk lagre. Eventuelt søk opp korrekt adresse i kartet nedenfor.',
    remove: 'Fjern',
    optimizingNewSlot: 'Optimaliserer levering til endret slot',
    slotSelect: 'Velg slot',
    pickupInstructions: 'Henteinstrukser',
    deliveryInstructions: 'Leveringsinstrukser',
    specificationDescription: 'Beskrivelse',
    tracking: 'Sporingslenke',
    recipientPhone: 'Mottakers telefonnummer',
    customerRef: 'Kundereferanse',
    service: 'Tjeneste',
    message: {
      CREATED: 'Opprettet',
      ASSIGNED: 'Tildelt rute',
      UNASSIGNED: 'Ikke tildelt slot',
      COLLECTED: 'Plukket opp',
      DELIVERED: 'Levert',
      DEVIATED: 'Avvik',
      COMMENT: 'Kommentar',
      RESOLVED: 'Løst',
      UNRESOLVED: 'Uløst',
      OFFERED: 'Tilbudt',
      REJECTED: 'Avvist',
      ACCEPTED: 'Akseptert',
      RETURNED: 'Returnert',
      DELETED: 'Slettet',
      UNCONFIRMED: 'Ubekreftet',
      REFUSED: 'Avvist'
    },
    adjustTabTitle: 'Redigere',
    bookingPanelTitle: 'Booking',
    mapPanelTitle: 'Kart',
    recipientName: 'Mottakers navn',
    receivedBy: 'Mottatt av:',
    manuallyChangeLocations: 'Manuelt endre lokasjoner',
    manualOverrideDeviationTimeConfirm: 'Bekreft manuell avvikelse for valgt sending',
    manualOverrideDeliveryTimeConfirm: 'Bekreft manuell levering for valgt sending',
    onManuallyChangeLocationsConfirm: 'Er du sikker på at du vil gjøre sendingen uløst?',
    unresolveDeliveryAddress: 'Gjør leveringsadresse ufullstendig',
    unresolvePickupAddress: 'Gjør opphentingsadresse ufullstendig',
    unresolveAddress: 'Gjør adresse ufullstendig',
    reference: 'Referanse',
    shipmentIdNumber: 'Nr',
    shipmentDetails: 'Leveransedetaljer',
    customer: 'Kunde',
    subcustomer: 'Kundenummer',
    dateAndTime: 'Dato og tid',
    filterCustomer: 'Filtrer kunde',
    searchShipmentDateError: 'Angi datoperiode under 120 dager.',
    searchPhraseLength: 'Søkeord bør være minst {{minLength}} tegn for utvidet søk.',
    moveOrder: 'Flytt leveranse',
    moveOrderTitle: 'Flytt leveransen til en annen avdeling',
    moveOrderDefault: 'Velg avdeling',
    label: 'Etikett',
    createLabel: 'Lag etikett',
    createDeliveryLabel: 'Opprett leveringsetikett',
    createLabelShipment: 'Lag etikett (Sending)',
    createMultipleLabel: 'Lag etikett ({{count}})',
    viewLabel: 'Se etikett',
    viewLabels: 'Se etiketter',
    generateLabelError: 'Feil: {{error}}',
    generateLabelErrorTitle: 'Noe gikk galt',
    generateLabelErrorDescription: 'Beklager, kan ikke generere etiketter nå',
    generateLabelErrorButton: 'Vis feilkode',
    generatingLabels: 'Etikett PDF URL-er vil snart komme til syne under',
    labelsGeneratedSuccessfully: 'Etikettene ble generert',
    vas: 'Tillegstjenester (VAS)',
    price: 'Pris',
    orderSources: {
      expressit: 'ExpressIT',
      glow: 'GLOW',
      glow_customerBooking: 'GLOW kundebooking',
      glow_excelImportV2: 'GLOW Excel',
      excel: 'GLOW Excel',
      HappyFlow: 'Happy Flow',
      '98466118503': 'Mybring',
      '98466118504': 'Mybring',
      glow_recurring: 'Gjentagende',
      ShipmentAPI: 'Shipment API',
      others: 'EDI'
    },
    pickupDeviation: 'Avvik ved opphenting',
    deliveryDeviation: 'Avvik ved levering',
    shipmentSyncStatus: { no: 'Nei', yes: 'Ja', partial: 'Delvis' },
    selectOtherActions: 'Velg andre handlinger'
  },
  jobs: {
    job: 'Jobb',
    lastStarted: 'Sist startet',
    lastFinished: 'Sist fullført',
    maxDuration: 'Maks varighet',
    timeBetweenRuns: 'Tid mellom kjøringer',
    disable: 'Deaktiver',
    enable: 'Aktiver',
    disabled: 'Deaktivert',
    disabledInConfig: 'Deaktivert i konfigurasjon',
    mustBeASuperAdmin: 'Du må være superadministrator for å deaktivere og aktivere jobber',
    showOnlyStruggling: 'Vis bare jobber med problemer',
    runningLongerThanExpected: 'Kjører lenger enn forventet',
    notStartedForLongerThanExpected: 'Har ikke startet som forventet'
  },
  numberSeries: {
    numberSeries: 'Nummerserier',
    comparisonError: 'Maksimum må være større enn minimum',
    successfullyAdded: 'Nummerserien ble lagt til i listen',
    successfullyDeleted: 'Nummerserien ble slettet',
    addNewNumberSeries: 'Legg til ny nummerserie',
    addedNumberSeries: 'Nummerserier som er lagt til',
    addedNumberSeriesSubHeading: 'Legg til nummerserie (ikke inkluder kontrollsifre)',
    selectType: 'Velg type',
    shipmentNumber: 'GSIN (sendingsnummer)',
    packageNumber: 'SSCC (kollinummer)',
    minimum: 'Minimum',
    maximum: 'Maksimum',
    addNumberSeriesButton: 'Legg til nummerserie i listen',
    type: 'Type',
    currentNumber: 'Gjeldende nummer',
    maxNumber: 'Maksnummer',
    numbersLeft: 'Numre igjen',
    validMinimumValue: 'Du må angi en gyldig minimumsverdi',
    validMaximumValue: 'Du må angi en gyldig maksimumsverdi',
    deleteModalTitle: 'Slett nummerserie',
    deleteModalDescription: 'Denne handlingen kan ikke angres'
  },
  preadvice: {
    searchPlaceholder: 'Skriv minst 3 tegn for å filtrere',
    selectedCustomers: 'Valgte kunder ({{count}})',
    noSelectedCustomers: 'Ingen valgte kunder',
    customerSearch: 'Søkefelt - Skriv minst 3 tegn for å søke etter kunder',
    settingTargetDepartment:
      'Denne aviseringsinnstillingen gjelder bestemte avdelinger. Fjern alle valgte avdelinger for å kunne bytte til avdelingsgrupper',
    settingTargetDepartmentGroups:
      'Denne aviseringsinnstillingen gjelder bestemte avdelingsgrupper. Fjern alle valgte avdelingsgrupper for å kunne bytte til avdelinger',
    settingTargetCustomers:
      'Denne preaviseringen retter seg mot en spesifikk kunde. Fjern alle valgte kunder for å kunne bytte innstilling til kundgrupper',
    settingTargetCustomerGroups:
      'Denne aviseringsinnstillingen gjelder bestemte kundegrupper. Fjern alle valgte kundegrupper for å kunne bytte til kunder',
    conflictHeading: 'Det er noen konflikter i aviseringsreglene dine',
    conflictingRules: 'Regler i konflikt',
    deletePreadviceDescription:
      'Sletting fjerner alle varslingsinnstillinger, og mottaker eller avsender vil ikke lenger få noen kommunikasjon. Denne handlingen kan ikke angres.',
    nameDescription: 'Navn og beskrivelse',
    createNewPreadvice: 'Opprett ny preaviseringsregel',
    bizArea: 'Velg forretningsområde',
    courierAndExpress: 'Courier and Express (C&E)',
    homeDelivery: 'Hjemlevering (HD)',
    filterDepartmentAndGroups: 'Filtrer på avdelinger eller avdelingsgrupper',
    filterCustomersAndGroups: 'Filtrer på kunder eller kundgrupper',
    tabsWithErrors: 'Rett opp feil i følgende faner: {{tabs}}',
    preadvice: 'Avisering',
    hdDepartments: 'HD-avdelinger',
    ceDepartments: 'Budavdelinger',
    departmentGroups: 'Avdelingsgrupper',
    customers: 'Kunder',
    customerGroups: 'Kundegrupper',
    customersCount: 'Antall kunder',
    customerGroupsCount: 'Antall kundegrupper',
    showGroupMembers: 'Vis gruppemedlemmer',
    departmentsCount: 'Antall avdelinger',
    departmentGroupsCount: 'Antall avdelingsgrupper',
    lockNotification: 'Lås avisering',
    preadviceRule: 'Aviseringsregel',
    locked: 'Avisering låst',
    nameOfRule: 'Navn på regel',
    updated: 'Avisering oppdatert',
    rule: 'Regel',
    ruleTrigger: 'Preadvice på',
    type: 'Type',
    trigger: 'Trigger',
    action: 'Variant',
    result: {
      NO_RULE: 'Ingen regel matchet',
      NO_DELIVERY_TIME_WINDOW: 'Fant ingen tidsvinduer',
      SMS_SENT: 'Preadvice-regel sjekket. SMS lagt i kø',
      EMAIL_SENT: 'Preadvice-regel sjekket. Epost lagt i kø',
      SMS_AND_EMAIL_SENT: 'Preadvice-regel sjekket. SMS og Epost lagt i kø',
      NO_VALID_PHONE_OR_EMAIL: 'Verken gyldig telefonnummer eller epostadresse',
      FEATURE_OFF: 'Preadvice er skrudd av',
      ALREADY_PRE_ADVICED: 'Leveringstid allerede satt. Ingen handling utført',
      CANCELLED: 'Preadvice avbrutt',
      WAITING_FOR_PACKAGES: 'Venter på pakker',
      ALREADY_IN_PROGRESS: 'Venter på at mottaker skal booke tid',
      ERROR: 'Det skjedde en feil',
      WRONG_TRIGGER: 'Trigger matcher ikke regel. Ignorerer',
      MANUAL_ATTEMPT: 'Preadvice-forsøk inkrementert manuelt',
      PRE_ADVICE_LIMIT_REACHED: 'Grense for antall preadvice nådd',
      PRE_ADVICE_LOCKED: 'Preadvice er låst',
      ORDER_DELIVERED: 'Ordren er allerede levert',
      RETURN_LAST_LEG_CREATION_SKIPPED: 'Returben ble ikke opprettet'
    },
    error: {
      PRE_ADVICE_RULE_COLLISIONS: {
        label: 'Regelkonflikt!',
        detail:
          'Regel for {{service}} vil overstyre regelsett {{policySetNames}} gjennom knytning der til {{relations}}.',
        department: 'avdeling',
        department_group: 'avdelingsgruppe',
        customer: 'kunde',
        customer_group: 'kundegruppe'
      }
    },
    noPoliciesFound: 'Ingen aviseringsinnstillinger',
    policies: 'Aviseringsinnstillinger',
    copyText: 'Kopier tekst',
    customerInGroupTitle: 'Kunder i {{groupName}}',
    policy: {
      servicePoliciesDescription: 'Avhengig av hvilken type varsling du velger, vil ulike inndatafelt vises',
      exception: 'Unntak',
      deleteConfirm: 'Er du sikker på at du vil slette dette regelsettet?',
      name: 'Navn',
      new: 'Ny aviseringsinnstilling',
      edit: 'Endre aviseringsinnstilling',
      description: 'Beskrivelse',
      save: 'Lagre',
      saveAnyway: 'Lagre likevel',
      servicePolicies: 'Aviseringsregler',
      targets: 'Kunde-/avdelingsinnstillinger',
      servicePolicy: {
        edit: 'Endre innstillinger',
        new: 'Legg til aviseringsinnstillinger for tjeneste',
        cutOff: 'Cutoff',
        remove: 'Fjern valgte',
        serviceCode: 'Tjeneste',
        serviceCodeLegend: 'Legg til tjenestekode, f.eks 3123',
        vasCode: 'VAS',
        vasCodeLegend: 'Legg til tilleggstjeneste f.eks SWAP',
        sameDay: 'Samme dag',
        returnToCustomer: 'Retur til kunde',
        reminderToCustomer: 'Påminnelse til kunde',
        redirectToPuP: 'Omdiriger til hentested',
        sameDayTitle: 'Tillat bestillinger samme dag før cutoff',
        yesRecipientShouldChange: 'Ja, mottaker skal kunne endre',
        noRecipientShouldNotChange: 'Nei, mottaker skal ikke kunne endre',
        recipientCanCancelBookedTimeSlot: 'Mottaker vil kunne kansellere det bookede tidsvinduet.',
        sameDayLegend: 'Huk av av hvis du vil at tjenesten skal utføres som Same Day Service',
        triggerEvent: 'Avisering på',
        triggerEventTitle: 'Trigger for avisering',
        triggerEventLegend:
          'Hva som skal forsårsåke at preavisering sendes. At vi mottar EDI til Glow, når sendingen ankommer HUB eller kommer til DIP, eller hvis den ikke skal trigges velger du MANUAL',
        cutoff: 'Cutoff',
        cutoffLegend:
          'Cutoff-tidspunkt. Etter dette tidspunktet tilbys ikke lenger første ledige tidsvindu til mottaker, men dagen etter.',
        relativeCutoffMinutes: 'Cutoffminutter',
        relativeCutoffMinutesLegend:
          'Minimum antall minutter fra aviseringstidspunktet til det neste tilgjengelige tidsvinduet. Overstyrer cutofftid.',
        calendarDays: 'Kalenderdager',
        goodsRedirectToPickupPoint: 'Varene blir omdirigert til hentested etter 1 leveringsforsøk',
        dateAndTimeChangeBookingPageTitle: 'Endring av dato og tid på bookingsiden.',
        calenderDaysTitle: 'Angi antall dager som skal vises til mottaker på bookingsiden',
        calendarDaysLegend: 'Hvor mange dager skal vises til mottaker i kalenderen.',
        noServicePoliciesFound: 'Ingen innstillinger lagt til ennå',
        returnToSenderAfterDays: 'Retur til avsender',
        returnToSenderAfterDaysLegend:
          'Etter hvor mange dager skal sendingen returneres til avsender i tilfelle vi ikke har oppnådd kontakt med mottaker.',
        scheme: 'Type',
        schemeLegend: 'Type preavisering som skal sendes; Push, Pull, Return eller Pick up parcel.',
        searchCustomer: 'Søk kunde',
        remindAfterHours: 'Påminnelse til mottaker',
        remindAfterHoursLegend:
          'Relevant for Push og Pull: etter hvor mange timer skal det sendes påminnelse til mottaker om å avtale leveringstid.',
        preAdviceAttempts: 'Aviseringsforsøk',
        preAdviceAttemptsLegend: 'Hvor mange påminnelser som skal sendes før sendingen returneres.',
        reminderToSenderAfterHours: 'Påminnelse til avsender',
        reminderToSenderAfterHoursLegend:
          'Etter hvor mange timer skal det sendes påminnelse til avsender om at det ikke er er avtalt levering.',
        deliveryAttempts: 'Leveringsforsøk',
        deliveryAttemptsTitle: 'Når maksimalt antall leveringsforsøk er nådd, returneres pakken til kunden',
        deliveryAttemptsChoiceTitle: 'Hva skal skje når maksimalt antall leveringsforsøk er nådd',
        deliveryAttemptsLegend: 'Hvor mange leveringsforsøk før sendingen returneres til avsender.',
        pickupAttempts: 'Henteforsøk',
        pickupAttemptsTitle: 'Maksimalt antall henteforsøk',
        pickupAttemptsDescription:
          'Når antall henteforsøk er nådd, informerer vi kunden om at det ikke er noe å returnere på grunn av avvik ved opphenting',
        label: { days: 'Dager', hours: 'Timer', smss: 'stk' },
        legend: { days: 'Dager', hours: 'Timer', smss: 'Maks antall SMS' },
        returnToPup: 'Retur til pickup point',
        addNewRule: 'Legg til ny regel',
        enableCancelBookingTimes: 'Tillat kansellering på bookingsiden',
        typeOfOrders: 'Type ordre',
        ordersWithDate: 'Ordre med dato',
        ordersWithoutDate: 'Ordre uten dato',
        ordersWithAndWithoutDate: 'Ordre med og uten dato',
        emailToCustomer: 'E-post til kunde',
        triggerEventType: {
          EDI: 'EDI',
          HUB: 'HUB',
          DIP: 'DIP',
          MANUAL: 'MANUAL'
        }
      }
    },
    tooltip: 'Låse ordren = ingen avisering sendes til mottaker',
    customerCode: 'Kundekode'
  },
  holidays: {
    holidays: 'Helligdager',
    holiday: 'Helligdag',
    dayBeforeHoliday: 'Dag før helligdag',
    addHoliday: 'Legg til ny helligdag',
    country: 'Land',
    type: 'Type',
    date: 'Dato',
    successfullyAdded: 'Helligdagen er lagt til i listen',
    successfullyDeleted: 'Helligdagen er slettet',
    filterOnCountry: 'Filtrer på land',
    selectHolidayType: 'Velg type helligdag',
    addHolidayToList: 'Legg til helligdag i listen',
    selectCountry: 'Velg land',
    addedHolidays: 'Helligdager som er lagt til',
    deleteModalTitle: 'Slett helligdag',
    deleteModalDescription: 'Denne handlingen kan ikke angres'
  },
  distributionMapping: {
    title: 'Distribusjonskobling',
    addDips: 'Legg til DIP',
    addedDips: 'Lagt til DIP-lokasjon ({{count}})',
    addedDips_other: 'Lagt til DIP-lokasjoner ({{count}})',
    connectedToPickupPoints: 'Koblet til {{count}} utleveringssted',
    connectedToPickupPoints_other: 'Koblet til {{count}} utleveringssteder',
    emptyTitle: 'Ingen tilkoblede distribusjonspunkt (DIP)',
    emptyDescription:
      'Du må først velge en DIP for å kunne legge til utleveringssteder.\nKlikk på knappen øverst til høyre for å komme i gang.',
    addDipModalTitle: 'Legg til distribusjonskobling',
    addDipModalDescription: 'Velg DIP-en du vil legge til utleveringssteder på',
    selectDipLabel: 'Søk etter distribusjonspunkt (DIP)',
    searchPlaceholder: 'PUP ID, navn eller adresse',
    selectButton: 'Velg',
    editDip: 'Endre {{name}}',
    selectPickupPointHeading: 'Velg utleveringsstedet du vil legge til DIP-en',
    selectPickupPointLabel: 'Søk etter utleveringssted (PUP)',
    addedPickupPoints: 'Utleveringssteder lagt til DIP-en',
    removePickupPoint: 'Fjern {{name}}',
    editPickupPoint: 'Endre {{name}}',
    editPickupPointDescription: 'Velg dagene PUP-en kan få leveringer',
    deliveryDays: 'Leveringsdager',
    deliveryDaysHint: 'Velg dagene utleveringsstedene kan få leveringer',
    addPickupPoint: 'Legg til utleveringssted',
    saveToast: 'Distribusjonskobling for {{name}} er lagret',
    addLocations: 'Legg til lokasjoner',
    removeDip: 'Fjern {{name}}',
    removeDipQuestion: 'Fjerne {{name}} fra distribusjonskoblingen?',
    removeDipDescription: 'Tilkoblede utleveringssteder mister DIP-en sin.',
    removeConnectionQuestion: 'Fjerne koblingen til {{name}}?',
    removeConnectionDescription: 'Utleveringsstedet vil være uten DIP til det kobles på nytt.',
    alreadyAdded:
      'Dette utleveringsstedet ligger allerede på denne DIP-en. Å legge det til igjen erstatter leveringsdagene.',
    alreadyMappedToOtherDip:
      'Dette utleveringsstedet er allerede koblet til {{dip}}. Fjern det fra den DIP-en før du legger det til her.',
    loadFailed: 'Klarte ikke å hente DIP-koblingene. Prøv igjen, eller last siden på nytt.',
    errorSelectPickupPoint: 'Du må velge et utleveringssted',
    errorSelectDeliveryDay: 'Du må velge minst én leveringsdag',
    errorSelectDip: 'Du må velge en DIP',
    deleteToast: '{{name}} ble slettet'
  },
  department: {
    region: 'Region',
    general: 'Generelt',
    plannedStopLocations: 'Planlagte stopplokasjoner',
    plannedStopLocationsDescription:
      'Her kan du legge til alle planlagte stopplokasjoner for optimalisering av ruteplanlegging.',
    plannedStopLocationName: 'Navn på planlagt stopplokasjon',
    plannedStopLocationIsTerminal: 'Regnes som terminaladresse for denne avdelingen',
    plannedStopLocationIsTerminalTooltip:
      'Kun relevant for avdelinger med mer enn én terminaladresse. Adressen brukes da i tillegg til avdelingens standardadresse.',
    addPlannedStopLocation: 'Legg til planlagt stopplokasjon',
    searchDepartmentByNameOrId: 'Filtrer på avdelingsnavn eller avdelings-ID',
    searchDepartmentGroups: 'Søk etter gruppenavn eller beskrivelse',
    createNewDepartment: 'Opprett ny avdeling',
    addressAndContact: 'Adresse og kontaktinformasjon',
    searchAddressError: 'Manglende verdier for adresse. Du må bruke søkefeltet for å få riktig adresse.',
    addressContactIngress:
      'For å få riktig adresse, bruk søkefeltet. Adresse, postnummer og by vil automatisk bli fylt ut.',
    settingsInGlow: 'Innstillinger på mottakerens sporingsside',
    settingsBodyText: 'Avhengig av ditt valg vil forskjellig innhold og kommunikasjon bli vist/send til mottakerne.',
    tooltipNPSID:
      'NPS-ID = Glow kan sende ut NPS-målinger av mottakertilfredshet. Her fylles den unike identifikatoren for hver avdeling inn',
    tooltipTerminal: 'Fylles ut dersom navn på hentested og avdelingsnavn er forskjellige',
    removeRow: 'Fjern rad',
    cutoff: 'Cutoff',
    regular: 'Ordinær',
    sameDay: 'Samme dag',
    weekdays: 'Hverdager',
    saturdays: 'Lørdager',
    sundays: 'Søndager',
    setTimeWindow: 'Angi tidsvindu',
    setTimeWindowToDepartment: 'Angi tidsvindu for avdeling',
    updateTimeWindow: 'Oppdater tidsvindu',
    timeWindowTitle: 'Logikk for levering per dag',
    timeWindowIngress:
      'Hvilke dager skal denne avdelingen levere? Fyll inn enten alle verdiene eller ingen av verdiene for hver dag.',
    emailAddress: 'E-postadresse',
    npsId: 'NPS-ID',
    defaultAlystraUnitId: 'Selfbilling unit ID',
    timeWindow: 'Tidsvindu',
    pickupEarliest: 'Tidligste opphenting',
    pickupLatest: 'Seneste opphenting',
    deliveryEarliest: 'Tidligste levering',
    deliveryLatest: 'Seneste levering',
    routePlanning: 'Ruteplanlegging',
    autoRouteCreationTime: 'Automatisk ruteoppretting',
    autoRouteOptimizationTime: 'Automatisk ruteoptimalisering',
    clearTime: 'Fjern tiden',
    delegatedDepartment: 'Delegert avdeling',
    manageDepartment: 'Administrer avdeling',
    listAllDepartments: 'Vis alle avdelinger',
    listAllGroups: 'Liste alle avdelingsgrupper',
    successUpdate: '{{name}} ble oppdatert',
    editDepartment: 'Rediger {{name}}',
    departmentTitle: 'Avdeling',
    departmentsLabel: 'avdelinger',
    labels: 'Etiketter',
    labelsDescription:
      'Opprett etiketter for å bygge filtreringsregler for denne avdelingen. Etiketter innen samme kategori matches med <bold>OR</bold>-logikk, mens ulike kategorier kombineres med <bold>AND</bold>-logikk. Husk å tildele etikettene til rutene dine for at filtreringen skal tre i kraft.\n' +
      '\n' +
      'Hvis det er opprettet etiketter for en avdeling, blir brukerne bedt om å velge hvilke etiketter de vil vise første gang de åpner siden <bold>Ruteoversikt</bold>. De kan når som helst endre valget sitt ved å bruke det vanlige filterpanelet på siden <bold>Ruteoversikt</bold>. Valget lagres i nettleseren. Les mer her (eller i “Hva er dette”-modalen): <supportLink>Labels (Only for Parcel Norway departments) – GLOW Support</supportLink>',
    labelsCategory: 'Kategori',
    labelsCategoryHint: 'Bruk et eksisterende kategorinavn for å legge til flere etiketter i samme gruppe.',
    labelName: 'Etikettnavn',
    existingLabels: 'Eksisterende etiketter',
    labelsEmpty: 'Ingen etiketter er opprettet ennå.',
    labelsPreview: 'Forhåndsvisning',
    labelsPreviewEmpty: 'Velg etiketter for å se hvordan filterlogikken bygges opp.',
    labelsDuplicate: 'Denne etiketten finnes allerede i den valgte kategorien.',
    labelsNotAdded: 'Klikk Legg til for å legge til etiketten før du lagrer.',
    nameRequired: 'Navn er påkrevd',
    addressRequired: 'Adresse er påkrevd',
    zipCodeRequired: 'Postnummer er påkrevd',
    zipAreaRequired: 'Poststed er påkrevd',
    labelsCategoryRequired: 'Kategori er påkrevd',
    labelNameRequired: 'Etikettnavn er påkrevd',
    departmentTypeRequired: 'Avdelingstype er påkrevd',
    departmentIdRequired: 'Avdelings-ID er påkrevd',
    descriptionRequired: 'Beskrivelse er påkrevd',
    regionRequired: 'Region er påkrevd',
    minutesAfterOrderArrivalRequired: 'Minutter etter at ordren er mottatt er påkrevd',
    createLabels: 'Opprett etiketter',
    departmentWithCount: '{{count}} avdeling',
    departmentWithCount_other: '{{count}} avdelinger',
    departmentGroups: 'Avdelingsgrupper',
    numberOfDepartmentGroups: 'Avdelingsgrupper',
    numberOfDepartments: 'Antall avdelinger',
    search: 'Søk etter avdelinger',
    searchGroups: 'Søk etter avdelingsgrupper',
    noDepartmentsFound: 'Fant ingen avdelinger',
    noDepartmentGroupsFound: 'Fant ingen avdelingsgrupper',
    noDepartmentName: 'Navn mangler',
    noDepartmentId: 'Id mangler',
    noCouriers: 'Ingen sjåfører',
    courierCount_other: '{{count}} sjåfører',
    courierCount: '{{count}} sjåfør',
    noCourier: 'Ingen sjåfører',
    couriers: 'Antall sjøfører',
    plannerCount_other: '{{count}} planleggere',
    plannerCount: '{{count}} planlegger',
    noPlanner: 'Ingen planleggere',
    planners: 'Antall planleggere',
    choose: 'Velg avdeling',
    new: 'Ny avdeling',
    description: 'Beskrivelse',
    name: 'Navn',
    created: 'Avdeling opprettet',
    updated: 'Avdeling oppdatert',
    departmentType: 'Avdelingstype',
    notSet: 'Ikke valgt',
    courier: 'Bud',
    express: 'Ekspress',
    hd: 'Hjemlevering',
    h2: 'H2',
    parcel: 'Parcel',
    posten: 'Posten',
    other: 'Annet',
    all: 'Alle',
    deliveryDisplayType: 'Visning av leveringstid',
    terminalName: 'Terminalnavn',
    terminalNameTooltip: 'Fylles ut dersom avdelingsnavn ikke er det samme som navn på hentested',
    selectArea: 'Velg område...',
    address: 'Adresse',
    zipCode: 'Postnummer',
    zipArea: 'Poststed',
    orderBillingType: {
      title: 'Ordretype for fakturering',
      selectBillingType: 'Velg ordretype',
      apollo: 'Apollo',
      h2: 'H2',
      pickup: 'Opphenting',
      customerBillingNumber: 'Kundens faktureringsnummer',
      addMoreOrderBillingInfo: 'Legg til ny ordretype',
      internalTrade: 'Internhandel'
    },
    departmentId: 'Avdelings-ID',
    disableSms: 'Deaktiver sporings- og ETA-SMS på rute',
    smsShouldNotBeSent: 'Sporings- og ETA-SMS skal ikke sendes til mottakere på denne avdelingens ruter.',
    autoRecurrentTime: 'Automatisk gjentagende tid',
    autoInvoiceTitle: 'Automatisk fakturering',
    autoInvoiceEnable: 'Sett automatisk fakturering',
    autoInvoiceTime: 'Tidspunkt',
    autoInvoiceOffset: {
      legend: 'Hvilke ordre skal faktureres',
      oneDayEarlier: 'Levert 1 dag siden',
      twoDaysEarlier: 'Levert 2 dager siden',
      threeDaysEarlier: 'Levert 3 dager siden',
      fourDaysEarlier: 'Levert 4 dager siden',
      fiveDaysEarlier: 'Levert 5 dager siden'
    },
    autoDispatchSettings: {
      title: 'Automatisk tildeling av opphentingsordrer',
      enable: 'Sett automatisk tildeling av opphentingsordrer',
      minutesAfterOrderArrival: 'Minutter etter at ordren er mottatt',
      startTime: 'Starttidspunkt'
    },
    unitNumber: 'Enhetsnummer'
  },
  departmentGroup: {
    departmentGroupDeleted: '{{name}} ble slettet',
    selectedCountries: '{{count}} valgt land',
    selectedCountries_other: '{{count}} valgte land',
    countries: 'Land',
    allDepartmentTypes: 'Alle avdelingstyper',
    selectedDepartmentTypes: '{{count}} valgt avdelingstype',
    selectedDepartmentTypes_other: '{{count}} valgte avdelingstyper',
    departmentTypes: 'Avdelingstyper',
    youMustSelectDepartment: 'Du må velge avdeling',
    manageDepartments: 'Administrer avdelinger i gruppe',
    createDepartmentGroup: 'Opprett ny avdelingsgruppe',
    noSelectedDepartments: 'Ingen valgte avdelinger',
    selectedDepartments: 'Valgte avdelinger ({{count}})',
    selectAllFor: 'Velg alle for {{name}}',
    departmentGroup: 'Avdelingsgruppe',
    name: 'Navn',
    deleteConfirm: 'Er du sikker på at du vil slette avdelingsgruppen?',
    edit: 'Rediger avdelingsgruppe',
    type: 'Type',
    types: {
      DEFAULT: 'Standard',
      FOLLOW_UP: 'Oppfølging',
      INVOICING: 'Fakturering',
      PLANNING: 'Planlegging',
      PREADVICE: 'Avisering',
      REGION: 'Region',
      SEARCH: 'Søk'
    }
  },
  deliveryDisplayType: {
    instant: 'Instant',
    customized: 'Tilpasset'
  },
  templateRouteRules: {
    title: 'Administrer ruteregler',
    ruleName: 'Regelnavn',
    type: 'Type',
    POSTAL_CODE: 'Postnummer',
    searchPlaceholder: 'Søk etter navn eller type',
    createNew: 'Opprett ny regel',
    createNewRule: 'Opprett ny ruteregel',
    edit: 'Rediger',
    settings: 'Innstillinger',
    assignToTemplateRoutes: 'Malruter',
    connectedToRule: 'tilknyttet "{{name}}"',
    noTemplateRoutesInDepartment: 'Ingen malruter tilgjengelig i denne avdelingen',
    templateHasNoRoutes: 'Den valgte malen har ingen ruter',
    noRecurringRoutesInDepartment: 'Ingen gjentagende ruter tilgjengelig i denne avdelingen',
    template: 'Mal',
    selectTemplate: 'Velg mal',
    templateRoute: 'Malrute',
    selectTemplateRoutes: 'Velg malruter',
    assignedTemplateRoutes: 'Tilordnede malruter ({{count}})',
    noAssignedTemplateRoutes: 'Ingen malruter tilordnet ennå',
    assignToRecurringRoutes: 'Gjentagende ruter',
    recurringRoute: 'Gjentagende rute',
    selectRecurringRoutes: 'Velg gjentagende ruter',
    assignedRecurringRoutes: 'Tilordnede gjentagende ruter ({{count}})',
    noAssignedRecurringRoutes: 'Ingen gjentagende ruter tilordnet ennå',
    atLeastOneRule: 'Legg til minst én postnummerregel',
    successfullyAdded: '{{name}} ble lagt til',
    successfullyUpdated: '{{name}} ble oppdatert',
    successfullyDeleted: 'Ruteregel ble slettet',
    deleteRule: 'Slett ruteregel',
    deleteRuleDescription: 'Er du sikker på at du vil slette denne ruteregelen?',
    serviceExclusion: 'Tjenesteekskludering',
    serviceExclusionDescription: 'Ordre med en av disse tjenestekodene blir aldri tildelt ruter av denne regelen.',
    serviceCode: 'Tjenestekode',
    addServiceCode: 'Legg til tjenestekode',
    excludedServices: 'Ekskluderte tjenester',
    noExcludedServices: 'Ingen tjenester ekskludert',
    serviceCodeRequired: 'Skriv inn en tjenestekode',
    serviceCodeAlreadyExcluded: '{{code}} er allerede ekskludert',
    removeServiceCode: 'Fjern {{code}}'
  },
  menu: {
    distributionMapping: 'DIP-kobling',
    manageRouteRules: 'Administrer ruteregler',
    defaultDisabled: 'Velg en kunde for å aktivere dette menypunktet',
    home: 'Hjem',
    admin: 'Administrasjon',
    planner: 'Planlegger',
    volumeReport: 'Volumrapporter',
    openSearch: 'Åpne søk',
    report: 'Rapporter',
    customer: 'Kunde',
    apiOrder: 'Finn API-ordre',
    support: 'Support',
    priceMotor: 'Prismotor',
    departments: 'Avdelinger',
    users: 'Brukere',
    customers: 'Kunder',
    customerGroups: 'Kundegrupper',
    numberSeries: 'Nummerserier',
    jobsMonitoring: 'Jobbovervåking',
    holidays: 'Helligdager',
    shd: 'SHD',
    settings: 'Innstillinger',
    preadvice: 'Avisering',
    cms: 'CMS',
    userRoles: 'Brukerroller',
    integrations: 'Integrasjoner',
    live: 'Live',
    routePlanning: 'Ruteplanlegging',
    dispatching: 'Dispatching',
    booking: 'Booking',
    h2Booking: 'H2-booking',
    setCoordinates: 'Angi koordinater',
    pickupOrders: 'Opphentingsordre',
    billingOrder: 'Faktureringsordre',
    shipments: 'Leveranser',
    corrections: 'Korrigeringer',
    units: 'Enheter',
    couriers: 'Sjåfører',
    vehicles: 'Vehicles',
    importExport: 'Import / Eksport',
    addresses: 'Adresser',
    invoicing: 'Fakturering',
    manageReturns: 'Administrer returer',
    preAdviceFollowup: 'Administrer forhåndsvarsel',
    optimizing: 'Optimalisering',
    services: 'Tjenester',
    matrix: 'Matrise',
    vendors: 'Leverandører',
    backToOldShipmentsPage: 'Tilbake til den gamle siden.',
    mainNavigation: 'Hovedmenyen',
    closePanel: 'Lukk panelet',
    expandPanel: 'Utvid panel',
    goToHomepage: 'Gå til forsiden',
    productionTimeWindow: 'Produksjonstidsvindu',
    routesOverview: 'Ruteoversikt',
    recurring: 'Gjentagende'
  },
  eventsList: { timeWindow: 'Tidsvindu', from: 'Fra', to: 'Til' },
  status: {
    started: 'Startet',
    notStarted: 'Ikke startet'
  },
  consignmentEvent: {
    message: {
      'auto-dispatch-succeeded': 'Automatisk tildeling av oppdrag startet',
      'auto-dispatch-failed': 'Automatisk tildeling av oppdrag feilet',
      'optimizing-failed': 'Ruteoptimalisering feilet',
      'order-excluded-from-invoicing': 'Ekskludert fra fakturering',
      'reoptimized-with-fallback-window': 'Rute automatisk reoptimalisert',
      routeName: 'Rutenavn',
      resolved: 'Adressekoordinater satt',
      unresolved: 'Adressekoordinater er ikke satt',
      comment: 'Kommentar',
      created: 'Registrert',
      completed: 'Fullført',
      assigned: 'Tildelt',
      plannedOnRoute: 'Planlagt på rute',
      plannedOnRouteMoreInfo: 'Planlagt på rute {{routeName}} ({{unitName}})',
      nameOfUnit: 'Enhetens navn',
      optimizeProviderId: 'Optimerings-ID',
      noOptimizationEngine: 'Ingen optimeringsmotor',
      failedOptimizeProviderId: 'Feilet optimerings-ID',
      retryOptimizeProviderId: 'Optimerings-ID for nytt forsøk',
      optimizationTimeWindow: 'Tidsvindu for optimalisering',
      extendedBy: 'Utvidet med {{minutes}} min',
      optimizingFailedOtherNotPlanned: 'En annen sending på ruten kunne ikke planlegges',
      optimizingFailedError: 'Optimaliseringen stoppet med en feil',
      delivered: 'Levert',
      collected: 'Hentet',
      returned: 'Returnert',
      deviated: 'Avvik',
      damaged: 'Skadet',
      notification: 'Melding',
      slotChanged: 'Slot endret',
      unassigned: 'Ikke tildelt sjåfør',
      rejected: 'Avvist',
      image: 'Bilde',
      error: 'Feil',
      started: 'Startet',
      stopped: 'Stoppet',
      accepted: 'Akseptert',
      offered: 'Tilbudt',
      unitName: 'Enhet',
      driverName: 'Sjåfør',
      'delivery-id-check': 'ID-sjekk',
      'deviation-sms-sent': 'Avviks-SMS sendt',
      'delivered-manually-overridden': 'Levert manuelt overstyrt',
      'order-released-for-invoicing': 'Frigitt for fakturering',
      'order-paused-from-invoicing': 'Fakturering satt på pause',
      'manually-set-invoicing-ok-for-order-invoicing': 'Fakturert OK',
      'manually-set-not-invoiced-for-order-invoicing': 'Ikke fakturert',
      'manually-set-excluded-from-invoicing': 'Unntatt fra fakturering',
      'unit-manually-added-for-invoicing': 'Enhet lagt til manuelt',
      'deviated-manually-overridden': 'Avvik manuelt overstyrt',
      'collected-manually-overridden': 'Opphenting manuelt endret',
      'pickup-location-changed': 'Henteadresse endret',
      'delivery-time-estimated': 'Oppdatert leveringstid',
      'slot-manually-changed': 'Slot manuelt overstyrt',
      'pickup-time-changed': 'Opphentingstid endret',
      'manually-change-location': 'Manuell overstyring av lokasjoner',
      'pickup-consignment-data-changed': 'Henteinformasjon har blitt oppdatert',
      'delivery-consignment-data-changed': 'Leveringsinformasjon har blitt oppdatert',
      'specification-size-data-changed': 'Størrelse oppdatert',
      'specification-description-data-changed': 'Detaljer oppdatert',
      'delivery-time-purchased': 'Mersalg: Tilpasset tidsvindu bestilt av mottaker',
      'digital-identity-verified': 'Mottakerens identitet bekreftet digitalt',
      'digital-identity-verification-failed': 'Kunne ikke verifisere mottakerens identitet digitalt',
      'flex-delivery-ordered': 'Forenklet leveranse bestilt av mottaker',
      'flex-delivery-ordered-by-sender': 'Forenklet leveranse bestilt av avsender',
      'flex-delivery-changed': 'Forenklet leveranse endret',
      'flex-delivery-confirmation-sms-sent': 'Forenklet leveransebekreftelse SMS sendt',
      'flex-delivery-confirmation-app-notification': 'Pushvarsling for forenklet leveransebekreftelse sendt',
      'return-to-pickup-point-delivery-deviated': 'Vil overleveres på utleveringssted',
      recipientName: 'Mottakernavn',
      receivedBy: 'Mottatt av',
      'reject-order-correction': 'Avvist ordre-korreksjon',
      'accept-order-correction': 'Akseptert ordre-korreksjon',
      'handed-over-to-other-unit': 'Overlevert til annen enhet',
      'handed-over': 'Overlevert til annen enhet',
      deliveredWithoutSignature: 'Levert uten signatur',
      deliveredWithoutSignatureReason: {
        left_package_outside: 'Plassert som instruert',
        did_not_get_signature: 'Personlig',
        DELIVER_IN_PERSON: 'Personlig'
      },
      'returned-manually-overridden': 'Manuell endring av retur',
      'eta-sms-sent': 'ETA SMS sendt',
      calculatedEta: 'Beregnet ankomst: {{eta}}',
      etaSmsLabel: 'Beregnet ankomst',
      scanned: 'Ankommet terminal',
      'arrived-at-terminal': 'Ankommet distribusjonsterminal',
      'order-sorted': 'Sortert',
      'not-arrived-at-distributing-terminal': 'Ikke ankommet distribusjonsterminal',
      'pickup-eta-sms-sent': 'Pickup ETA SMS sendt',
      'handed-in-at-posten-terminal': 'Ankommet sorteringsterminal',
      'pickup-sms-sent': 'Sporings-SMS sendt',
      'pre-pickup-sms-sent': 'Sporings-SMS forhåndssendt',
      'pickup-address-unresolved': 'Opphentingadresse ble gjort ufullstendig',
      'delivery-address-unresolved': 'Leveringsadresse ble gjort ufullstendig',
      'in-transit': 'I transitt',
      'upcoming-pickup-sms-sent': 'Nærstående leveranse SMS sendt',
      'order-sorted-same-day': 'Dato satt til i dag via terminal app',
      'signature-sms-sent': 'Signatur-SMS sendt',
      'flex-delivery-cancelled': 'Forenklet leveranse avbestilt',
      'delivery-time-ordered': 'Leveringsdato endret av mottaker',
      'delivery-time-ordered-internal': 'Leveringsdato endret',
      'delivery-time-updated-from-hf-sync': 'Leveringstid synkronisert fra HF',
      'planned-delivery-date-ordered': 'Planlagt leveringsdato bestilt',
      'delay-sms-sent': 'SMS om forsinkelse sendt',
      'production-deviation': 'Produksjonsavvik',
      'manual-delay-sms-sent': 'Manuell forsinkelse SMS sendt',
      'route-planning-complete': 'Rute ferdig',
      'signature-delivered': 'Signatur fra mottaker',
      showPicture: 'Vis bilde',
      'external-address-wash': 'Leveringsinformasjon har blitt oppdatert',
      'order-note-changed': 'Notat endret',
      'customer-details-changed': 'Kundedetaljer endret',
      'order-data-changed': 'Ordre endret',
      'order-moved-to-department': 'Flyttet mellom avdelinger',
      'order-moved-to-department-with-data': 'Sendingen er flyttet fra',
      'package-measurements-changed': 'Pakkestørrelse endret',
      'package-data-changed': 'Kollidata endret',
      'driver-deviated-from-route': 'Sjåføren avvek fra ruta',
      'driver-deviated-from-route-at-pickup': 'Sjåføren avvek fra ruta ved henting',
      'delivered-outside-service-time-window': 'Levering eller avvik utenfor tjenesten sitt tidsvindu',
      'delivered-outside-estimated-time-window': 'Levering eller avvik utenfor det estimerte tidsvinduet',
      'delivered-in-estimated-time-window': 'Levering eller avvik innenfor det estimerte tidsvinduet',
      'picked-up-outside-service-time-window': 'Henting eller avvik utenfor tjenesten sitt tidsvindu',
      'picked-up-outside-estimated-time-window': 'Henting eller avvik utenfor det estimerte tidsvinduet',
      'picked-up-in-estimated-time-window': 'Henting eller avvik innenfor det estimerte tidsvinduet',
      'ordered-delivery-time-set-by-production-time-window': 'Produksjonstidsvindu er satt',
      'seen-by-recipient': 'Sporingsside sett av mottaker',
      'first-estimated-times-seen': 'Første estimerte tid sett av mottaker',
      'pre-advice-push-sms-sent': 'Preadvice PUSH-SMS sendt',
      'pre-advice-push-return-sms-sent': 'Preadvice PUSH-RETURN-SMS sendt',
      'pre-advice-pull-sms-sent': 'Preadvice PULL-SMS sendt',
      'pre-advice-pull-email-sent': 'Preadvice PULL-e-post sendt',
      'pre-advice-pull-reminder-sms-sent': 'Preadvice PULL påminnelses-SMS til mottaker sendt',
      'pre-advice-pull-reminder-email-sent': 'Preadvice PULL påminnelses-e-post til mottaker sendt',
      'pre-advice-pup-sms-sent': 'Preadvice PUP-SMS sendt',
      'pre-advice-return-sms-sent': 'Preadvice Return-SMS sendt',
      'pre-advice-return-email-sent': 'Preadvice Return-email sendt',
      'delivery-location-deviation': 'Levering eller avvik ikke på forventet sted',
      'pre-advice-pull-reminder-to-sender-email-sent': 'Preadvice PULL påminnelse til avsender sendt',
      'pre-advice-pup-reminder-to-sender-email-sent': 'Preadvice PUP påminnelse til avsender sendt',
      'pre-advice-return-return-to-sender-email-sent': 'Preadvice RETURN retur til avsender sendt',
      'pre-advice-pull-return-to-sender-email-sent': 'Preadvice PULL retur til avsender epost sendt',
      'pre-advice-push-return-email-sent': 'Preadvice PUSH retur til avsender epost sendt',
      'pre-advice-manual-attempt': 'Manuelt preadvice-forsøk',
      'pre-advice-manual-request': 'Manuell preadvice startet',
      'pre-advice-status-changed': 'Aviseringstatus endret',
      'pre-advice-active-return-to-customer-email-sent': 'Preadvice aktiv retur til kunde, epost sendt',
      'pre-advice-active-return-not-picked-up-email-sent': 'Preadvice aktiv retur ble ikke hentet, epost sendt',
      'pre-advice-active-return-info-to-customer-email-sent':
        'Preadvice e-post med informasjon om aktiv retur sendt til kunde',
      'pre-advice-passive-return-to-customer-email-sent': 'Preadvice passiv retur til kunde, epost sendt',
      'notification-to-sender-failed': 'Epostvarsel til kunden feilet',
      'reported-damaged': 'Meldt skade',
      'reported-missing-article': 'Rapportert manglende produkt',
      'delivery-sms-sent': 'Leverings SMS sendt',
      'parcelbox-allocated': 'Reservert plass i pakkeboks',
      unconfirmed: 'Ubekreftet',
      refused: 'Avvist',
      'accepted-by-planner': 'Akseptert',
      'apartment-information-updated': 'Leilighetsinformasjon oppdatert',
      'lock-code-entered': 'Dørkode lagt inn',
      'claim-registered-email-sent': 'E-post om skadede- eller manglende varer sendt',
      'invoicing-failed': 'Fakturering feilet',
      'invoiced-ok': 'Fakturering OK',
      'invoice-awaiting-acknowledgement': 'Avventer ordrebekreftelse',
      'parcel-locker-delivery-selected': 'Pakkeboks valgt',
      'cancelled-parcel-locker-delivery': 'Pakkeboks kansellert',
      'pre-advice-result': 'Avisering',
      'order-credited': 'Ordre kreditert',
      'invoice-acknowledged-by-external-system': 'Ordre bekreftet av eksternt system',
      'invoice-created-in-external-system': 'Faktura opprettet i eksternt system',
      'invoice-sent-to-customer': 'Faktura sendt til kunde',
      'invoice-paid-by-customer': 'Faktura betalt av kunde',
      'invoice-due-date-updated': 'Fakturaens forfallsdato oppdatert',
      'invoice-paid-to-vendor': 'Faktura betalt til leverandør',
      'customer-invoiced': 'Kunde fakturert',
      'parcel-locker-tracking-sms-sent': 'Sporings-SMS for pakkeboks-leveranse sendt',
      'time-window-cancelled-by-recipient': 'Tidsvindu kansellert av mottaker',
      'hd-multileg-return-created': 'Returben opprettet',
      'hd-multileg-return-failed': 'Opprettelse av returben feilet',
      'service-upgrade-purchased': 'Mersalg: Innbæring bestilt av mottake',
      serviceUpgradePurchasedDescription: 'Innbæring bestilt av mottaker',
      'preliminary-loaded': 'Foreløpig lastet',
      selfBillingUnitId: 'Self-billing unit ID',
      selfBillingUser: 'Bruker',
      'manual-price-override': 'Pris overstyrt',
      'incomplete-price-approved': 'Ufullstendig pris godkjent',
      'incomplete-price-unapproved': 'Godkjenning av ufullstendig pris trukket tilbake',
      'b2r-return-order-created': 'B2R-returordre opprettet',
      unloaded: 'Avlastet',
      'manually-changed-measurements': 'Manuelt endret vekt og volum',
      'internal-trade-order-created': 'Ordre for internfakturering opprettet',
      'load-carrier-ready-for-distribution': ' Lastbærer klar for distribusjon',
      'bom-articles-muted': 'BOM PU/DEL unntatt fra fakturering',
      'bom-articles-unmuted': 'BOM PU/DEL ikke unntatt fra fakturering.',
      'pickup-app-notification': 'Pushvarsling for sporing sendt',
      'duplicate-order-created': 'Duplikatordre opprettet',
      'ready-for-pickup': 'Klar for henting (PUP på terminal)',
      'return-address-updated': 'Returadresse oppdatert',
      restored: 'Gjenopprettet',
      'manually-marked-as-handled': 'Retur markert som håndtert',
      'recipient-phone-number-updated': 'Mottakers telefonnummer oppdatert',
      'recipient-email-address-updated': 'Mottakers e-postadresse oppdatert'
    },
    cause: {
      plannedStop: 'Henteinformasjon har blitt oppdatert fordi ordren ble lastet på et planlagt stopp',
      planToScan: 'Leveringsinformasjon har blitt oppdatert fordi sendingen ble scannet på rute',
      adhocHenteordre:
        'Leveringsinformasjonen har blitt oppdatert fordi ruten har en annen sluttadresse enn terminalen',
      sorted: 'Leveringsinformasjon har blitt oppdatert fordi sendingen ble sortert',
      shipmentDelayed: 'Leveringsinformasjon har blitt oppdatert fordi sendingen er forsinket',
      movedToNextWorkingDay: 'Flyttet til neste virkedag',
      optimizedInLoadCarrier:
        'Leveringsinformasjonen har blitt oppdatert fordi sendingen ble ruteplanlagt som en del av en lastbærer'
    },
    source: 'Kilde',
    unassignedReason: 'Årsak',
    returnAddressSource: {
      OrderSource: 'Returadressen kunden har oppgitt i bookingfilen brukes',
      CustomerAdmin: 'Returadressen som er satt opp i Customer Admin brukes',
      SenderAddress: 'Ingen returadresse er oppgitt i kundens bookingfil, avsenderens adresse brukes'
    },
    rejectedReason: {
      reason: 'Årsak',
      private: 'Private årsaker',
      notEnoughTime: 'Rekker ikke stoppet i tide',
      notEnoughSpaceOnVehicle: 'Forsendelse får ikke plass på bil',
      other: 'Andre årsaker',
      CJ: '$t(consignmentEvent.rejectedReason.notEnoughSpaceOnVehicle)',
      CK: '$t(consignmentEvent.rejectedReason.other)',
      CL: '$t(consignmentEvent.rejectedReason.notEnoughTime)',
      OL1: 'Ikke på ruten',
      OL2: 'Ikke nok plass i kjøretøyet',
      OL3: 'Ikke nok tid',
      OL4: 'Godset ble ikke funnet',
      OL5: 'Planlagt til senere, men ingen terminalstopp gjenstår',
      comment: 'Kommentar'
    },
    idCheck: {
      idCheckFailed: 'ID-sjekk feilet, men ble levert med {{idCheckFailedResult}}',
      idCheckSummaryOther: 'Annet ({{otherType}}), fødselsdato {{birthDate}}',
      idCheckSummary: '{{idCheckType}}, fødselsdato {{birthDate}}',
      idCheckSummaryOtherLabel: 'Annet ({{otherType}})',
      idCheckValue: 'Fødselsdato {{birthDate}}'
    },
    damaged: {
      damageType: 'Type skade',
      courierInput: 'Melding fra sjåfør',
      showPictureLink: 'Vis bilde {{idx}}',
      type: { A: 'Skade på eske/emballasje', D: 'Trykk/klemskade', E: 'Totalskadet' }
    },
    invoiceInitiationType: {
      automatic: 'Planlagt fakturering',
      'manual-department-level': 'Manuell avdelingsfakturering',
      'manual-order-level': 'Manuell ordrefakturering',
      'multiple-order-level': 'Manuell fakturering av flere ordre'
    },
    autoDispatchFailedReason: {
      NO_MATCHING_ROUTE: 'Fant ingen matchende rute',
      DISPATCH_REJECTED: 'Kunne ikke planlegge optimalisering',
      RETRIES_EXHAUSTED: 'Alle forsøk mislyktes'
    },
    excludedFromInvoicingReason: {
      UNIT_NOT_SELF_BILLING_WITH_INTERNAL_TRADE:
        'Ekskludert automatisk fordi enheten ikke har både avregning og intern handelstransaksjon aktiv'
    },
    autoDispatchSucceeded: {
      matchedRange: 'Matchet postnummerintervall: {{from}}-{{to}}.',
      matchedPostalCode: 'Matchet postnummer: {{code}}.',
      viewRuleDetails: 'Se regeldetaljer <a>her</a>',
      sentForOptimization:
        'Ordren samsvarte med en regel for automatisk tildeling av oppdrag og er sendt til ruteoptimalisering.'
    },
    invoiceCallback: {
      timeOfTransaction: 'Tidspunkt for transaksjon',
      transactionNumber: 'Transaksjonsnummer i {{systemId}}',
      invoiceLink: 'Klikk for å se faktura'
    },
    changedFrom: 'Endret fra -',
    blankText: '(tom)',
    name: 'Navn',
    deliveryOrderedByReceiver: 'Levering til pakkeboks valgt av mottaker',
    invoiceEventReason: {
      manuallySetByUser: 'Satt manuelt av bruker',
      manualInvoiceInfo: 'Satt på pause automatisk fordi manuell fakturainformasjon ble oppgitt på ordren'
    },
    unresolved: {
      missingPickupCoordinates: 'Manglende hentekoordinater',
      missingDeliveryCoordinates: 'Manglende leveringskoordinater'
    },
    resolved: {
      source: {
        DepartmentLocation: 'koordinater på avdeling',
        GeocodingAPI: 'Google',
        DatabaseLookup: 'lagrede koordinater',
        PickupPointAPI: 'Pickup Point API',
        GlowFrontend: 'Glow',
        EDI: 'ukjent',
        CustomerSite: 'kundens lokasjon',
        ParcelHub: 'ParcelHub',
        ParcelInMailbox: 'postkassens koordinater',
        Driver: 'sjåfør',
        OriginalOrder: 'Opprinnelig ordre',
        Google: 'Google',
        GoodsReturnAddress: 'returadresse for varer'
      },
      pickup: {
        coordinatesSetBy: 'Hentekoordinater satt av {{source}}',
        coordinatesManuallySet: 'Hentekoordinater har blitt satt manuelt',
        coordinatesRestored: 'Hentekoordinater gjenopprettet',
        coordinatesSwapped: 'Hentekoordinater satt til tidligere leveringskoordinater'
      },
      delivery: {
        coordinatesSetBy: 'Leveringskoordinater satt av {{source}}',
        coordinatesManuallySet: 'Leveringskoordinater har blitt satt manuelt',
        coordinatesRestored: 'Leveringskoordinater gjenopprettet',
        coordinatesSwapped: 'Leveringskoordinater satt til tidligere hentekoordinater'
      }
    },
    created: {
      recurringOrder: 'Opprettet fra gjentakende ordre.',
      showOriginalOrder: 'Vis originalen',
      recurringRoute: 'Opprettet fra gjentakende rute',
      recurringRouteLink: 'til ruteoppsett',
      showDuplicate: 'Vis duplikatordre',
      showOrder: 'Vis ordre',
      fromThisOrder: 'Opprettet fra denne ordren',
      fromOrder: 'Opprettet fra ordre'
    },
    outsideTimeWindow: {
      'delivered-outside-estimated-time-window': 'Estimert tidsvindu',
      'delivered-in-estimated-time-window': 'Estimert tidsvindu',
      'delivered-outside-service-time-window': 'Servicetidsvindu',
      'picked-up-outside-estimated-time-window': 'Estimert tidsvindu',
      'picked-up-in-estimated-time-window': 'Estimert tidsvindu',
      'picked-up-outside-service-time-window': 'Servicetidsvindu',
      actual: 'Faktisk levering eller avvik',
      actualPickup: 'Faktisk henting eller avvik'
    },
    deliveryInstructions: 'Leveringsinstrukser'
  },
  planner: {
    colorPicker: 'Fargevelger',
    canLogIn: 'Kan logge inn',
    chooseYourDepartment: 'Velg din avdeling',
    unassignedShipments: 'Uanviste forsendelser',
    filterCustomers: 'Filtrer kunder',
    filterServices: 'Filtrer tjenester',
    autoRoute: 'Automatisk rute',
    saved: 'Lagret',
    allUserRoles: 'Alle brukerroller',
    userRolesCount_other: '{{count}} brukerroller',
    createNewUser: 'Opprett ny bruker',
    userRolesCount: '{{count}} brukerrolle',
    role: 'Rolle',
    searchForNameOrNumber: 'Søk etter navn eller telefonnummer',
    noPlannersFound: 'Ingen planleggere funnet',
    typeOfRole: 'Type brukerrolle',
    selectUserRole: 'Velg brukerrolle',
    secondTab: 'Andre fane',
    users: 'Brukere',
    connectDepartment: 'Koble avdeling til bruker',
    banner: {
      tryNewRoutePlanner:
        'Fra 1. mai vil <0>ruteplanlegger 2.0</0> være den eneste tilgjengelige ruteplanleggeren. Hvis du ikke har brukt ruteplanleggeren før, oppfordrer vi deg til å begynne å bruke den fra nå av. <1>Les mer på Zendesk</1> og andre relaterte artikler for å få en oversikt over hvordan den fungerer.'
    },
    createdBy: 'Opprettet av',
    totalTitle: 'Kolli',
    pickList: 'Plukkliste',
    export: 'Eksporter for fakturering',
    deleteSlot: 'Slett',
    editSlot: 'Rediger',
    deleteSlotConfirmDialogText: 'Er du sikker du vil slette denne slotten?',
    deleteFilteredSlots: 'Slett alle ruter',
    deleteAllSlotsConfirmDialogText: 'Er du sikker på at du vil slette alle rutene?',
    created: 'Planlegger opprettet',
    updated: 'Planlegger oppdatert',
    deleted: 'Planlegger har blitt slettet',
    removeDepartment: 'Fjern avdeling {{name}}',
    confirmDelete: 'Er du sikker på at du vil slette denne brukeren?',
    live: 'Live',
    youMustProvideName: 'Du må oppgi brukerens navn',
    youMustProvidePhonenumber: 'Du må oppgi telefonnummer',
    showInGoogleMaps: 'Vis ruten i Google Maps',
    detailedAccessRights: 'Detaljerte tilgangsrettigheter for {{name}}',
    routePlanning: 'Ruteplanlegging',
    vehicles: 'Kjøretøy',
    routePlanningConsignmentsAssigned: 'tildelt',
    routePlanningRangeDescription: 'Filtrer leveranser basert på leveringstidspunkt',
    unresolvedConsignments: 'Ufullstendige',
    consignments: 'Leveranser',
    couriers: 'Sjåfører',
    units: 'Enheter',
    invoicing: 'Fakturering',
    planner: 'Planlegger',
    planners: 'Planleggere',
    noPlanners: 'Ingen planleggere',
    missingId: 'Id mangler',
    missingName: 'Navn mangler',
    search: 'Søk',
    searchForPlanner: 'Søk etter planleggere',
    name: 'Navn',
    phoneNumber: 'Telefonnummer',
    selectDepartments: 'Velg avdeling(er)',
    createSlot: 'Opprett slot',
    editSlotForm: 'Rediger slot',
    routeUpdated: 'Ruten har blitt oppdatert',
    createSlotFormName: 'Navn',
    createSlotFormUnit: 'Enhet',
    createSlotFormCourier: 'Sjåfør',
    createSlotFormSlotMode: 'Modus',
    createSlotFormSlotModePickup: 'Tegn hentingsområde i kart',
    createSlotFormSlotModeDelivery: 'Tegn leveringsområde i kart',
    createSlotFormSlotModeManual: 'Velg leveranser manuelt',
    createSlotFormSlotModeSelected: 'Velg pakker',
    createSlotFormTimeRange: 'Tid',
    createSlotFormStartLocation: 'Start-lokasjon',
    createSlotFormEndTime: 'Sluttid',
    createSlotFormEndLocation: 'Slutt-lokasjon',
    createSlotFormSlotColor: 'Farge',
    createSlotFormTimeRangeTooBig: 'For stort tidsspenn. Maks er {{hours}} timer.',
    createSlotFormFilterCustomers: 'Filtrer kunder',
    createSlotFormFilterServices: 'Filtrer tjenester (ingen valgt betyr alle)',
    slotFilterInfo:
      'Denne ruten er filtrert, dvs at kun ordre som tilhører valgte kunde(r) og valgte tjeneste(r) vil kunne knyttes til ruten.',
    slotFilteredCustomer: 'Ruten inkluderer KUN ordre fra følgende kunder',
    slotFilteredService: 'Ruten inkluderer KUN ordre med følgende tjenester',
    onlyShowApplicable: 'Vis kun tildelte og gyldige for ruten basert på kunde-/tjenestefiltrering',
    optimizeButtonLabel: 'Optimaliser og tildel ruter',
    optimizeSlotButtonLabel: 'Re-optimaliser slot',
    reversedOptimizeSlotButtonLabel: 'Reverser leveringsrekkefølgen',
    optimizingSince: 'Optimalisering pågår, startet kl. {{startTime}}',
    addToRoute: 'Legg til rute...',
    pickup: 'Opphenting',
    delivery: 'Levering',
    depot_call: 'Planlagt stopp',
    slot: 'Rute',
    notAssigned: 'Ikke tildelt',
    readOnly: 'Kun lesetilgang',
    normal: 'Normal',
    plus: 'Ekstra rettigheter',
    partner: 'Partner',
    readOnlyAccessPlannersWithCount: '{{count}} trafikkplanleggere med lese-tilgang',
    plusPlannersWithCount: '{{count}} trafikkplanleggere med ekstra rettigheter',
    normalPlannersWithCount: '{{count}} trafikkplanleggere med normale rettigheter',
    saveTemplate: 'Lagre som mal',
    loadTemplate: 'Hent fra mal',
    routeListForFilteredSlots: 'Kvitteringsliste (print alle)',
    loadListForFilteredSlots: 'Lasteliste (print alle)',
    sendPrePickupSmsesToAll: 'Forhåndssend sporings-sms',
    alertBeforeSendingPrePickupSms: 'Er du sikker på at du vil forhåndssende sporings-SMS for alle ruter for i dag?',
    newTemplate: 'Lag en ny mal',
    selectTemplate: 'Velg mal',
    deleteTemplate: 'Slett',
    templateDeleteConfirm: 'Er du sikker på at du vil slette malen?',
    missingDeliveryMarker: 'Ikke en gyldig leveringsadresse eller lokasjon',
    missingPickupMarker: 'Ikke en gyldig henteadresse eller lokasjon',
    assignConsignmentFromSlot: 'Tildel leveranse til {{routeName}}?',
    unassignConsignmentFromSlot: 'Fjern {{count}} leveranse fra rute?',
    unassignConsignmentFromSlot_other: 'Fjern {{count}} leveranser fra rute?',
    unassignBulkConsignmentsFromSlotsAlert: 'Ønsker du å fjerne sendingene fra sine respektive ruter?',
    unassignedFromSlot: 'Leveransen har nå blitt fjernet fra tilhørende slot',
    unassignBulkConsignmentsFromSlots: 'Sendingene har nå blitt fjernet fra sine respektive ruter',
    unassignButton: 'Fjern fra slot',
    forceUnassignButton: 'Tving fjerning fra slot',
    driverName: 'Sjåfør',
    deliveries: 'Leveringer',
    returns: 'Returer',
    installations: 'Installasjoner',
    curbside: 'Curbside',
    label: 'Etikett',
    filters: { assigned: 'Tildelt', unassigned: 'Ikke tildelt', pickups: 'Opphentinger', deliveries: 'Leveringer' },
    saveSelected: 'Lagre valgte ({{count}})',
    showSaved: 'Vis lagrede ({{count}})',
    showAll: 'Vis alle',
    clearSaved: 'Fjern lagrede',
    sendPrePickupSms: 'Forhåndssend sporings-SMS til mottaker',
    sendSms: 'Send SMS',
    sendingSmsText: 'Sendinger {{count}} sporings-SMS',
    prePickupSmsSent: '{{sentCount}} av {{totalCount}} sporings-SMS sendt',
    manualDelaySms: {
      smsSent: '{{count}} manuelle forsinkelse SMS sendt',
      heading: 'Manuell forsinkelse SMS',
      sendingSmsText: 'Sender {{count}} manuelle forsinkelse SMS-er',
      selectSmsDescription: 'SMS-en vil starte med "Hei, vi er dessverre forsinket". Velg SMS-avslutning nedenfor',
      selectSmsEnding: 'Velg hvordan SMS-en skal avsluttes',
      selectSmsBeginning: 'Velg hvordan SMS-en skal begynne',
      previewLabel: 'Forhåndsvisning av SMS',
      buttonTitle: 'Send',
      beginningType: {
        hi: '"Hei!"',
        none: 'Ingen',
        fromSender: '"Leveransen din fra avsender er dessverre forsinket."',
        highDemand: '"På grunn av høy belastning kan godset ditt dessverre ikke leveres som planlagt."'
      },
      endingType: {
        none: 'Ingen',
        soon: '"Vi kommer til å levere så raskt som mulig"',
        tomorrow: '"Vi forsøker å levere neste virkedag"',
        whenShipmentHasArrived: '"Et nytt leveringsdato og -tidsrom blir sendt når sendingen har ankommet terminalen."',
        newDeliveryTime: '"Vi vil levere dette til deg på neste tilgjengelige leveringsdag."',
        newDeliveryTimeFullEnding:
          '"Ny levering er booket [DATE] [TIMESLOT]. Du kan endre leveringstid via [TRACKINGLINK]. Hilsen Bring"'
      },
      disabledTooltip: 'Ordrer kan ikke være i tilstanden Levert'
    },
    delayedShipmentNotification: {
      description:
        'Mottakeren vil få en SMS om at sendingen er forsinket, og at nytt leveringsdato- og tidsrom blir sendt når sendingen har ankommet terminalen.',
      resetDescription: 'Når du bekrefter, vil de valgte sendingene bli resatt og fjernet fra rute hvis de er tildelt.',
      gScanDescription:
        'Etter at terminalankomst er registrert, vil mottakeren bli varslet på nytt i henhold til preadvice-reglene.',
      successMessage: 'Flyten for forsinket sending ble startet'
    },
    rescheduledShipmentNotification: {
      description: 'Leveransen vil bli flyttet til en ny dato og tid.',
      autoUpdateDescription:
        'Mottakeren vil få en SMS om at leveransen ikke kommer i dag som planlagt. Meldingen inkluderer også den nye datoen og tidspunktet, samt en lenke der de kan endre leveransen om nødvendig.'
    },
    h2: {
      booking: 'H2-booking',
      vasHelperText: 'Bruk VAS 1158 for MBH'
    },
    loadList: {
      address: 'Adresse',
      customerRef: 'Kundereferanse',
      date: 'Dato',
      deliveries: 'Leveringer',
      distance: 'Avstand',
      estimatedLoadTime: 'ELT',
      estimatedTotalTime: 'Est. tid',
      header: 'Ruteoppsummering',
      instructions: 'Leveringsinstruksjoner,\ntelefon,\nmottakerref.',
      instructionsPhone: 'Tlf:',
      instructionsRef: 'Mottakerref:',
      listName: 'Lasteliste',
      name: 'Navn',
      qty: 'Ant.',
      routeName: 'Rute',
      service: 'Tjeneste\n(VAS)',
      stopOrder: 'Stopp nr.',
      summary: 'Oppsummering',
      time: 'Tid',
      timeWindow: 'Tidsvindu (ETA-ETD)',
      tripNumber: 'Tur',
      totalDistance: 'Total avstand',
      totalTime: 'Total tid',
      unit: 'Enhet',
      volume: 'Vol\nm³',
      weight: 'Vekt\nkg',
      zipArea: 'Område',
      zipCode: 'Postnummer',
      unknownRouteName: 'Ukjent rutenavn',
      unknownUnitName: 'Ukjent enhetsnavn',
      noDataText: 'Ingenting å se her',
      utilization: 'Utnyttelse'
    },
    locationList: { listName: 'Lokasjonsliste' },
    assignedUnits: 'Tildelte enheter',
    unassignedUnits: 'Utildelte enheter',
    noUnitSelected: 'Ingen enhet valgt',
    unitAssignmentCount: 'Enhet tilordnet til {{count}} ruter',
    breakDeletedFromRoute: 'Pausetiden ble fjernet fra rute',
    autoRouteModal: {
      selectRoutes: 'Velg ruter',
      selectRoutesText:
        'Velg rutene som skal inkluderes i automatisk ruting. Bare ruter med status Opprettet eller Tildelt er tilgjengelige. For ruter som allerede pågår, bruk Legg til rute for å dispatche sendinger.',
      routesStartedRemoved: '{{routes}} har startet og er fjernet fra utvalget',
      routesStartedRemoved_other: '{{routes}} har startet og er fjernet fra utvalget',
      lockAllToSlot: 'Lås alle tildelte ordre til ruten',
      useMapAreaRestrictions: 'Bruk kartområderestriksjoner',
      usePostalCodeRestrictions: 'Bruk postnummerrestriksjoner',
      useGraphHopper: 'Bruk GraphHopper',
      usePtv: 'Bruk PTV',
      usePtvPilot: 'Premium optimering',
      useKardinal: 'Bruk Kardinal',
      useHere: 'Bruk HERE',
      useHexaly: 'Bruk Hexaly',
      useHexalyCloud: 'Bruk Hexaly Cloud',
      timeLimitInSeconds: 'Tidsgrense i sekunder',
      timeLimitByStops: 'Tom: basert på størrelsen på planen',
      timeLimitAsMinutes: '= {{minutes}} min {{seconds}} s',
      timeLimitOutOfRange: 'Skriv hele sekunder mellom 10 og 2700 (45 minutter)',
      timeLimitExample: 'f.eks. 60',
      useNoEngine: 'Ikke bruk optimaliseringsmotor på denne spesifikke ruten',
      optimizeOn: 'Optimer på',
      noRelevantRoutes: 'Fant ingen relevante ruter',
      startAutomaticRouting: 'Start automatisk ruting',
      selectOptimizingEngine: 'Velg optimaliseringsmotor',
      useFlexAndForceFromPrevious: 'Bruk fleks og tvungen rekkefølge fra tidligere optimalisering'
    },
    wait: 'Ventetid',
    trips: 'Turer',
    searchSlotCourierName: 'Søk etter rute-/sjåførnavn',
    favouriteDepartments: 'Favoritter',
    addFavouriteDepartment: 'Legg til favoritt: {{department}}',
    removeFavouriteDepartment: 'Fjern favoritt: {{department}}',
    largeDepartmentGuard: {
      validationMessage:
        'Den valgte avdelingsgruppen {{departmentGroup}} har for mange ruter og kan ikke brukes på {{page}}. Velg en annen avdelingsgruppe eller avdeling.'
    }
  },

  updateServiceLevel: {
    menuItem: 'Endre servicenivå',
    selectOption: 'Velg servicenivå',
    heading: 'Endre servicenivå',
    confirmation: 'Servicenivå oppdatert',
    subtext: 'Endre servicenivå for {{count}} sending',
    subtext_other: 'Endre servicenivå for {{count}} sendinger’',
    failed: {
      title: 'Kunne ikke endre servicenivå',
      message: 'Kunne ikke endre servicenivå for {{count}} sending',
      message_other: 'Kunne ikke endre servicenivå for {{count}} sendinger'
    }
  },
  manualPreAdvice: {
    menuItem: 'Manuell preavisering',
    selectOption: 'Velg preaviseringstype',
    heading: 'Manuell preavisering',
    confirmation: 'Preavisering(er) opprettet',
    subtext: 'Manuell preavisering av {{count}} sending',
    subtext_other: 'Manuell preavisering av {{count}} sendinger',
    failed: {
      title: 'Manuell preavisering feilet',
      message: 'Noe gikk galt ved preavisering av {{count}} sending',
      message_other: 'Noe gikk galt ved preavisering av {{count}} sendinger'
    }
  },
  setPickupDeliveryDuration: {
    menuItem: 'Angi tider for henting/levering',
    heading: 'Angi tider for henting og levering',
    subtext: 'Angi tider for henting og levering på {{count}} forsendelse',
    subtext_other: 'Angi tider for henting og levering på {{count}} forsendelser',
    pickupPreparation: 'Forberedelse henting',
    pickupDuration: 'Varighet henting',
    deliveryPreparation: 'Forberedelse levering',
    deliveryDuration: 'Varighet levering',
    confirmation: 'Tider for henting og levering er oppdatert',
    validationError: 'Ugyldig tid. Maksimalt antall minutter og sekunder er 59',
    description:
      'Angi forberedelse og varighet for henting og levering for de valgte bestillingene. Maksimalt antall minutter og sekunder er 59.'
  },
  importExportOrders: {
    importOrdersHeading: 'Importer ordre',
    importStatus: 'Det er for øyeblikket {{imports}} importer i kø med totalt {{orders}} ordre',
    exportForInvoice: 'Eksport for fakturering',
    fileTemplateLink: 'Last ned Excel-mal',
    uploadFile: 'Importer ordre',
    uploadingMessage: 'Laster opp filen og importerer bestillingene...',
    testDataWarning: 'Ikke bruk personopplysninger i testmiljø',
    testDataInfo:
      'Dette er et qa/testmiljø, og du har ikke lov til å bruke produksjonsdata i test uten berørte brukeres eksplisitte samtykke.',
    fromDate: 'Fra dato',
    toDate: 'Til dato',
    fromDateNotAfterToDate: "Kan ikke være senere enn 'Til dato'",
    toDateNotBeforeFromDate: "Kan ikke være tidligere enn 'Fra dato'",
    removeControlColumns: 'Fjern kontrollkolonner',
    importResults: 'Importer resultater',
    fileName: 'Importert fil',
    processedAt: 'Behandlet',
    createdShipmentId: 'Opprettet forsendelses-ID',
    date: 'Dato',
    exportShipments: 'Eksporter forsendelser',
    createLabels: 'Opprett etiketter',
    selectSlot: 'Velg rute',
    selectExportLabel: 'Velg hva du vil eksportere',
    allOrders: 'Alle Ordre',
    deviatedOrders: 'Ordre med avvik',
    all: 'Alle',
    selectFile: 'Velg fil',
    exportFailed: 'Kunne ikke eksportere data',
    jobList: {
      title: 'Tidligere eksporter',
      content: 'Innhold',
      created: 'Opprettet',
      user: 'Bruker',
      dates: 'Datoer',
      download: 'Last ned',
      exporting: 'Eksporterer...',
      downloading: 'Laster ned...',
      inQueue: 'I eksportkø',
      exportFailed: 'Eksporten mislyktes',
      updated: 'Oppdatert',
      previousImports: 'Tidligere import',
      fileName: 'Filnavn',
      numberOfOrders: 'Antall ordre',
      imported: 'Importert',
      viewOrders: 'Vis ordre',
      lastImports: 'Viser de siste {{count}} importene'
    },
    exportStartedNotification: 'Eksporten startet',
    exportStartedNotificationMessage: 'Rapporten din vil være tilgjengelig så snart den er behandlet.',
    exportFailedNotification: 'Eksporten mislyktes. Prøv igjen senere',
    refreshData: 'Oppdater data i eksisterende rapport',
    refreshDataDescription:
      'Velg dette alternativet hvis du allerede har opprettet en eksisterende rapport for de spesifikke datoene',
    types: {
      SHIPMENT_EXPORT: 'Forsendelser',
      COURIER_WORK_REPORT: 'Arbeidsrapport for sjåfører',
      COURIER_WORK_REPORT_EXTENDED: 'Utvidet arbeidsrapport for sjåfører',
      END_OF_DAY_REPORT: 'Dagsrapport',
      SOCIAL_CONTROL: 'Sosialkontroll',
      LOCATION_LIST: 'Lokasjonsliste',
      ORDER_EXPORT: 'Eksport av ordre',
      ORDER_DEVIATION_EXPORT: 'Ordre (Avvik)',
      ORDER_EXPORT_ANONYMOUS: 'Ordre (Anonymisert Data)',
      ORDER_PARTNER_EXPORT: 'Ordre (For Partnere)',
      DEVIATION_EVENTS: 'Avvikshendelser',
      OPTIMIZATION_RESULTS: 'Optimeringsresultater',
      FINANCIAL_REPORT: 'Økonomisk rapport'
    },
    exportTitles: {
      SHIPMENT_EXPORT: 'Eksporter forsendelser',
      COURIER_WORK_REPORT: 'Arbeidsrapport for sjåfører',
      COURIER_WORK_REPORT_EXTENDED: 'Utvidet arbeidsrapport for sjåfører',
      END_OF_DAY_REPORT: 'Dagsrapport',
      SOCIAL_CONTROL: 'Eksporter Sosialkontroll',
      LOCATION_LIST: 'Eksporter lokasjonsliste',
      ORDER_EXPORT: 'Eksporter ordre',
      ORDER_DEVIATION_EXPORT: 'Eksporter Ordre med avvik',
      ORDER_EXPORT_ANONYMOUS: 'Eksporter Ordre Anonymisert',
      ORDER_PARTNER_EXPORT: 'Eksporter Ordre for partnere',
      DEVIATION_EVENTS: 'Eksporter avvikshendelser',
      OPTIMIZATION_RESULTS: 'Eksporter optimeringsresultater',
      FINANCIAL_REPORT: 'Eksporter økonomisk rapport'
    },
    exportDescriptions: {
      SHIPMENT_EXPORT: '',
      COURIER_WORK_REPORT: '',
      COURIER_WORK_REPORT_EXTENDED: '',
      END_OF_DAY_REPORT: 'Bruk denne rapporten for å se daglig rutestatistikk, inkludert driftskostnader og inntekter.',
      SOCIAL_CONTROL: '',
      LOCATION_LIST: '',
      ORDER_EXPORT:
        'Hvis du ønsker å bruke data i testmiljøer, anbefaler vi å bruke alternativet "Ordre (anonymiserte data)"',
      ORDER_DEVIATION_EXPORT:
        'Hvis du ønsker å bruke data i testmiljøer, anbefaler vi å bruke alternativet "Ordre (anonymiserte data)"',
      ORDER_EXPORT_ANONYMOUS: 'Kan brukes hvis data skal importeres til et testmiljø',
      ORDER_PARTNER_EXPORT: 'Tilpasset excelfil som kan brukes for import i Opter',
      DEVIATION_EVENTS: '',
      OPTIMIZATION_RESULTS: 'Tilpasset excelfil med optimeringsresultater',
      FINANCIAL_REPORT: 'Inneholder tilleggsark med ordre nedbrukket på debiteringsrader der det er relevant'
    }
  },
  unit: {
    unitWithCount: '{{count}} enhet',
    unitWithCount_other: '{{count}} enheter',
    new: 'Ny enhet',
    edit: 'Endre enhet',
    addCourier: 'Legg til sjåfør',
    hideAddCourier: 'Skjul legg til sjåfør',
    requiresCourierUsers: 'Må ha minst én sjåfør',
    created: 'Enheten har blitt opprettet',
    updated: 'Enheten har blitt oppdatert',
    search: 'Søk etter enheter fra andre avdelinger...',
    unitsInCurrentDepartment: 'Enheter i nåværende avdeling',
    unitsInOtherDepartments: 'Enheter i andre avdelinger',
    saveUnit: 'Lagre enhet',
    addCourierToUnit: 'Legg sjåfør til enhet',
    clearSearch: 'Tøm søk',
    noCouriersFound: 'Ingen sjåfør funnet',
    addCourierToUnitSearch: 'Du kan bare søke etter sjåfører i avdelinger du har tilgang til',
    addedCouriers: 'Lagt til sjåfør ({{count}})',
    newCourier: 'Opprett ny sjåfør',
    name: 'Navn',
    unitId: 'Enhets-ID',
    couriers: 'Sjåfør',
    active: 'Aktiv',
    vehicle: 'Kjøretøy',
    deleteQuestion: 'Fjern enheten fra nåværende avdeling',
    deleteDescription: 'Enheten kan kobles til igjen senere hvis den fortsatt er tilkoblet andre avdelinger',
    unassigned: 'Enheten ble fjernet fra avdelingen',
    setDefaultVehicle: {
      add: 'Legg til kjøretøy',
      change: 'Bytt kjøretøy',
      title: 'Legg kjøretøy til {{unit}}',
      selectVehicle: 'Velg kjøretøy',
      addSuccess: 'Kjøretøyet ble lagt til {{unit}}',
      changeSuccess: 'Kjøretøyet ble endret på {{unit}}'
    }
  },
  courier: {
    isActive: 'Er aktiv',
    canLogIn: 'Kan logge inn',
    recipientName: 'Mottakernavn',
    created: 'Sjåføren har blitt opprettet',
    updated: 'Sjåføren har blitt oppdatert',
    courier: 'Sjåfør',
    couriers: 'Sjåfører',
    noCouriers: 'Ingen sjåfører',
    courierWithCount: '{{count}} sjåfør',
    courierWithCount_other: '{{count}} sjåfører',
    numberOfCouriers: 'Fant {{number}} sjåfører',
    multipleDrivers: 'Flere transportører',
    missingId: 'Id mangler',
    missingName: 'Navn mangler',
    search: 'Søk etter sjåfører',
    new: 'Ny sjåfør',
    edit: 'Endre sjåfør {{name}}',
    name: 'Navn',
    phoneNumber: 'Telefonnummer',
    driverId: 'Sjåfør-ID',
    capacity: 'Kapasitet',
    capacityLabel: 'Kapasitet (antall)',
    weightCapacity: 'Vektkapasitet (kg)',
    volumeCapacity: 'Volumkapasitet (m³)',
    maxRangeKm: 'Rekkevidde (km)',
    color: 'Farge',
    resetColor: 'tilbakestill farge',
    speedFactor: 'Hastighetsfaktor',
    speedFactorExplanation: 'lavere = tregere',
    serviceTimeFactor: 'Opphentings- og leveransehastighetsfaktor',
    serviceTimeFactorExplanation: 'lavere = raskere',
    defaultStopLocation: 'Sluttlokasjon',
    defaultStartLocation: 'Startlokasjon',
    slotNumDeliveries: '{{count}} levering',
    slotNumDeliveries_other: '{{count}} leveringer',
    slotNumPickups: '{{count}} opphenting',
    slotNumPickups_other: '{{count}} opphentinger',
    deliverPerformButtonLabel: 'Levér',
    handoverPerformButtonLabel: 'Overlever',
    deviationPerformButtonLabel: 'Avvik',
    deliverWithoutSignatureButtonLabel: 'Uten signatur',
    deliverWithSignatureButtonLabel: 'Signatur',
    deviateNotAtHomeButtonLabel: 'Ikke hjemme',
    deviateLocNotFoundButtonLabel: 'Kunne ikke finne stedet',
    deviateRecipientDeclinedButtonLabel: 'Mottakeren ønsket det ikke',
    deviateTimeWindow: 'Fikk ikke mulighet å levere innen tidsvinduet',
    addressNotFound: 'Adresse ikke funnet',
    deliverySpotUnavailable: 'Avtalt leveringssted utilgjengelig',
    deliveryAttemptNotPickedUp: 'Leveringsforsøk - Ikke hentet',
    noAvailableHatchInParcelBoxMachine: 'Ingen tilgjengelig luke',
    packageDoesNotFitInParcelBox: 'Pakken overskrider tillatte dimensjoner/vekt',
    unknownErrorForParcelBoxDelivery: 'Annet ukjent',
    errorInParcelBoxMachine: 'Maskinen er ute av drift',
    deviation: {
      'H-12': 'Sendingen er forsøkt levert, men mottaker var ikke tilstede',
      'H-11': 'Pakken ble forsøkt levert, men mottakeren ble ikke funnet på stedet',
      'H-10': 'Pakken ble forsøkt levert, men adressen ble ikke funnet',
      'H-13': 'Sendingen er forsøkt levert, men er nektet mottatt',
      '7-10': 'Leveransen kunne ikke plukkes opp pga ufullstending adresse',
      '7-12': 'Avsenderen var ikke tilgjengelig. Leveransen har ikke blitt hentet',
      '7-82': 'Leveransen var ikke klar for å bli plukket opp',
      'OFU-10': 'Ufullstendig adresse',
      'OFU-12': 'Mottaker ikke tilgjengelig',
      'OFU-82': 'Godset er ikke klart for henting',
      'OFU-DI': 'Ingen varer for henting',
      'OFU-87': 'Force majeure',
      'OFU-OCB': 'Havari på bilen',
      'OFU-OL2': 'Ikke nok plass i bilen',
      'OFU-OS1': 'Godset skadet før henting',
      'V-41-K': 'Sendingen er forsinket, den vil bli videresendt så raskt det lar seg gjøre',
      'V-OL2': 'Ikke nok plass i kjøretøyet',
      'V-OL4': 'Godset ble ikke funnet',
      'V-OL5': 'Planlagt senere på samme rute',
      '9-91': 'Kansellert av kunden',
      'H-07-R': 'Mislykket sosialkontroll',
      'H-07-Z': 'Mislykket sosialkontroll',
      'H-08-Z': 'Mislykket alderskontroll',
      'H-09-Z': 'Mislykket ID-kontroll',
      'VI-16-X': 'Fikk ikke mulighet å levere innen tidsvinduet',
      'H-11-Z': 'Adresse ikke funnet',
      'H-BL-A': 'Avtalt leveringssted utilgjengelig',
      'A-10': '$t(courier.deviation.7-10)',
      'A-12': '$t(courier.deviation.7-12)',
      'A-82': '$t(courier.deviation.7-82)',
      'V-100-CA': 'Ingen pakkeboks tilgjengelig. Pakken leveres som hjemlevering',
      'V-100-CI': 'Ingen tilgjengelig luke',
      'V-80-CI': 'Pakken overskrider tillatte dimensjoner/vekt',
      'V-99-CI': 'Annet ukjent',
      'V-AO-CI': 'Maskinen er ute av drift',
      'H-49-Q': '$t(courier.deliveryAttemptNotPickedUp)',
      'V-X-Y': 'Ordre lastet av en annen sjåfør'
    },
    completionProgressCounter: '{{numCompleted}}/{{numTotal}} ferdige',
    lockCode: 'Dørkode',
    flexDelivery: 'Forenklet levering',
    fuelType: 'Drivstofftype',
    fuelTypes: {
      gasoline: 'Bensin',
      natural_gas: 'Naturgass',
      ethanol: 'Etanol',
      bio_gas: 'Biogass',
      electric: 'Elektrisitet',
      bicycle: 'Sykkel',
      diesel: 'Diesel',
      rme: 'RME',
      hvo: 'HVO',
      hydrogen: 'Hydrogen'
    },
    fuelCategory: 'Drivstoffkategori',
    fuelCategories: {
      fossil: 'Fossilt drivstoff',
      fossil_free: 'Fossilfritt drivstoff',
      zero_emissions: 'Null utslipp'
    },
    latestLogin: 'Siste pålogging',
    latestVersion: 'Siste versjon',
    failedSocialControl: 'Mislykket sosialkontroll',
    failedIdControl: 'Mislykket ID-kontroll',
    failedAgeControl: 'Mislykket alderskontroll',
    incompletePickupAddress: 'Leveransen kunne ikke plukkes opp pga ufullstending adresse.',
    custNotAvailableAtPickupAddress: 'Avsenderen var ikke tilgjengelig. Leveransen har ikke blitt hentet.',
    goodsNotReadyAtPickupForCust: 'Leveransen var ikke klar for å bli plukket opp.',
    shipmentNotAvailableAtTerminal: 'Sendingen er forsinket, den vil bli videresendt så raskt det lar seg gjøre.',
    registrationNumber: 'Registreringsnummer',
    commercialTrafficEligibility: 'Kommersiell trafikk berettigelse',
    vehicleBrand: 'Kjøretøymerke',
    vehicleModel: 'Kjøretøymodell',
    vehicleControl: 'Kjøretøykontroll',
    vehicleControlComment: 'Kommentar om kjøretøykontroll',
    euroClass: 'Euroklasse',
    euroClassTypes: { euro5: 'Euro 5', euro6: 'Euro 6', euroEL: 'Euro EL' },
    alcoholDeliveryEducation: 'Alkoholleveringsutdanning',
    alcoholDeliveryEducationDate: 'Utført utdanning',
    alcoholDeliveryEducationDateMissing: 'Dato mangler',
    alcoholDeliveryEducationDateRequired: 'Angi datoen alkoholleveringsutdanningen ble fullført',
    alcoholDeliveryEducationValidToDate: 'Gyldig til {{date}}',
    alcoholDeliveryEducationExpiresDate: 'Utløper {{date}}',
    alcoholDeliveryEducationExpiredDate: 'Utløpt {{date}}',
    alcoholDeliveryEducationValidTo: 'Gyldig til',
    alcoholDeliveryEducationValidToRequired: 'Angi datoen utdanningen er gyldig til',
    alcoholDeliveryEducationValidToAfterEducationDate: 'Gyldig til må være etter datoen for utført utdanning',
    approved: 'Godkjent',
    notApproved: 'Ikke godkjent',
    couriersInCurrentDepartment: 'Sjåfører i nåværende avdeling',
    couriersInOtherDepartments: 'Sjåfører i andre avdelinger',
    inCurrentDepartment: 'Nåværende avdeling',
    inOtherDepartments: 'Ulike avdelinger',
    noCouriersExplain: 'Vi fant ingen resultater. Prøv å søke med et annet begrep',
    confirmConnect: 'Koble sjåfør til nåværende avdeling',
    confirmModalDescription: '',
    searchForCouriers: 'Søk etter sjåfør',
    dateOfBirthWithFormat: 'Fødselsdato (dd-mm-yyyy)',
    occupationalInjuryInsurance: 'Yrkesforsikring',
    editCourier: 'Rediger Sjåfør:',
    courierUserUpdated: 'Sjåfør har blitt oppdatert.',
    courierScanEnabled: 'Skann',
    breakTime: 'Pause',
    breakDuration: 'Pausens varighet (min)',
    timeWindow: 'Start på pause (tidligste og seneste)',
    breakTimeDescription:
      'I feltene <i>Tidligst</i> og <i>Senest)</i> angir du tidligste og seneste tidspunkt for pause. For eksempel betyr 11:00 - 17:00 at sjåføren senest kan starte pausen kl. 17:00.',
    breakOptimizingSupportDescription:
      'Merk at pauser kun støttes ved optimalisering av ruter med GraphHopper. Denne funksjonaliteten er ikke tilgjengelig ved bruk av PTV.',
    between: 'Mellom',
    editBreakTime: 'Rediger pausetid',
    updateBreakTime: 'Oppdater pausetid',
    latestBreakStart: 'Seneste start på pause',
    radioButtons: { noBreakTime: 'Ingen pause', timeWindow: 'Tidsvindu', workingTime: 'Arbeidstid' },
    workingTimeDescription:
      'Du setter maksimal arbeidstid før sjåføren må ta en pause. For eksempel";" etter 8 timer må sjåføren ta en 30-minutters paus',
    maxWorkingTime: 'Maksimal arbeidstid',
    selectMaxWorkingTime: 'Velg maksimal arbeidstid',
    hours: '{{hours}} timer',
    breakTooltip: 'Du kan bare ha én pausetype per enhet',
    secureLoginEnabled: 'BankID-innlogging',
    unitId: 'Enhets-ID',
    minShipmentWeightKg: 'Minimum fraktvekt på dette kjøretøyet (kg)',
    maxShipmentWeightKg: 'Maksimal fraktvekt på dette kjøretøyet (kg)',
    canCarryPallets: 'Kan frakte paller',
    co2: 'CO2',
    dateOfBirth: 'Fødselsdato',
    dateNotValid: 'Ugyldig dato'
  },
  slot: {
    minutesDelay: 'minutter forsinket',
    minutesAhead: 'minutter før tiden',
    minutes: 'minutter',
    time: 'Tid',
    created: 'Opprettet',
    assigned: 'Tildelt',
    lock: 'Lås',
    lockDescription:
      'Når slotten er låst, så vil den ikke være en del av nye ruteoptimaliseringer, og kan ikke bli endret på.',
    toggleVisibleSlotDescription: 'Skjul slot.',
    inProgress: 'Pågår',
    onHold: 'På vent',
    complete: 'Fullført',
    unknownState: 'Ukjent tilstand',
    courierSelect: 'Velg sjåfør',
    unitSelect: 'Velg enhet',
    printableSlotList: 'Slot-liste for utskrift',
    followsRoute: 'Følger',
    doesNotFollowRoute: 'Avviker',
    hasLocation: 'Synlig',
    hasNoLocation: 'Ikke synlig',
    showActiveSlots: 'Aktive',
    showSlotNotStarted: 'Ikke startet',
    showLoggedInRoutes: 'Innlogget - ikke startet',
    showCompletedSlot: 'Fullførte',
    showPerfectSlot: 'Perfekte',
    filterSlots: 'Filtrer slots',
    planningCompleted: 'Ferdig',
    completeWithLastSent: '{{label}} (sist sendt: {{time}})',
    addMapArea: 'Velg område i kart',
    editMapArea: 'Endre område i kart'
  },
  login: {
    heading: 'Logg Inn',
    phone: 'Tast inn ditt Glow registerte telefonnummer, med landkode (f.eks. +47 ...), og vi sender SMS kode',
    code: 'Vi har sendt deg en SMS kode, dersom ditt nummer er registrert. Denne koden er gyldig i 5 minutter. Tast inn koden.',
    requestNewCode: 'Be om en ny kode.',
    verifyFailed:
      'Kode eller telefonnummer er feil, eller du har forsøkt å logge inn for mange ganger. Prøv igjen, eller be om ny kode.',
    requestFailed: 'Kunne ikke sende kode, prøv igjen..',
    verifyTokenButton: 'Verifiser kode',
    requestTokenButton: 'Be om kode',
    privacyLink: 'Personvernerklæring',
    passwordWrong: 'Feil passord',
    customer: 'Jeg er en kunde',
    forgotPassword: 'Glemt passordet?',
    tryApp: 'Prøv den nye appen!',
    appDownload: 'Last ned sjåfør-appen her og få tilgang til mere funksjonalitet!',
    appInfo:
      'Er du en sjåfør med en Android-telefon? Last ned sjåfør-appen <1>her</1> og få tilgang til mere funksjonalitet!',
    webApp: 'Webapp',
    note: 'Merk! Bruk bare webversjonen av budprogrammet hvis du av en eller annen grunn ikke kan bruke appene til iOS og Android',
    resendToken: 'Send kode på nytt',
    submitPassword: 'Send inn passord',
    loginAsCustomer: 'Logg inn som kunde',
    loginAsPlanner: 'Logg inn som planlegger',
    loginAsPartnerOrPhoneNumber: 'Logg inn som partner',
    loginWithPhoneNumber: 'Logg inn med telefonnummer',
    loginUsingSSO: 'Logg inn med Posten-konto',
    partnerLoginTitle: 'Innlogging med telefonnummer er for partnere',
    partnerLoginBody:
      'Kun partnerbrukere kan logge inn med telefonnummer. Som Glow- og Bring-ansatt, bruk <pageLink>denne siden</pageLink>.',
    ssoLoginFailed: 'Kunne ikke logge deg inn. Kontakt Posten og Bring servicedesk hvis problemet vedvarer.',
    token: 'Kode',
    password: 'Passord',
    tokenRequired: 'Kode kreves',
    forgotPasswordDescription:
      'For å fortsette må du angi et passord. Vi sender deg en e-post med en lenke for å angi dette. Hvis e-postadressen din er endret, må du kontakte en administrator for å endre den.,',
    sendEmailDescription:
      'For å fortsette trenger vi e-posten din. Vi sender deg en bekreftelseslenke til den oppgitte adressen. Med denne lenken kan du angi 2-faktor passord.',
    emailFormatValidation: 'E-post må være i gyldig format,',
    sendEmailSuccess: 'E-posten skal komme innen kort tid',
    sendEmailFailed: 'Sending av e-post mislyktes, prøv igjen',
    setYourPassword: 'Angi passordet ditt',
    sendEmail: 'Send e-post',
    passwordsDontMatch: 'Passord stemmer ikke',
    passwordNotMeetRequirements: 'Passord oppfyller ikke kravene,',
    passwordRequired: 'Passord er påkrevd,',
    newPassword: 'Nytt passord',
    repeatPassword: 'Gjenta passordet ditt',
    lowercaseLetter: 'En liten bokstav',
    uppercaseLetter: 'En stor bokstav',
    numberCharacter: 'Et tall',
    minimumCharacters: 'Minimum 15 tegn',
    passwordDescription: 'Du kan nå angi passordet ditt, det må inneholde følgende'
  },
  error: {
    '404Title': 'Fant ikke siden',
    '404Message': 'Siden du leter etter er ikke tilgjengelig',
    '500Message': '{{error}} - Beklager, men vi får ikke tak i dine data... prøver igjen om litt..',
    title: 'Noe gikk galt!',
    dateRequiredWhenSecureLogin: '*Obligatorisk felt om BankID er aktivert',
    dateNotValid: 'Ugyldig dato',
    dateCannotBeInFuture: 'Datoen kan ikke være fram i tid',
    dateCannotBeInThePast: 'Datoen kan ikke være tilbake i tid',
    dateCannotBeOlderThanMonths: 'Datoen kan ikke være mer enn {{months}} måneder gammel',
    dateOutsideRange: 'Dato utenfor gyldig område',
    errorMessage: 'Beklager! Dette gikk ikke bra, men utviklerne har fått beskjed om feilen..',
    errorClickToReload: 'Trykk her for å laste siden på nytt',
    phoneNumber: 'Du må angi en gyldig telefonnummer, f.eks. +47 12345678',
    phoneNumberPrefix: 'Du må angi en landkode, f.eks. +47 ...',
    somethingWentWrong: 'Noe gikk galt.',
    andMoreErrors_one: 'og {{count}} feil til',
    andMoreErrors_other: 'og {{count}} feil til',
    notAValidNumber: 'Må være et nummer',
    notAValidAlphaNumeric: 'Må være tall og/eller bokstaver',
    notAValidDate: 'Må være en gyldig dato (yyyy-mm-dd)',
    notAValidTime: 'Må være et gyldig klokkeslett (hh:mm)',
    notAValidDuration: 'Må være en gyldig varighet (mm:ss)',
    notAValidZipCode: 'Må være et gyldig postnummer',
    notAValidPostalCodeRange: "'Fra postnummer' må være mindre enn eller lik 'Til postnummer'",
    notAValidTimezone: 'Må være en gyldig tidssone. Prøv "Europe/Oslo" eller lignende',
    somethingWentWrongOnTheServer: 'Noe gikk galt på serveren...',
    somethingWentWrongWithTheRequest: 'Noe gikk galt med operasjonen...',
    somethingWentWrongWithTheResponse: 'Noe gikk galt med operasjonen...',
    selectAtLeastOne: 'Du må velge minst ett av valgene',
    requiredBreakDuration: 'Du må angi pausevarighet',
    notAValidTimeWindow: 'Den tidligste pausen må starte før den seneste',
    requiredEarliestStartBreak: 'Du må angi tidligste pause',
    requiredLatestStartBreak: 'Du må angi seneste pause',
    requiredIfWorkingTimeDuration: 'Du må angi maksimal arbeidstid',
    timeInWrongFormat: 'Tiden er ikke gyldig',
    invalidEmail: 'Du må oppgi en gyldig e-postadresse, f.eks. name@gmail.com',
    invalidUrlParameterCombination: 'Denne kombinasjonen av URL-parametere er ugyldig og siden kan ikke vises',
    numberCannotContainDecimals: 'Tallet kan ikke inneholde desimaler',
    selectAtLeastOneItem: 'Minst ett element må velges',
    mustSelectDepartment: 'Du må velge en avdeling',
    mustSelectRoute: 'Du må velge en rute',
    mustProvideLabel: 'Du må oppgi {{label}}',
    sizeMustBeAnIntegerGreaterThanZero: 'Størrelsen må være et tall uten desimaler som er større enn eller lik 1'
  },
  loading: 'Vi henter dataene dine...',
  newAppVersion: 'Vi har akkurat lagt ut en ny versjon, den lastes nå.',
  loadingReceiptList: 'Kvitteringslister blir generert...',
  invoicing: { departmentInvoicingInProgress: 'Fakturering pågår...' },
  months: {
    january: 'Januar',
    february: 'Februar',
    march: 'Mars',
    april: 'April',
    may: 'Mai',
    june: 'Juni',
    july: 'Juli',
    august: 'August',
    september: 'September',
    october: 'Oktober',
    november: 'November',
    december: 'Desember'
  },
  weekdays: {
    monday: 'Mandag',
    tuesday: 'Tirsdag',
    wednesday: 'Onsdag',
    thursday: 'Torsdag',
    friday: 'Fredag',
    saturday: 'Lørdag',
    sunday: 'Søndag'
  },
  weekdaysShort: {
    sunday: 'Søn',
    monday: 'Man',
    tuesday: 'Tir',
    wednesday: 'Ons',
    thursday: 'Tor',
    friday: 'Fre',
    saturday: 'Lør'
  },
  notifications: {
    dismiss: 'Lukk',
    dismissAll: 'Lukk alle',
    dismissAllNotifications: 'Fjerne alle varsler?',
    error: 'Feil',
    reload: 'Last inn på nytt',
    reloadCourier: 'Trykk her for å laste på nytt',
    navigate: 'Gå til siden',
    networkError:
      'Det ser ut til at du har mistet nettverketstilkoblingen, dette kan ha vært midlertidig, men siden må lastes på nytt',
    networkErrorCourier: 'Du har vært uten nettverk, last siden på nytt.',
    liveUpdatesPaused: 'Direkteoppdateringer satt på pause',
    liveUpdatesDescription:
      'Direkteoppdateringer ble satt på pause mens fanen var inaktiv. Klikk for å laste inn på nytt og bruke de nyeste oppdateringene.'
  },
  grid: {
    columns: {
      addressWashRecipientId: 'Mottaker ID',
      addressWashAddressId: 'Adresse ID',
      department: 'Avdeling',
      deadline: 'Frist',
      failedReason: 'Feilmelding',
      exceptions: 'Unntak',
      dispatchAsGroup: 'Dispatch som gruppe',
      name: 'Navn',
      senderName: 'Avsenders navn',
      puearly: 'PU',
      pulate: 'PU',
      delearly: 'LEV',
      dellate: 'LEV',
      vas: 'VAS',
      zip: 'Postnr',
      type: 'Type',
      estimated: 'Estimert tid',
      estimatedDepartureTime: 'ETD',
      adjusted: 'Justert',
      timeWindow: 'Tidsvindu',
      onCar: 'på enhet',
      frequency: 'Frekvens',
      startDate: 'Startdato',
      endDate: 'Sluttdato (valgfritt)',
      from: 'Fra',
      to: 'Til',
      days: 'Dager',
      holidays: 'Helligdager',
      startdate: 'Startdato',
      enddate: 'Sluttdato',
      orders: 'Ordre',
      id: 'ID',
      shipmentId: 'Sendingsnummer',
      packageId: 'Kollinummer',
      errorMessage: 'Feilmelding',
      customer: 'Kunde',
      pickup: 'Opphenting',
      delivery: 'Levering',
      service: 'Tjeneste',
      address: 'Adresse',
      zipcode: 'Postnummer',
      area: 'By',
      weight: 'Vekt',
      volume: 'Volum{{unit}}',
      bookedWeight: 'Bestilt vekt{{unit}}',
      bookedVolume: 'Bestilt volum{{unit}}',
      qty: 'Ant',
      preplanned: 'Planlagt',
      preplannedRouteTemplate: 'Rute',
      group: 'Gruppe',
      totalOrders: 'Totalt antall',
      ordersFailed: 'Ordre feilet',
      date: 'Dato',
      finished: 'Ferdig',
      failed: 'Feilet',
      ordersInvoiced: 'Ordre fakturert',
      start: 'Start',
      stop: 'Stopp',
      pickupContactPerson: 'Kontaktperson henting',
      pickupPhone: 'Telefon henting',
      deliveryContactPerson: 'Kontaktperson levering',
      deliveryPhone: 'Telefon levering',
      deliveryAddress: 'Leveringsadresse',
      deliveryTime: 'Leveringstid',
      contactPerson: 'Kontaktperson',
      phone: 'Telefon',
      email: 'E-post',
      deliveryReferencePlaceholder: 'Mottakers referanse',
      specificationDescriptionPlaceholder: 'Forsendelsesinformasjon',
      multileg: 'Multileg',
      groupName: 'Gruppenavn',
      customerNumber: 'Kundenummer',
      orderNote: 'Intern merknad',
      returned: 'Returnert',
      price: 'Pris',
      slotName: 'Rute',
      estimatedArrivalTime: 'ETA',
      waitingTime: 'Ventetid',
      timeOfDelivery: 'ToD',
      timeOfPickup: 'Hentetidspunkt',
      deliveryEtaSmsSentAt: 'Leverings ETA-SMS sendt',
      trip: 'Tur',
      addresses: {
        title: 'Adresser',
        search: 'Adressesøk',
        searchAddresses: 'Søk etter adresser',
        filterAddresses: 'Filtrer adresser',
        deleteConfirmation: 'Er du sikker på at du vil slette denne adressen?',
        deleteMultipleConfirmation: 'Er du sikker på at du vil slette alle valgte adresser?',
        deleteSuccess: 'Adresse slettet',
        deleteMultipleSuccess: 'Adresser slettet',
        delete: 'Slett',
        name: 'Navn',
        phone: 'Telefonnummer',
        address: 'Adresse',
        zipArea: 'Poststed',
        zipCode: 'Postnummer',
        country: 'Land',
        contactPerson: 'Kontaktperson',
        instructions: 'Instruksjoner',
        deleteAddress: 'Slett adresse',
        deleteMultipleAddresses: 'Slett adresser ({{count}})',
        loc: 'Sted',
        locTitle: 'Vis på kartet'
      },
      orderGrid: { vehicleType: 'Kjøretøy', extraInfo: 'Ekstra info' },
      dispatch: {
        adjusted: 'Justert',
        customerName: 'Kunde',
        estimatedDepartureTime: 'ETD',
        service: 'Tjeneste'
      },
      goodsType: 'Godstype',
      orderSource: 'Ordrekilde',
      postalCodes: '# postnumre',
      displayEndCustomerPriceShd: 'Vis kundepris',
      courier: 'Sjåfør',
      createdBy: 'Opprettet av',
      createdAt: 'Opprettet',
      plannedDeliveryDate: 'Planlagt dato',
      orderedDeliveryDate: 'Bestilt dato',
      lastUpdatedAt: 'Sist oppdatert',
      route: 'Rute',
      instructions: 'Instruksjoner',
      pickupDuration: 'PU varighet',
      deliveryDuration: 'LEV varighet',
      pickupPreparation: 'PU forberedelse',
      deliveryPreparation: 'LEV forberedelse',
      originalPickupAddress: 'Opprinnelig avsenderadresse',
      originalPickupZipCode: 'Opprinnelig avsenderpostnummer',
      originalPickupZipArea: 'Opprinnelig avsendersted',
      originalPickupCountry: 'Opprinnelig avsenderland',
      originalDeliveryAddress: 'Opprinnelig leveringsadresse',
      originalDeliveryZipCode: 'Opprinnelig leveringspostnummer',
      originalDeliveryZipArea: 'Opprinnelig leveringssted',
      originalDeliveryCountry: 'Opprinnelig leveringsland',
      packagesArrivedAtDip: 'Ankommet',
      packagesCollected: 'Hentet',
      packagesDelivered: 'Levert',
      originalDeliveryEarliest: 'Opprinnelig LEV',
      originalDeliveryEarliest1: 'Opprinnelig LEV 1',
      originalDeliveryLatest: 'Opprinnelig LEV',
      originalDeliveryLatest2: 'Opprinnelig LEV 2',
      preAdvices: 'Preaviseringsforsøk',
      preAdviceScheduledDate: 'Første preaviseringsdato',
      hasPreAdviceSettings: 'Preaviseringsregler',
      arrivedAtHub: 'Ankommet HUB',
      returnToSender: 'Retur til avsender',
      preAdviceFailed: 'Mislykket',
      deliveryAttempts: 'Leveranseforsøk',
      shipmentCreationDate: 'Sending opprettet dato',
      preAdviceResult: 'Preaviseringsresultat',
      failedPreAdviceDate: 'Dato for mislykket preavisering',
      loadCarrierId: 'Lastbærer-id',
      deliveryPupUnitId: 'PUP ID',
      loadCarrier: 'Lastbærer',
      pickupZipCode: 'Hentepostnummer',
      pickupArea: 'Hentepoststed',
      deliveryZipCode: 'Leveringspostnummer',
      deliveryArea: 'Leveringspoststed',
      plannedStops: 'Planlagte stopp'
    },
    columnSettings: {
      header: 'Legg til kolonner i datatabellen',
      description: 'Når du velger en etikett, vises denne informasjonen i datatabellen'
    }
  },
  openBooking: {
    error: {
      pickupTimeNotWithinServiceTimeWindow: 'Hentetiden er ikke innenfor tjenestetidsvinduet',
      pickupTimeBeforeEarliestServicePickupTime: 'Hentetiden kan ikke være før den tidligste hentetiden for tjenesten',
      pickupNotAvailableForWeekend: 'Hentetjeneste er ikke tilgjengelig i helgene',
      invalidOrganisationNumber: 'Ugyldig organisasjonsnummer'
    }
  },
  instant: {
    title: 'Dispatching',
    openMap: 'Åpne kart',
    group: 'Grupper valgte',
    editGroup: 'Endre gruppe',
    groupName: 'Gruppenavn',
    groupOrders: 'Grupper ordre',
    viewGroup: 'Vis gruppe',
    ordersToGroup: 'Ordre i gruppen',
    fixedOrder: 'Fast leveringsrekkefølge',
    saveFixedOrder: 'Lagre endringer i rekkefølge',
    paidTogether: 'Betales sammen',
    saveGroup: 'Lagre gruppe',
    ungroup: 'Avgrupper',
    removeSelected: 'Fjern valgte',
    split: 'Splitt valgte',
    noCourierSelected: 'Ingen sjåfør valgt',
    noOrderSelected: 'Ingen ordre valgt',
    workingHours: 'Arbeidstid',
    chatButton: 'Chat med sjåfør',
    offeredShipments: 'Tilbudte leveringer',
    rejectedShipments: 'Avviste leveringer',
    rejectedShipmentsSnackbar: '{{count}} avvist levering av "{{name}}"',
    rejectedShipmentsSnackbar_other: '{{count}} avviste leveringer av "{{name}}"',
    toBeDone: 'Leveringer som skal gjøres',
    finishedRoutePoints: 'Fullførte leveringer',
    suggestedRouteApplied: 'Foreslått rute lagret',
    suggestedRouteCancelled: 'Foreslått rute slettet',
    reorderValidationError: 'Foreslått rute er ikke gyldig',
    planSlot: 'Planlegg rute',
    createRoute: {
      vehiclePlaceholder: 'Ingen kjøretøy valgt',
      title: 'Velg kjøretøy for å opprette ny rute',
      description:
        'Denne enheten er ikke koblet til en rute ennå. Når de valgte sendingene legges til denne enheten, opprettes en ny rute. Velg et kjøretøy for ruten.'
    },
    columnSettings: {
      reset: 'Nullstill',
      settings: 'Innstillinger',
      hideColumns: 'Vis kolonner',
      saveAndClose: 'Lagre og lukk'
    },
    routePoint: {
      pickup: 'H',
      delivery: 'L',
      depot_call: 'PS',
      start: 'S',
      end: 'E'
    },
    confirmation: {
      heading: 'Ordrebekreftelse',
      from: 'Fra',
      to: 'Til',
      service: 'Tjeneste',
      pickup: 'Henting',
      delivery: 'Levering',
      shipmentNumber: 'Sendingsnummer',
      printLabel: 'Skriv ut merkelapp',
      copyOrder: 'Kopier ordre',
      editOrder: 'Rediger ordre'
    },
    goods: {
      custom: 'Egendefinert',
      letter: 'Brev',
      bag: 'Pose',
      smallbox: 'Liten boks',
      mediumbox: 'Mellomstor boks',
      largebox: 'Stor boks',
      tube: 'Rør',
      quarterpallet: 'Kvartpall',
      halfpallet: 'Halvpall',
      fullpallet: 'Pall',
      suitcase: 'Koffert',
      movingbox: 'Flytteeske',
      trolley: 'Vogn',
      parcel: 'Løs kolli',
      expressbox: 'Express boks',
      '9A': 'Rullebur pakker, gods',
      '9C': 'Rullebur tom',
      '9F': 'Halvpall  brev',
      '9J': 'Pall brev',
      PX: 'Pall',
      PA: 'Pakke',
      AF: 'Halvpall',
      SA: 'Sekk',
      CS: 'Kassett',
      '9N': 'Monsterbur, pakker',
      '9O': 'Monsterbur, tomt',
      '9B': 'Rullebur brev',
      '9D': 'Rullebur annet',
      '9E': 'Halvpall  pakker, gods',
      '9G': 'Halvpall  tom',
      '9H': 'Halvpall  annet',
      '9I': 'Pall pakker, gods',
      '9K': 'Pall tom',
      '9L': 'Pall annet',
      '9M': 'Brev stykk',
      '9P': 'IKEA TU lang',
      '9Q': 'IKEA TU kort',
      '9Z': 'Ukjent volum',
      BE: 'Bunt',
      BG: 'Pose',
      BX: 'Boks',
      CD: 'Kanne',
      CL: 'Kveil',
      CN: 'Kontainer',
      CR: 'Kasse',
      CT: 'Kartong',
      CW: 'Rullebur',
      DR: 'Fat',
      ED: 'Pallekasse',
      LT: 'Parti',
      OA: 'Kvartpall',
      OC: 'Sjø-pall',
      OT: 'Bulkboks',
      PB: 'Palleboks',
      PC: 'Pakke',
      PE: 'Pall modulær',
      PI: 'Rør',
      PK: 'Kolli',
      PP: 'Stykk',
      PV: 'Rørbunt',
      RK: 'Reol',
      RO: 'Rull',
      RV: 'Rek Verdi',
      SE: 'Semibeholder',
      TY: 'Tank, sylindrisk',
      VB: 'Vekselbeholder',
      Z1: 'Bisonpall',
      Z2: 'Blomsterbur',
      Z3: 'Bananpall',
      Z4: 'Fruktbur',
      Z5: 'Pall lav',
      Z6: 'Pall Rema',
      Z8: 'Melkegrind',
      ZZ: 'Ukjent'
    },
    instantGrid: {
      editColumnTooltip: 'Trykk for å redigere',
      deleteColumnTooltip: 'Trykk for å slette sending',
      unassignColumnTooltip: 'Trykk for å ta sending av enhet',
      dragColumnTooltip: 'Klikk og dra for å tildele',
      filtersActive: 'Aktive filtre',
      clearFilters: 'Fjern alle filtre',
      filterPlaceholder: 'filtrer <enter>',
      assignColumnTooltip: 'Klikk for å tildele sendingen'
    },
    booking: {
      numberOfCopies: 'Antall kopier',
      numberOfCopiesPlaceholder: 'Fyll inn et tall mellom {{min}} og {{max}}',
      numberOfCopiesError: 'Du må fylle inn et tall mellom {{min}} og {{max}}',
      afterCutoffWarning:
        'Levering ikke tilgjengelig - frist kl. {{cutoffTime}} i dag er passert. Velg en annen tjeneste eller leveringsdag.',
      standaloneInvoiceCheckbox: 'Marker som separat faktura',
      standaloneInvoiceDescription:
        'Ved å velge dette alternativet vil denne orderen bli behandlet individuelt og ikke bli gruppert med andre ordre for fakturering.',
      addPackage: 'Legg til ny pakke',
      removePackageRow: 'Fjern pakke',
      cannotRemoveLastPackageRow: 'Kan ikke fjerne siste pakke',
      copyPackageRow: 'Kopier pakken',
      title: 'Booking',
      header: 'Booking',
      headerCreate: 'Ny ordre',
      headerEdit: 'Rediger av ordre',
      headerCopy: 'Kopier ordre',
      headerRestore: 'Gjenopprett ordre',
      customer: 'Kunde',
      customerPlaceholder: 'Kunde id',
      subcustomerPlaceholder: 'Underkunde',
      invalidSubcustomer: 'Subcustomer-navn er ugyldig',
      invoiceSplitPlaceholder: 'Faktura splitting',
      invoiceSplitPlaceholderLegend: 'Velg faktura splitting',
      shipmentOrPackageId: 'Sendingsnummer eller kollinummer',
      creditBlockedCustomer: 'Kredittsperret kunde',
      sender: 'Avsender',
      setAsDefaultAddress: 'Sett som standardadresse',
      setAsDefaultDisabledText: 'Mangler koordinater. Angi adressen ved hjelp av adressesøkefeltet',
      defaultAddressUpdated: 'Standardadresse oppdatert',
      recipient: 'Mottaker',
      pickupNamePlaceholder: 'Navn',
      pickupAddressPlaceholder: 'Addresse',
      pickupZipCodePlaceholder: 'Postnummer',
      pickupZipAreaPlaceholder: 'Poststed',
      pickupCountryPlaceholder: '-- Velg land --',
      pickupPhoneNumberPlaceholder: 'Telefon',
      pickupContactPerson: 'Kontaktperson',
      customerReference: 'Kundereferanse',
      pickupReferencePlaceholder: 'Kundereferanse – dette feltet er synlig på kundens faktura',
      pickupInformationPlaceholder: 'Henteinformasjon',
      pickupEmailPlaceHolder: 'E-post',
      customerContact: 'Kontaktperson hos kunden',
      customerContactPlaceholder: '$t(instant.booking.customerContact) – dette feltet er synlig på kundens faktura',
      customerInfoPlaceholder: 'Generell kundespesifikk informasjon',
      customerInfoHelper:
        'Denne informasjonen er knyttet til kunden. Endringer som blir gjort vil være synlig for alle ordre relatert til denne kunden.<br><br>For å legge til ordrespesifikk informasjon, bruk «notater» feltet under.',
      deliveryNamePlaceholder: 'Navn',
      letterBoxPrefix: 'Postkasse',
      letterBoxAlt: '{{operator}} postkasse',
      deliveryAddressPlaceholder: 'Addresse',
      deliveryZipCodePlaceholder: 'Postnummer',
      deliveryZipAreaPlaceholder: 'Poststed',
      deliveryCountryPlaceholder: '-- Velg land --',
      deliveryPhoneNumberPlaceholder: 'Telefon',
      deliverySecondPhoneNumberPlaceholder: 'Telefon 2',
      deliveryEmailPlaceHolderPlaceholder: 'E-post',
      deliveryReferencePlaceholder: 'Mottakers referanse',
      deliveryInformationPlaceholder: 'Leveringsinformasjon',
      invalidInvoiceSplit: 'Ugyldig fakturaoppdelingstekst',
      orderNote: 'Intern merknad',
      clearData: 'Slett data',
      deliveryContactPerson: 'Kontaktperson',
      dimensions: 'Forsendelse',
      weightPlaceholder: 'Vekt (kg)',
      lengthPlaceholder: 'Lengde (cm)',
      widthPlaceholder: 'Bredde (cm)',
      heightPlaceholder: 'Høyde (cm)',
      specificationDescription: 'Forsendelse',
      specificationDescriptionPlaceholder: 'Forsendelsesinformasjon',
      service: 'Tjeneste',
      serviceSelect: 'Velg tjeneste',
      serviceSelectDisabled: 'Endring av tjenester på HD ordre må gjøres i HappyFlow',
      deliveryOrderService: {
        description: 'Bringeordre'
      },
      goodsEditDisabled: 'Endringer på gods på HD ordre må gjøres i HappyFlow',
      standardServices: '-- STANDARD TJENESTER --',
      customizedServices: '-- KUNDESPESIFIKKE TJENESTER --',
      serviceCode: 'Tjenestekode',
      servicePlaceholder: 'Tjenestekode',
      invoiceInfo: 'Fakturainformasjon',
      invoiceInfoPlaceholder: 'Fakturainformasjon – denne teksten er synlig på kundens faktura',
      manualInvoiceInfo: 'Manuell fakturahåndtering',
      manualInvoiceInfoPlaceholder:
        'Manuell fakturahåndtering (Hvis dette feltet er fylt ut vil ordren måtte faktureres manuelt)',
      pickup: 'Henting',
      delivery: 'Levering',
      pickupDatePlaceholder: 'Hentedato',
      pickupTimePlaceholder: 'Hentetid',
      deliveryDatePlaceholder: 'Leveringsdato',
      deliveryTimePlaceholder: 'Leveringstid',
      restoreButton: 'Gjenopprett',
      orderButton: 'Bestill',
      editButton: 'Oppdater',
      copyButton: 'Bestill',
      created: 'Ordren er registrert',
      edited: 'Ordren er oppdatert',
      quickSelect: 'Hurtigvalg',
      volume: 'Volum',
      points: 'Poeng',
      totalVolume: 'Totalt volum {{volume}}',
      totalWeight: 'Totalvekt {{weight}}',
      removeItem: 'Fjern',
      copyItem: 'Kopier',
      addItem: 'Legg til',
      calculatePrice: 'Beregn pris',
      priceExplanations: {
        header: 'Prisforklaring',
        article: 'Artikkel: {{article}}',
        priceListName: 'Prisliste:: {{pricelist}}',
        explanations: 'Forklaringer',
        noInfo: 'Ingen prisinformasjon tilgjengelig',
        details: 'Detaljer',
        notFound: 'Ingen prisforklaring tilgjengelig.'
      },
      approveIncompletePrice: 'Jeg godkjenner alle rader med nullpris',
      muteBomArticles: 'Ekskluder {{bomArticle}} fra fakturering',
      prePlan: 'Planlegg',
      prePlannedToCourier: 'Velg sjåfør',
      prePlannedToRouteTemplate: 'Velg rute',
      prePlannedToRouteText:
        'Tilgjengelige ruter avhenger av malene som er lagret på avdelingen. For at automatisk ruting skal fungere riktig, må du konfigurere ruteinnstillinger <0>på avdelingsnivå</0> på administrasjonssidene.',
      automaticDepartment: 'Automatisk',
      departmentLabel: 'Avdeling',
      notifications: 'Varsler',
      emailNotifications: 'E-post varslinger',
      eventRegistered: 'Registrert',
      eventPickup: 'Opphenting',
      eventDelivery: 'Levering',
      emailAddress: 'E-postadresse',
      emailRecipientText: 'Følgende e-postadresser vil motta varslinger:',
      invalidEmail: 'Ugyldig e-post',
      editIndicator: 'Rediger',
      updateIndicator: 'Uppdater',
      copyIndicator: 'Kopier',
      quantity: 'Antall',
      additionalServices: 'Tilleggstjenester',
      paymentInformation: 'Betalingsinformasjon',
      paidTogetherLabel: 'Faktureres sammen?',
      groupingLabel: 'Sendingsgruppering',
      groupIdPlaceholder: 'Unik gruppe ID',
      groupOrderPlaceholder: 'Ordningsrekkefølge',
      addRecipient: 'Legg til mottaker',
      addPickup: 'Legg til avsender',
      vehicleType: 'Kjøretøytype',
      vehicleTypeUpdated: 'Kjøretøytype oppdatert',
      selectVehicleType: 'Velg kjøretøytype',
      customerPrice: 'Kundepris',
      resourcePrice: 'Unitpris',
      priceDetails: 'Prisdetaljer',
      priceList: 'Prisliste',
      manualPrice: 'Manuell',
      total: 'Totalt',
      vehicleTypes: {
        car: 'Bil',
        bicycle: 'Sykkel',
        truck: 'Lastebil',
        van: 'Varebil',
        motorcycle: 'Motorsykkel',
        cargobike: 'Lastesykkel'
      },
      date: 'Dato',
      unNumber: 'UN-nummer',
      hazardous: 'Klasse',
      class: 'Klasse',
      group: 'Gruppe',
      netWeight: 'Netto vekt',
      name: 'Navn',
      restrictions: 'Begrensninger',
      totalPoints: 'Totale poeng',
      unacceptableMeasurementsError:
        'Målene er ikke riktige. Fyll inn alle dimensjonene korrekt, eller sørg for at alle pakkene har volum.',
      serviceMessage: 'Husk å legge til kunde for å se tilgjengelige tjenester',
      pickupTimeEarliest: 'Tidligste hentetid',
      pickupTimeLatest: 'Seneste hentetid',
      deliveryTimeEarliest: 'Tidligste leveringstid',
      deliveryTimeLatest: 'Seneste leveringstid',
      henteordre: {
        availableTimeSlots: 'Tilgjengelige tidsvinduer',
        setCustomTimes: 'Sett egendefinerte tider',
        selectAvailableTimes: 'Velg tilgjengelige tider',
        enterPickupZipCode: 'Skriv inn hente-postnummer for å se tilgjengelige tidsvinduer'
      },
      hazardousGoods: 'Farlig gods'
    },
    courierSorting: {
      title: 'Sorter etter',
      alystraId: 'Sjåfør id',
      empty: 'Tom',
      full: 'Full'
    },
    courierFilter: {
      title: 'Filtrer sjåfører',
      all: 'Vis alle',
      inactive: 'Skjul inaktive',
      offline: 'Skjul offline',
      both: 'Skjul inaktive og offline'
    },
    invoicingFilter: {
      ALL: 'Vis alle',
      INVOICED_OK: 'Vis fakturerte',
      TO_BE_INVOICED: 'Klare for fakturering',
      ORDER_CORRECTION: 'Med ordre-korreksjon',
      INVOICED_FAILED: 'Fakturert med feil'
    },
    shipmentFilter: {
      title: 'Filtrer sendinger',
      showAll: 'Vis alle',
      notCollected: 'Ikke plukket opp',
      hideAll: 'Skjul alle'
    },
    offer: {
      carEmpty: 'Enheten er tom',
      suggestedDelivery: 'Foreslått leveringsrekkefølge',
      newShipments: 'Nye sendinger',
      manualRoute: 'Manuell ruteplanlegging',
      confirmRoute: 'Bekreft rute',
      assigning: 'Tildel',
      replanning: 'Endre ruten til',
      shipmentsTo: 'sendinger til',
      shipmentTo: 'sending til'
    },
    useFlexible: 'Bruk fleksible tider',
    forceOptimizing: 'Tving leveringsrekkefølge',
    replanRoute: 'Endre ruten',
    recurring: {
      recurringOrderSaved: 'Gjentagende ordre lagret',
      executeDate: 'Utførelsesdato',
      confirmExecuteOrders: 'Er du sikker på at du vil utføre alle gjentagende ordre for {{date}}?',
      editRecurringOrder: 'Rediger gjentagende ordre',
      createRecurringOrder: 'Opprett gjentagende ordre',
      successMessage: '{{number}} sending(er) ble lagt til på valgte gjentakende grupper',
      recurringOrders: 'Gjentagende ordre',
      includedOrders: 'Inkluderte ordre',
      details: 'Detaljer',
      editOriginal: 'Rediger original',
      copyOriginal: 'Kopier original',
      notStarted: 'Ikke startet',
      executing: 'Kjører...',
      ended: 'Ferdig',
      status: 'Status',
      pending: 'Gjenstår',
      ok: 'OK',
      total: 'Totalt',
      failedOrders: 'Feilede ordre',
      exceptionsHeading: 'Unntak for ordre',
      addExceptionHeading: 'Ny unntaksperiode',
      exceptionStart: 'Start',
      exceptionEnd: 'Slutt',
      editExceptions: 'Rediger unntak',
      addRecurring: 'Gjentagende',
      addToGroup: 'Velg gjentagende gruppe',
      exceptions: 'Unntak',
      recurringOrderAddedConfirmation: 'Ordre lagt til i gruppe',
      exceptionsUpdated: 'Unntak oppdatert',
      dispatchAsGroup: 'Dispatch som gruppe',
      name: 'Navn',
      frequency: 'Frekvens',
      frequencies: {
        weekly: 'Hver uke',
        second_week: 'Annenhver uke',
        third_week: 'Hver tredje uke',
        monthly: 'Hver måned'
      },
      daysOfWeek: 'Ukedager',
      includeHolidays: 'Inkludert helligdager',
      endsNextDay: 'Slutter neste dag',
      endsNextDayExplanation:
        'Bare for ruter som går over midnatt. Starttiden er på første dag og sluttiden dagen etter.',
      endsNextDayRequiredByShipments: 'Fjern henting eller levering neste dag på sendingene før du fjerner denne',
      pickupNextDay: 'Henting neste dag',
      deliveryNextDay: 'Levering neste dag',
      nextDayExplanation: 'Vinduet starter på rutens første dag. Bare seneste tid flyttes til neste dag.',
      createBillingOrder: 'Opprett faktureringsordre',
      customerForBillingOrder: 'Kunde for faktureringsordre',
      errorBeforeToday: 'Kan ikke være før i dag',
      errorEndBeforeStart: 'Kan ikke være før startdato',
      excludedDateRanges: {
        title: 'Ekskluderte datoer',
        add: 'Legg til i listen',
        savedWithRoute: 'Ekskluderte datoer lagres når du lagrer ruten',
        ongoing: 'pågår'
      },
      startDate: 'Startdato',
      endDate: 'Sluttdato (valgfritt)',
      save: 'Lagre',
      fromDate: 'Fra dato',
      confirmDelete: 'Er du sikker på at du vil slette valgte gjentagende ordre?',
      numSelectedRoutes: '{{count}} valgt',
      deleteTemplateRoute: {
        title: 'Slett malrute',
        description: 'Denne handlingen kan ikke angres.'
      },
      deleteTemplateRoutes: {
        title: 'Er du sikker på at du vil slette {{count}} ruter?',
        description: 'Denne handlingen kan ikke angres.'
      },
      rolloutTemplateRoutes: {
        title: 'Er du sikker på at du vil rulle ut {{count}} ruter?',
        description: 'Rutene rulles ut for {{date}}.',
        alreadyRolledOut: '{{count}} av rutene er allerede rullet ut for {{date}}:',
        replaceWarning: 'Rutene og ordrene deres slettes og rulles ut på nytt. Ordrene får nye sendingsnumre.'
      },
      from: 'Fra',
      createOrders: 'Lag ordre',
      showResult: 'Vis resultat',
      showRolloutResult: 'Vis utrullingsresultat',
      rolloutProblems: 'Problemer med utrulling',
      rolloutProblemsFrom: 'Fra forrige utrulling, {{date}}',
      rolloutProblemsHandled: 'Håndterte utrullingsproblemer',
      noRolloutProblems: 'Ingen utrullingsproblemer i denne perioden',
      noOutstandingRolloutProblems: 'Alle utrullingsproblemer er håndtert',
      dealtWith: 'Håndtert',
      problems: 'Problemer',
      problemType: 'Problem',
      severityCritical: 'Kritisk',
      severityWarning: 'Advarsel',
      rangeReversed: 'Fra-datoen kan ikke være etter til-datoen',
      rangeTooLong: 'Perioden kan ikke være lengre enn {{days}} dager',
      rangeNeedsEnd: 'For å se lenger tilbake enn {{days}} dager må du også sette en til-dato',
      problemRolloutFailed: 'Utrullingen feilet',
      problemOrderNotCreated: 'Ordren ble ikke opprettet',
      problemOrderNotOnRoute: 'Ordren er ikke på ruten',
      problemStopNotOnRoute: 'Planlagt stopp er ikke på ruten',
      startdate: 'Startdato',
      enddate: 'Sluttdato',
      orders: 'Ordre',
      executionSummary: 'Utførelsesoppsummering',
      executions: 'Utførelser',
      executionStatus: 'Utførelsesstatus',
      executionId: 'Utførelse',
      templateShipment: 'Malsending',
      createdOrderId: 'Opprettet ordrenummer',
      packageIds: 'Pakkenumre',
      sentAt: 'Sendt',
      lastAttemptAt: 'Siste forsøk',
      routeConnected: 'Koblet til rute',
      optimizationRequestId: 'Optimaliseringsforespørsel-id',
      failedOptimizationRequestIds: 'Feilede optimaliseringsforespørsel-id-er',
      routeConnectedSummary: 'Koblet til rute',
      onlyWithErrors: 'Kun med feil',
      rolloutResult: {
        newView: 'Ny visning',
        oldViewNotice:
          'Denne visningen fjernes snart. Den nye visningen viser problemene fra denne datoen og fremover, gruppert etter årsak.',
        switchToNewView: 'Bytt til den nye visningen',
        earlierProblems_one: 'Det er {{count}} ubehandlet problem fra utrullingen {{date}}.',
        earlierProblems_other: 'Det er {{count}} ubehandlede problemer fra utrullingen {{date}} og fremover.',
        showEarlierProblems: 'Vis dem',
        crumb: 'Utrullingsresultat',
        title: 'Utrullingsresultat - {{date}}',
        nothingRolledOut: 'Ingenting er rullet ut fra denne datoen',
        progress: 'Utrullingsstatus',
        showProgress: 'Vis utrullingsstatus',
        processing: 'Utrulling pågår',
        processingCount: 'Fremdrift · {{processed}} av {{total}} ruter',
        done: 'Utrulling ferdig',
        doneCount: '{{processed}} av {{total}} ruter',
        routes: 'Opprettede ruter',
        createdOrders: 'Opprettede ordrer',
        stops: 'Stopp',
        failedStops: 'Feilede stopp',
        orderStatus: {
          PENDING: 'Venter',
          SENT: 'Sendt',
          CREATED: 'Opprettet',
          FAILED: 'Feilet',
          MISSING: 'Mangler'
        },
        plannedStopStatus: {
          PENDING: 'Venter',
          CONNECTED: 'Koblet',
          FAILED: 'Feilet'
        },
        unhandled: 'Ubehandlede',
        handled: 'Håndterte',
        handledToggle: 'Vis ubehandlede eller håndterte problemer',
        unhandledCount: 'Ubehandlede problemer ({{count}})',
        handledCount: 'Håndterte problemer ({{count}})',
        unhandledDescription: 'Rett feilene slik at neste utrulling ikke får de samme.',
        handledDescription: 'Problemer markert som håndtert. Marker et som ikke håndtert for å hente det tilbake.',
        unhandledEmpty: 'Ingen problemer må håndteres',
        handledEmpty: 'Ingen problemer er markert som håndtert',
        groupDescription:
          'Når du har rettet opplysningene, marker problemet som håndtert, så forsvinner det fra listen.',
        cause: {
          MISSING_CUSTOMER: {
            title: 'Mangler kundenummer',
            description: 'Kunden ble ikke funnet. Den kan være slettet eller endret.'
          },
          ORDER_NOT_CREATED: {
            description: 'Ordren kunne ikke opprettes. Se feilårsaken.'
          },
          TIME_WINDOW: {
            title: 'Tidsvindu',
            description: 'Ordren ble ikke lagt til ruten på grunn av tidsvinduet.'
          },
          MISSING_COORDINATES: {
            title: 'Mangler koordinater',
            description: 'Adressen mangler koordinater.'
          },
          CAPACITY: {
            title: 'Ikke nok kapasitet på kjøretøyet',
            description: 'Ordren fikk ikke plass på grunn av kapasitet.'
          },
          OPTIMIZATION_FAILED: {
            title: 'Optimalisering feilet',
            description: 'Ruteoptimaliseringen feilet etter flere forsøk.'
          },
          ORDER_NOT_ON_ROUTE: {
            description: 'Ordren ble opprettet, men ikke lagt til ruten. Årsaken er ikke kjent ennå.'
          },
          STOP_NOT_ON_ROUTE: {
            description:
              'Stoppet kunne ikke legges til ruten, som regel på grunn av tidsvinduet eller plasseringen. Rett det på malruten.'
          }
        },
        filterRoutes: 'Filtrer ruter',
        allRoutes: 'Alle ruter',
        routeName: 'Rutenavn',
        templateRoute: 'Malrute',
        rolledOutAt: 'Rullet ut',
        handledBy: 'Markert som håndtert av',
        selectRow: 'Velg {{route}} {{id}}',
        markAsHandled: 'Marker som håndtert',
        markAsHandledHint: 'Det forsvinner fra listen',
        markAsUnhandled: 'Marker som ikke håndtert'
      },
      rolloutView: {
        label: 'Utrullinger',
        current: 'Gjeldende',
        all: 'Alle, inkludert erstattede',
        replaced: 'Bare erstattede'
      },
      replaced: 'erstattet',
      replacedAt: 'Erstattet',
      replacedBy: 'Erstattet av',
      replacesExecution: 'Erstatter utrulling',
      templateRouteId: 'Malrute-id',
      templateRouteName: 'Malrutenavn',
      createdAt: 'Opprettet',
      updatedAt: 'Oppdatert',
      date: 'Dato',
      createdSlotId: 'Opprettet rute-id',
      createdBy: 'Opprettet av',
      failed: 'Feilet',
      by: 'Av',
      on: 'den',
      reset: 'nullstill',
      confirmReset: 'Vil du nullstille gjentagende ordre for {{date}}?',
      startDateExplanation: 'Ordre vil bli opprettet på samme dag som startdatoen',
      noOrderSelected: 'Ingen ordre valgt',
      noOrdersFound: 'Ingen ordre funnet',
      title: 'Gjentagende',
      groups: 'Grupper',
      routes: 'Ruter',
      newRoute: 'Opprett ny gjentagende rute',
      recurringRoute: 'Gjentagende rute',
      tabFrequency: 'Frekvens',
      tabRoute: 'Rute',
      tabTemplateShipments: 'Malforsendelser',
      timeQuestion: 'Hvilket klokkeslett skal ruten starte og slutte?',
      frequencyQuestion: 'Hvor ofte vil du at rutene skal rulles ut?',
      holidayRollout: 'Utrulling på helligdager',
      holidayRolloutDescription:
        'Ruter rulles ikke ut på helligdager som standard. Velg dette for å ta med helligdager i utrullingen.',
      weekdaysQuestion: 'Hvilke ukedager vil du at ruten skal levere?',
      periodQuestion: 'Når vil du at ruten skal starte og slutte?',
      routeDetails: 'Rutedetaljer',
      searchShipments: 'Søk etter sendinger',
      editShipment: 'Rediger malforsendelse',
      newTemplateShipment: 'Ny malforsendelse',
      addShipments: 'Legg til sendinger',
      saveShipment: 'Lagre sending',
      onRoute: 'På ruten',
      findYourShipmentsDescription: 'Skriv inn det du leter etter i søkefeltet ovenfor',
      saveFrequency: 'Lagre frekvensinnstillinger',
      saveRoute: 'Lagre ruteinnstillinger',
      saveShipments: 'Lagre sendinger på rute',
      shipmentsAddedToRoute: 'Sendinger lagt til på rute',
      shipmentCopied: 'Malforsendelse kopiert',
      routeCreated: 'Gjentagende rute opprettet',
      routeUpdated: 'Gjentagende rute oppdatert',
      editRoute: 'Rediger {{route}}',
      recurringRoutes: 'Gjentagende ruter',
      selectRouteWithId: 'Velg rute med id {{id}}',
      rolloutInfoConfigured:
        'Automatisk utrulling bruker avdelingens automatiske gjentagende tid {{time}} og ruller ut ruter for den påfølgende datoen.',
      rolloutInfoMissing:
        'Automatisk utrulling er ikke konfigurert for denne avdelingen fordi automatisk gjentagende tid er tom. Be en administrator om å sette dette opp.',
      addStop: 'Legg til stopp',
      days: 'Dager',
      dates: 'Datoer',
      addException: 'Legg til unntak',
      addedExceptions: 'Unntak som er lagt til',
      selectedOrders: 'Valgte sendinger',
      moveShipment: 'Flytt sending',
      moveShipmentModal: {
        errorMessage: 'Sendinger: {{shipmentIds}}, feilmelding: {{error}}',
        shipmentsMovedText: 'Sendinger {{shipmentIds}}, {{stopIds}} har blitt flyttet til rute {{route}}',
        partialSuccessMessage: '{{count}} av {{fullCount}} sendinger ble flyttet',
        title: 'Flytt valgte sending(er) til en annen rute'
      },
      changeRoute: 'Endre rute',
      viewRoute: 'Til rute',
      plannedStops: 'Planlagte stopp',
      templatePlannedStopId: 'Mal planlagt stopp',
      createdPlannedStopId: 'Opprettet planlagt stopp',
      notRouteConnected: 'Ikke på rute'
    },
    corrections: {
      title: 'Korrigeringer',
      headline: 'Ordrekorrigering for {{date}}',
      accepted: 'Korreksjon akseptert',
      rejected: 'Korreksjon avvist',
      approve: 'GODKJENN',
      decline: 'AVVIS',
      shipmentId: 'Sendingsnummer',
      courier: 'Enhet',
      from: 'Fra',
      to: 'Til',
      details: 'Detaljer',
      pickupWaitingTime: 'Ventetid opphenting (min)',
      deliveryWaitingTime: 'Ventetid levering (min)',
      pickupLoadingTime: 'Lastetid opphenting (min)',
      deliveryLoadingTime: 'Lastetid levering (min)',
      comment: 'Kommentar',
      weight: 'Vekt',
      volume: 'Volum',
      packages: 'Pakke',
      serviceCode: 'Tjenestekode',
      noOrderCorrections: 'Ingen ordrekorreksjoner',
      minutesOutOfRangeError: 'Du må fylle inn et tall mellom {{min}} og {{max}}',
      timeInMinutesWarning: 'Ugyldig tidsverdi, sjekk om den er korrekt'
    },
    dispatch: {
      assigningMultilegDelivery: 'Tildeler {{count}} multileg-levering',
      assigningMultilegDelivery_other: 'Tildeler {{count}} multileg-leveringer',
      turningThisOnExplanation: '(Når dette er slått på, kan du overstyre ruteplanen)'
    },
    suggestedUnits: {
      unitName: 'Enhetsnavn',
      driverName: 'Sjåførnavn',
      slotName: 'Rute',
      timeAtLocation: 'Tid på plassering',
      distanceFromLocation: 'Avstand fra lokasjon',
      shipmentInformation: 'Sendingsinformasjon',
      suggestedVehicles: 'Foreslåtte kjøretøy',
      suggestedVehiclesOnPickup: 'Foreslåtte kjøretøy ved opphenting',
      suggestedVehiclesOnDelivery: 'Foreslåtte kjøretøy ved levering',
      suggestedUnits: 'Foreslåtte enheter',
      noSuggestionsAvailable: 'Ingen forslag tilgjengelig',
      pickupTime: 'Opphentingstid',
      deliveryTime: 'Leveringstid',
      filterBy: 'Sorter etter'
    },
    shipmentSummary: {
      unPrePlan: 'Fjern planlegging',
      prePlanTo: 'Planlegg til'
    }
  },
  errors: {
    DIP_DESTINATION_ALREADY_MAPPED:
      'Dette utleveringsstedet er allerede koblet til en annen DIP. Last siden på nytt for å se gjeldende koblinger.',
    ALREADY_ENQUEUED_FOR_INVOICING: 'Allerede køet for fakturering',
    DEPARTMENT_INVALID_ALYSTRA_ID: 'Ugyldig avdelings-ID',
    EXPORT_DEPARTMENT_GROUP_TOO_LARGE: 'Velg en mindre avdelingsgruppe eller et kortere eksportdatointervall',
    ENTITY_DOES_NOT_EXIST: 'Entiteten eksisterer ikke',
    RECURRING_ROUTE_REROLL_OUT_DATE_NOT_IN_FUTURE: 'Faste ruter kan bare rulles ut igjen for en dato etter i dag',
    RECURRING_ROUTE_NOT_ROLLED_OUT:
      'En valgt rute er ikke rullet ut for denne datoen. Last siden på nytt og prøv igjen',
    RECURRING_ROUTE_ROLLOUT_IN_PROGRESS: 'En valgt rute rulles fortsatt ut. Vent noen minutter og prøv igjen',
    ROUTE_ALREADY_CONNECTED_TO_ANOTHER_RULE:
      'Ruten er allerede tilknyttet en annen ruteregel, oppdater siden og prøv igjen',
    INVALID_DATE_RANGE: 'Ugyldig dato tidsrom',
    INVALID_DELIVERY_LATITUDE: 'Ugyldig breddegrad',
    INVALID_DELIVERY_LONGITUDE: 'Ugyldig lengdegrad',
    INVALID_LATITUDE: 'Ugyldig breddegrad',
    INVALID_LONGITUDE: 'Ugyldig lengdegrad',
    INVALID_OR_MISSING_TIME: 'Ugyldig eller manglende tid',
    INVALID_PHONE_NUMBER: 'Ugyldig telefonnummer',
    DUPLICATE_PHONE_NUMBER: 'Duplikat telefonnummer',
    DUPLICATE_PHONE_NUMBER_COURIER: 'En sjåfør er allerede registrert med dette telefonnummeret',
    INVALID_PICKUP_LATITUDE: 'Ugyldig opphenting breddegrad',
    INVALID_PICKUP_LONGITUDE: 'Ugyldig opphenting lengdegrad',
    INVALID_SLOT_TYPE: 'Ugyldig slot type',
    MISSING_ADDRESS: 'Manglende addresse',
    MISSING_ALYSTRA_ID: 'Manglende id',
    MISSING_AREA: 'Manglende område',
    MISSING_CAPACITY: 'Manglende kapasitet',
    MISSING_COLOR: 'Manglende farge',
    MISSING_CONSIGNMENT_INPUTS: 'Manglende pakke inndata',
    MISSING_CONSIGNMENT: 'Manglende pakke',
    MISSING_CONSIGNMENTS: 'Manglende pakker',
    MISSING_COURIER_ID: 'Manglende sjåførs id',
    MISSING_COURIER: 'Du må angi sjåfør',
    MISSING_CREATED_AT: 'Manglende opprett tid',
    MISSING_CUSTOMER_ID: 'Manglende kunde id',
    MISSING_CUSTOMER_REF: 'Manglende kundereferanse',
    MISSING_DATE: 'Manglende dato',
    MISSING_DAYS: 'Manglende dager',
    MISSING_DEPARTMENT: 'Manglende kontor',
    MISSING_DESCRIPTION: 'Manglende beskrivelse',
    MISSING_DEVIATION_TEXT: 'Manglende avvikstekst',
    MISSING_END_LOCATION_LATITUDE: 'Manglende slutt-lokasjon breddegrad',
    MISSING_END_LOCATION_LONGITUDE: 'Manglende slutt-lokasjon lengdegrad',
    MISSING_EVENT_DATA: 'Manglende eventdata',
    MISSING_EVENT_TYPE: 'Manglende eventtype',
    MISSING_FILE_NAME: 'Manglende filnavn',
    MISSING_FROM_DATE: 'Manglende fra dato',
    MISSING_ID: 'Manglende id',
    MISSING_LOCATION_LATITUDE: 'Manglende lokasjon breddegrad',
    MISSING_LOCATION_LONGITUDE: 'Manglende lokasjon lengdegrad',
    MISSING_LOCATION_POSITION: 'Manglende lokasjon position',
    MISSING_LOCATION_TIME: 'Manglende lokasjon tid',
    MISSING_NAME: 'Manglende navn',
    MISSING_GROUP: 'Manglende gruppering',
    MISSING_PACKAGE_ID: 'Manglende pakke id',
    MISSING_PHONE: 'Manglende telefonnummer',
    MISSING_PLANNER_ID: 'Manglende planner id',
    MISSING_SERVICE_CODE: 'Manglende tjenestekode',
    MISSING_SHIPMENT_ID: 'Manglende shipment id',
    MISSING_SLOT_ID: 'Manglende slot id',
    MISSING_SLOT_TYPE: 'Manglende slot type',
    MISSING_SMS_TOKEN: 'Manglende sms token',
    MISSING_START_LOCATION_LATITUDE: 'Manglende start lokasjon breddegrad',
    MISSING_START_LOCATION_LONGITUDE: 'Manglende start lokasjon lengdegrad',
    MISSING_TO_DATE: 'Manglende til dato',
    MISSING_ZIP_AREA: 'Manglende poststed',
    MISSING_ZIP_CODE: 'Manglende postnummer',
    MISSING_COUNTRY_CODE: 'Manglende landkode',
    NO_SUCH_USER: 'Finner ikke bruker',
    BILLING_ORDER_AMOUNT_OUT_OF_VALID_RANGE: 'Maksimalt tillatt totalpris ({{limit, number}}) er overskredet',
    PARAM_NOT_OF_EXPECTED_TYPE: 'Parameter ikke av forventet type',
    PARAM_NULL_NOT_ALLOWED: 'Parameter null er ikke lov',
    PTW_ALREADY_EXISTS: 'Et produksjonstidsvindu finnes allerede for mottaker-ID {{recipientId}}.',
    QUERY_NAME_MISSING: 'Query navn mangler',
    QUERY_PARAMS_MISSING: 'Query params mangler',
    USER_NOT_EXIST_OR_INCORRECT_ROLE: 'Bruker eksisterer ikke eller har ugyldig rolle',
    USER_EXIST_BUT_INCOMPATIBLE_ROLE: 'Bruker eksisterer men har en annen rolle',
    SLOT_CANNOT_BE_STARTED: 'Slot kan ikke startes',
    SLOT_CANNOT_BE_DELETED: 'Slot kan ikke slettes',
    COURIER_NOT_PART_OF_DEPARTMENT: 'Sjåfør ikke den del av avdeling',
    CONSIGNMENT_IN_INCORRECT_STATE_CANNOT_UPDATE: 'Pakke i feil tilstand, kan ikke oppdatere',
    ORDER_DOES_NOT_EXISTS: 'Ordre eksisterer ikke',
    OPTIMIZE_ALREADY_RUNNING: 'Ruteoptimalisering pågår',
    CANNOT_CHANGE_ORDER: 'Kan ikke endre ordre',
    NO_ACCESS: 'Ingen tilgang',
    NO_RELEVANT_CONSIGNMENTS_OR_SLOTS: 'Ingen relevante leveringer for gitte slots',
    NO_RELEVANT_CONSIGNMENTS: 'Ingen relevante leveringer for gitte slots',
    NO_RELEVANT_SLOTS: 'Kun ruter som ikke er startet eller er satt på pause kan brukes for denne optimaliseringen',
    NOT_EQUAL_PICKUP_ADDRESSES: 'Alle henteadresser må være like for å begrense alle forsendelser til én sjåfør',
    NO_SUGGESTIONS_FOUND_FOR_ORDERS: 'Ingen sjåfører er kvalifisert for bestillingene.',
    NO_SUCH_QUERY: 'Spørringen finnes ikke',
    EXCEL_MISSING_SHIPMENT_ID: 'Manglende shipment id oppgitt i celle {{col}} på rad {{row}}',
    EXCEL_MISSING_CUSTOMER_REF: 'Manglende kundereferanse oppgitt i celle {{col}} på rad {{row}}',
    EXCEL_MISSING_CUSTOMER_ID: 'Manglende kunde id oppgitt i celle {{col}} på rad {{row}}',
    EXCEL_MISSING_DEPARTMENT: 'Manglende avdeling oppgitt i celle {{col}} på rad {{row}}',
    EXCEL_MISSING_PACKAGE_ID: 'Manglende pakke id oppgitt i celle {{col}} på rad {{row}}',
    EXCEL_MISSING_NAME: 'Manglende navn oppgitt i celle {{col}} på rad {{row}}',
    EXCEL_INVALID_PHONE: 'Ugyldig telefonnummer oppgitt i celle {{col}} på rad {{row}}',
    EXCEL_MISSING_ADDRESS: 'Manglende adresse oppgitt i celle {{col}} på rad {{row}}',
    EXCEL_MISSING_ZIP_AREA: 'Manglende postnummer oppgitt i celle {{col}} på rad {{row}}',
    EXCEL_MISSING_ZIP_CODE: 'Manglende poststed oppgitt i celle {{col}} på rad {{row}}',
    EXCEL_MISSING_FROM_DATE: 'Manglende fra dato oppgitt i celle {{col}} på rad {{row}}',
    EXCEL_MISSING_TO_DATE: 'Manglende til dato oppgitt i celle {{col}} på rad {{row}}',
    EXCEL_MISSING_NOTIFICATION_SMS: 'Manglende notifikasjons SMS oppgitt i celle {{col}} på rad {{row}}',
    EXCEL_MISSING_SIZE: 'Manglende størrelse oppgitt i celle {{col}} på rad {{row}}',
    EXCEL_MISSING_ORDERS: 'Fant ingen ordrer i regnearket.',
    EXCEL_MISSING_COUNTRY: 'Fant ikke land kode eller navn i celle {{col}} på rad {{row}}',
    EXCEL_NO_ACCESS_DEPARTMENT: 'Ingen tilgang til avdeling "{{dept_ref}}" på rad {{row}}',
    EXCEL_INVALID_FROM_DATE: 'Fra dato kan ikke være før i dag i cell {{col}} på rad {{row}}',
    EXCEL_INVALID_TO_DATE: 'Til dato kan ikke være før i dag i cell {{col}} på rad {{row}}',
    EXCEL_MISSING_DESCRIPTION: 'Manglende ordrebeskrivese i "{{cell}}" på rad {{row}}',
    EXCEL_MISSING_PICKUP_INSTRUCTIONS: 'Manglende hentebeskrivelse i "{{cell}}" på rad {{row}}',
    EXCEL_MISSING_DELIVERY_INSTRUCTIONS: 'Manglende leveringsbeskrivelse i "{{cell}}" på rad {{row}}',
    EXCEL_TOO_MUCH_DATA:
      'Rapporten er for stor. Prøv å eksportere for et smalere datointervall eller færre avdelinger.',
    MISSING_PICKUP_LOCATION_AND_TIME: 'Mangler henteadresse og tidspunkt',
    MISSING_EARLIEST_PICKUP_DATE: 'Mangler tidligste hentetidspunkt',
    MISSING_LATEST_PICKUP_DATE: 'Mangler seneste hentetidspunkt',
    MISSING_EARLIEST_DELIVERY_DATE: 'Mangler tidligste leveringstidspunkt',
    MISSING_LATEST_DELIVERY_DATE: 'Mangler seneste leveringstidspunkt',
    INVALID_EARLIEST_PICKUP_DATE: 'Ugyldig hentetidspunkt',
    INVALID_LATEST_PICKUP_DATE: 'Ugyldig hentetidspunkt',
    INVALID_EARLIEST_DELIVERY_DATE: 'Ugyldig leveringstidspunkt',
    INVALID_LATEST_DELIVERY_DATE: 'Ugyldig leveringstidspunkt',
    CANNOT_MODIFY_ORDERS_FROM_DIFFERENT_SOURCE: 'Du kan ikke overskrive ordre fra andre kilder enn Excel',
    PICKUP_EARLIEST_SHOULD_BE_BEFORE_DELIVERY_LATEST: 'Opphentingstid må være før leveransetid',
    DELIVERY_EARLIEST_SHOULD_BE_BEFORE_DELIVERY_LATEST:
      'Tidligste leveringstidspunkt må være før siste leveringstidspunkt',
    CANNOT_DELIVER_ON_A_HOLIDAY: 'Kan ikke levere på en helligdag',
    MISSING_TEMPLATE_ID: 'Mangler id på mal',
    TEMPLATE_DOES_NOT_EXIST: 'Malen finnes ikke',
    TEMPLATE_CANNOT_BE_DELETED: 'Malen kan ikke slettes',
    MISSING_TEMPLATE_SLOTS: 'Malen mangler slots',
    TEMPLATE_NAME_ALREADY_EXISTS: 'Det finnes allerede en mal med dette navnet',
    COURIER_ALREADY_EXISTS: 'Det finnes allerede en sjåfør med dette telefonnummeret',
    ORDER_EXIST_FOR_SERVICE: 'Kan ikke slette tjenesten da det eksisterer ordre tilknyttet denne',
    NO_SERVICE_FOUND: 'Legg til ny tjeneste før du tilknytter en kunde',
    CANNOT_DELETE_AS_SERVICE_EXIST: 'Fjern tilknytt til kunde før du sletter tjenesten',
    SLOT_IN_INCORRECT_STATE_CANNOT_UPDATE: 'Slot er ikke i en gyldig tilstand for denne endringen',
    GRAPHHOPPER_UNASSIGNED:
      'Klarte ikke å tildele alle leveransene (pga. tid, kapasitet eller andre faktorer), detaljer: {{details}}',
    GRAPHHOPPER_REQUEST_FAILED: 'Forespørsel om å optimere ruten feilet',
    GRAPHHOPPER_LATEST_ARRIVAL_AT_DELIVERY_AFTER_EARLIEST_DEPARTURE:
      'Siste ankomst for levering kan ikke være etter tidligste avgang - er tidsvinduet passert?',
    GRAPHHOPPER_EARLIEST_GREATER_THAN_LATEST: 'Tidligste tid kan ikke være etter seneste - er noen av tidene passert?',
    GRAPHHOPPER_PICKUP_EARLIEST_AFTER_LATEST:
      'Tidsvindu for henting for sending {{shipmentId}} kan ikke være passert ({{pickupEarliest}} - {{pickupLatest}})',
    GRAPHHOPPER_DELIVERY_EARLIEST_AFTER_LATEST:
      'Tidsvindu for levering for sending {{shipmentId}} kan ikke være passert ({{deliveryEarliest}} - {{deliveryLatest}})',
    GRAPHHOPPER_INVALID_PICKUP_LOCATION:
      "Mangler hentekoordinater for forsendelse {{shipmentId}}. Vennligst løs adressen via siden 'Angi koordinater'.",
    GRAPHHOPPER_INVALID_DELIVERY_LOCATION:
      "Mangler leveringskoordinater for forsendelse {{shipmentId}}. Vennligst løs adressen via siden 'Angi koordinater'.",
    GRAPHHOPPER_REQUEST_LIMIT_VIOLATED:
      'Grensen for antall forespørsler mot Graphhopper er nådd, prøv igjen om et minutt',
    SLOT_CANNOT_BE_EDITED: 'Slot er ikke i en gyldig tilstand for denne endringen',
    INVALID_POSTCODE_AND_COUNTRY_CODE_CANNOT_BE_HANDLED: 'Ugyldig postnummer og landkode',
    INVALID_BASIC_SERVICE_CODE: 'Ugyldig basis tjenestekode',
    INVALID_PICKUP_DATE_EARLIEST_FORMAT: 'Ugyldig format på tidligste hentedato',
    INVALID_PICKUP_DATE_LATEST_FORMAT: 'Ugyldig format på seneste hentedato',
    INVALID_DELIVERY_DATE_LATEST_FORMAT: 'Ugyldig format på seneste leveringsdato',
    INVALID_DELIVERY_DATE_EARLIEST_FORMAT: 'Ugyldig format på tidligste leveringsdato',
    INVALID_POSTAL_CODE: 'Ugyldig postnummer',
    INVALID_MEASUREMENT_UNIT: 'Ugyldig måleenhet',
    MISSING_CONSIGNMENT_SET: 'Missing consignment set',
    MISSING_UPDATE_INDICATOR: 'Mangler oppdateringsindikator',
    MISSING_CONSIGNMENT_ID: 'Mangler sendings-ID',
    MISSING_REFERENCE_NO: 'Mangler referanse-ID',
    MISSING_PACKAGE: 'Mangler pakke',
    MISSING_DELIVERY_DATE_EARLIEST: 'Mangler tidligste leveringsdato',
    MISSING_DELIVERY_DATE_LATEST: 'Missing delivery date latest',
    MISSING_CONSIGNEE: 'Mangler mottaker',
    MISSING_CONSIGNOR: 'Mangler avsender',
    MISSING_POSTAL_CODE: 'Mangler postnummer',
    MISSING_CITY: 'Mangler poststed',
    MISSING_PICKUP_DATE_LATEST: 'Mangler seneste hentedato',
    MISSING_PICKUP_DATE_EARLIEST: 'Mangler tidligste hentedato',
    MISSING_CONSIGNOR_PARTY_ID: 'Mangler avsenders part-ID',
    INVALID_CUSTOMER_NO_MAPPING: 'Ugyldig kobling av kundenummer',
    INVALID_ROUTING: 'Ugyldig ruting',
    NO_SERVICE_MATCHING_SERVICE_CODE: 'Ingen tjenester matcher tjenestekoden',
    NO_SERVICE_MATCHING_DAY_OF_WEEK: 'Ingen tjenester matcher ukedagen',
    NO_SERVICE_MATCHING_PICKUP_AND_DELIVERY_TIMES: 'Ingen tjenester matcher opphentings- og leveringstidene',
    ORDER_WAS_AFTER_CUTOFF_TIME: 'Ordren kom etter cutoff-tid',
    OPTIMUS_SERVICE_MUST_HAVE_PICKUP_AND_DELIVERY_TIMES: 'Må ha hente- og leveringstider',
    ORDER_CANNOT_BE_MOVED: 'Leveransen kan ikke flyttes, den kan ikke være koblet til en rute',
    MISSING_DESTINATION_DEPARTMENT_ID: 'Mangler mottakeravdeling',
    SHIPMENT_NOT_FOUND: 'Fant ikke sendingen',
    SHIPMENT_IN_INCORRECT_STATE: 'Sendingen er allerede tildelt en rute',
    DUPLICATE_EXCEL_IMPORT:
      'Det samme filnavnet er allerede importert til denne avdelingen i dag. Du kan se resultatene av importen <0>her</0>. Endre filnavnet hvis du vil importere igjen.',
    SHIPMENT_INVALID_QUERY:
      'Under Peak vil søk være begrenset for å sikre ytelse. Du kan søke etter alle bestillinger på en dag eller legge til et søkeparameter.',
    DURATION_IS_MORE: 'Vennligst begrens ditt søk til {{maxDuration}} dager.',
    ADDRESS_CANNOT_BE_DELETED: 'Adresse brukes som standardadresse og kan ikke slettes.',
    UNKOWN_ERROR: 'Endringer kunne ikke lagres',
    INCORRECT_STATES_OR_ASSIGNED_TO_SLOT: 'Ugyldig status eller planlagt på rute',
    CANNOT_MOVE_ORDERS: 'Kan ikke flytte ordre',
    DESTINATION_DEPARTMENT_INELIGIBLE: 'Destinasjonsavdelingen er ugyldig',
    DEPARTMENT_MISSING_ADDRESS_DETAILS: 'Avdelingen mangler adressedetaljer',
    MISSING_DELIVERY_PHONE_NUMBER: 'Telefonnummer mangler for',
    INVALID_DELIVERY_PHONE_NUMBER: 'Telefonnummeret er ikke gyldig for',
    ROLE_IN_USE: 'Rollen kan ikke fjernes siden rollen er i bruk.',
    INVALID_NAME: 'Rollenavnet må være unikt. En rolle med dette navnet eksisterer allerede.',
    BANNER_ALREADY_EXISTS: 'Bannernavn må være unikt. Et banner med dette navnet finnes allerede.',
    BANNER_NAME_TOO_BIG: 'Bannernavn er for langt. Det skal være maks 200 tegn.',
    CMS_NEWS_ALREADY_EXISTS:
      'Navnet på oppdateringen må være unikt. Det finnes allerede en oppdatering med dette navnet.',
    CMS_NEWS_NAME_TOO_BIG: 'Navnet på oppdateringen er for langt. Det skal være maks 200 tegn',
    INVALID_CMS_NEWS_NAME: 'Ugyldig navn på oppdateringen',
    TEXT_CANNOT_BE_DELETED:
      'Teksten brukes på en tjeneste og kan ikke slettes. Koble teksten fra tjenesten for å slette den.',
    INVALID_INVOICING_STATUS: 'Bestillingen har en status som ikke er gyldig for fakturering',
    ORDER_NOT_READY_FOR_INVOICING: 'Bestillingen er ikke klar for fakturering',
    ORDER_IS_PAUSED_FROM_INVOICING: 'Bestillingen er satt på pause for fakturering',
    ORDER_IS_EXCLUDED_FROM_INVOICING: 'Bestillingen er ekskludert fra fakturering',
    MISSING_ORDER_CORRECTION: 'Bestillingen mangler en korrigering',
    INVALID_MULTILEG_STATE_FOR_INVOICING: 'Det er bestillinger i multileg-gruppen som ikke er klare for fakturering',
    DUPLICATE: 'Dupliserte data',
    MISSING_DEPARTMENT_DETAILS:
      'Avdelingen har ikke område- og postnummerinformasjon. Vennligst legg til dette før du fortsetter.',
    INVALID_BANNER_NAME: 'Ugyldig bannernavn.',
    INVALID_WHATS_THIS_NAME: 'Ugyldig Hva er dette-modalnavn.',
    INVALID_CREDIT_ORDER: 'Kan ikke kreditere en ordre som ikke har blitt fakturert eller allerede er kreditert.',
    OVERLAPPING_BANNERS: 'URL overlapper med en eksisterende banner.',
    OVERLAPPING_WHATS_THIS_MODALS: 'URL overlapper med en eksisterende Hva er dette-modal.',
    noOrdersForDateAndCourier: 'Ingen bestillinger for den valgte datoen og enheten.',
    INVALID_ORDER_BILLING_CUSTOMER_NUMBER:
      '{{locale}}Faktureringskundenummer for type - {{orderBillingType}} er null eller ugyldig',
    MISSING_ORDER_BILLING_TYPE: 'Manglende ordre faktureringstype.',
    INVALID_ORDER_BILLING_TYPE:
      'Ordrefaktureringstype må være en av {{orderBillingTypes}}, men var - {{orderBillingType}}.',
    INVALID_ORDER_BILLING_INFO: 'Ugyldig ordre faktureringsinformasjon.',
    SMS_SERVICE_NOT_ORDERED: 'SMS-tjeneste er ikke bestilt for.',
    CANNOT_SEND_SMS_FOR_MESTER_GRONN_FUNERAL: 'Mester Grønn-begravelse er bestilt for.',
    SLOT_ROUTED_IN_HAPPY_FLOW: 'Tidsluke er rutet i Happy Flow for.',
    SERVICE_LEVEL_SHOULD_NOT_BE_NONE: 'Tjenestenivået er ingen for.',
    SLOT_NAME_ALREADY_CREATED: 'Rutenavn finnes allerede.',
    ORDER_IN_INCORRECT_STATE: 'Ordren er i feil tilstand.',
    ORDER_IN_INCORRECT_STATE_other: 'Ordrene er i feil tilstand.',
    INVALID_PARAMETERS: 'Ugyldige parametere, {{description}}.',
    FAILED_DELETING_WEBHOOK_SUBSCRIPTION: 'Webhook-abonnement kunne ikke slettes. Prøv igjen senere.',
    DEFAULT_ROLE_ALREADY_EXISTS: 'En annen rolle {{name}} er allerede standard for samme brukertype.',
    VEHICLE_IN_USE:
      'Kjøretøyet er tilknyttet enhet {{units}} og kan ikke slettes. Fjern kjøretøyet fra enheten og prøv igjen.',
    DEPARTMENT_MATRIX_ALREADY_EXISTS: 'Bare én avdelingsmatrise støttes',
    CUTOFF_MATRIX_ALREADY_EXISTS: 'Bare én cutoff-matrise støttes',
    MISSING_ACCESS_TO_DEPARTMENTS: 'Du mangler tilgang til avdelinger {{missingDepartments}}',
    DUPLICATE_PLANNED_STOP_LOCATION_NAME:
      'Det kan ikke finnes flere planlagte stoppsteder med samme navn i en avdeling. Bruk unike navn for hvert planlagte stoppsted.',
    AREA_PINS_TOO_CLOSE:
      'Kartpunktene på ruten må være minst {{minDistanceInMeters}} meter fra hverandre. Flytt dem lenger fra hverandre.',
    DUPLICATE_TEMPLATE_ROUTE_NAME:
      'En annen gjentagende rute i denne avdelingen har samme navn. Ruter med samme navn slås sammen til én rute når de rulles ut, så velg et annet navn.',
    PLANNED_STOP_LOCATION_IN_USE:
      'Kan ikke redigere eller slette planlagte stoppsteder - [{{locations}}] som allerede er i bruk.',
    TEMPLATE_IS_DEFAULT_FOR_DEPARTMENT:
      'Malen kan ikke slettes fordi den er satt som standard for en avdeling. Vennligst endre standardmalen for avdelingen før du sletter denne malen.'
  },
  customer: {
    useTerminalAddressModalHeading: 'Bruk terminaladresse',
    useTerminalAddressModalDescription:
      '"Ja" betyr at avdelingens terminaladresse brukes når ordre opprettes. "Nei" betyr at logikken for bruk av terminaladresse hoppes over.',
    settings: {
      webhook: {
        overviewTitle: 'Webhook-konfigurasjon',
        count: '{{count}} abonnement',
        count_other: '{{count}} abonnementer',
        noSubscriptions: 'Du har ingen abonnementer for øyeblikket',
        events: {
          prefix: 'Abonnerer på ',
          all: 'alle',
          suffix: ' hendelser'
        },
        state: {
          running: 'Aktiv',
          paused: 'Pauset'
        },
        event: {
          CREATED: 'ordren er registrert',
          ROUTE_PLANNING_COMPLETE: 'leveringsruten er ferdigstilt',
          COLLECTED: 'sjåføren har hentet varene',
          DELIVERED: 'sjåføren har levert varene',
          DEVIATED: 'sjåføren har registrert avvik på ordren',
          SCANNED: 'ordren har passert transittterminal',
          ARRIVED_AT_TERMINAL: 'ordren har ankommet distribusjonsterminalen',
          DAMAGED: 'ordren er skadet',
          RETURNED: 'sjåføren har levert varene tilbake til terminalen',
          PICKUP_ETA_SMS_SENT: 'SMS med estimert ankomsttid for henting er sendt',
          ETA_SMS_SENT: 'SMS med estimert ankomsttid for levering er sendt',
          PRE_ADVICE_PULL_SMS_SENT: 'SMS med mulige leveringsvinduer er sendt',
          DELIVERY_TIME_ORDERED: 'mottakeren har valgt leveringstid',
          PRE_ADVICE_PUSH_SMS_SENT: 'SMS med bestilt leveringsvindu er sendt til mottaker',
          PICKUP_SMS_SENT: 'SMS om kommende levering er sendt til mottaker',
          APARTMENT_INFORMATION_UPDATED: 'mottakeren har oppdatert leveringsdetaljene'
        },
        create: 'Klikk på knappen for å opprette en Webhook-konfigurasjon',
        delete: {
          title: 'Slett abonnement',
          description: 'Du kan ikke angre denne handlingen',
          successfullyDeleted: 'Webhook-abonnementet ble slettet'
        },
        newOrEdit: {
          createTitle: 'Opprett ny webhook-konfigurasjon',
          editTitle: 'Rediger webhook-konfigurasjon',
          created: 'Ny webhook-konfigurasjon ble opprettet',
          updated: 'Webhook-konfigurasjonen ble oppdatert',
          endpoint: 'Endepunkt',
          endpointDescription: 'Angi URL-en som hendelsesdataene skal sendes til',
          httpAuthentication: 'HTTP Basic-autentisering',
          username: 'Brukernavn',
          password: 'Passord', // betterleaks:allow a form label, not a secret
          retryPolicy: 'Regler for nye forsøk',
          retryPolicyDescription: 'Hvis webhooken feiler, angi antall nye forsøk og ventetiden mellom dem.',
          retry: '{{count}} nytt forsøk',
          retry_other: '{{count}} nye forsøk',
          retryDescription: 'Antall nye forsøk',
          delay: {
            description: 'Ventetid før nytt forsøk',
            value: 'Vent {{seconds}} sekunder'
          },
          pause: 'Sett dette abonnementet på pause inntil videre',
          pauseTooltip:
            'Pause legger utgående hendelser i kø til abonnementet aktiveres igjen. Da sendes hendelsene i køen på nytt.',
          validation: {
            endpointError: 'Du må oppgi en gyldig URL',
            endpointRequired: 'URL er påkrevd',
            usernameRequired: 'Brukernavn er påkrevd',
            passwordRequired: 'Passord er påkrevd',
            passwordNotLongEnoughError: 'Passordet må være minst 8 tegn',
            noEventSelectedError: 'Du må velge minst én hendelse',
            retryDelayRequired: 'Ventetid før nytt forsøk er påkrevd'
          }
        }
      }
    },
    returnLastLegModalHeading: 'Opprett returben',
    returnLastLegModalDescription:
      'Å velge "ja" betyr at vi deler opp bestillingen i to ledd og legger til et returledd. "Nei" betyr at ingen returledd trenger å opprettes. "Ikke angitt" betyr at returhåndteringsregelen ikke er definert for en spesifikk kunde.',
    connectMatrices: 'Koble sammen matriser',
    customerMatrices: 'Kundematriser',
    customerMatricesIngress: 'Koble kundenummeret til eksisterende matriser.',
    useTerminalAddressUpdated: 'Status for bruk av terminaladresse er oppdatert',
    brandedTrackingModalHeading: 'Branded Tracking fakturering',
    scanToCreatePackages: {
      title: 'Skann for å opprette pakker',
      enabled: 'Aktivert',
      disabled: 'Deaktivert',
      label: 'Bruk skanning for å opprette pakker',
      details:
        'Når skanning for å opprette pakker er aktivert, må budet skanne pakkene ved henting. De skannede pakkene blir automatisk oppdatert på forsendelsen',
      success: 'Skanning for å opprette pakker er oppdatert'
    },
    invoiceSplit: {
      title: 'Fakturadeling',
      legend: 'Forklaring',
      label: 'Angi fakturadeling',
      NotSet: 'Ikke satt',
      Department: 'Avdeling',
      Service: 'Tjeneste',
      Custom: 'Egendefinert',
      columLabel: 'Navn',
      addedItems: 'Fakturaregler lagt til ({{count}})',
      newItemLabel: 'Skriv inn fakturadeling',
      existingItem: 'Teksten finnes allerede. Prøv å søke etter teksten nedenfor.',
      existingItemShort: 'Teksten finnes allerede.',
      emptyItem: 'Teksten kan ikke være tom.',
      updated: 'Fakturadeling ble lagt til'
    },
    activateNPSFromDate: 'Aktiver NPS fra dato',
    activateNPSFromDateIngress:
      'Angi en startdato for aktivering av NPS (Net Promoter Score) fra Medallia. Funksjonen krever at kunden også er satt opp i Medallia.',
    npsFromDateUpdated: 'Startdato for NPS er endret',
    AddEdit: 'Legg til/rediger',
    startTypingPlaceHolder: 'Begynn å skrive',
    findCustomer: 'Finn en kunde',
    manageCustomers: 'Administrer kunder',
    searchAndSelect: 'Søk og velg kunde',
    changeCustomer: 'Bytt kunde',
    customerPlaceHolder: 'Søk etter kunder',
    emailRecipients: 'E-postmottakere',
    smsRecipients: 'SMS-mottakere',
    addEditEmails: 'Legg til/rediger e-poster',
    addEditSms: 'Legg til/rediger SMS',
    addEditDeviations: 'Legg til/rediger avvik',
    live: 'Live',
    customer: 'Kunde',
    groups: {
      titleSingular: 'Kundegruppe',
      titleWithCount: '{{count}} kundegrupper',
      name: 'Gruppenavn',
      description: 'Beskrivelse',
      numberOfCustomers: 'Antall kunder',
      none: 'Ingen kundegrupper',
      new: 'Ny kundegruppe',
      edit: 'Rediger kundegruppe',
      searchCustomer: 'Søk kunde',
      members: 'Kunder i gruppen',
      save: 'Lagre',
      deleteConfirm: 'Slette {{name}}?',
      deleteDescription: 'Du kan ikke angre denne handlingen',
      deleted: 'Kundegruppen er slettet',
      mustProvideName: 'Du må oppgi gruppenavn',
      cannotDelete: 'Kundegruppen kan ikke slettes fordi den brukes i en aviseringsregel.'
    },
    customerTitle: 'Kunder',
    customerNo: 'Kundenr',
    name: 'Navn',
    emailToSender: 'E-post til avsender',
    emailSubscriptions: 'E-postabonnementer',
    emailToSenderDescription:
      'Angi standardvarsler for alle ordre fra dette kundenummeret, for eksempel ordreregistrering og leveringer.',
    deviations: 'Avvik',
    deviationsDescription: 'Sett opp kundespesifikke avvik i sjåførappen.',
    add: 'Legg til',
    noOrders: 'Ingen ordre i Glow',
    noOrdersDescription: 'Kundene du har tilgang til har ingen ordre i Glow',
    choose: 'Vennligst velg kunde',
    search: 'Søk',
    customerNumber: 'Kundenummer',
    customerNumberAlreadyExists: 'Kundenummeret finnes allerede',
    accountingType: 'Regnskapstype',
    accountingTags: 'Kundetags',
    isDeleted: 'Slettet',
    deletedCannotBeUsed: 'Kunden er slettet og kan ikke brukes. Velg en annen kunde.',
    scanOnPickup: {
      title: 'Skann pakker ved henting',
      ingress: 'Slå på hvis sjåføren skal måtte skanne pakker ved henting.'
    },
    searchHint: 'Søk etter leveranser basert på sendings id, kundereferanse, pakke id, leveringsnavn eller adresse',
    senderName: 'Avsendernavn',
    senderNameIngress: 'Overstyr kundenavnet som er satt i Glow når det sendes SMS-varsler.',
    addSenderName: 'Legg til avsendernavn',
    senderNameAdded: 'Avsendernavn lagt til',
    addInvoiceHDOrdersFromDate: 'Legg til startdato for fakturering av HD-ordre gjennom Glow',
    invoiceHDOrdersFromDate: 'Startdato for fakturering av HD-ordre gjennom Glow',
    invoiceHDOrdersFromDateDescription: 'Angi en dato for når Glow Pricing Engine aktiveres for HD-kunder.',
    invoiceHDOrdersFromDateAdded: 'Startdato for fakturering av HD-ordre endret',
    billingCustomerNumber: 'Faktureringskundenummer',
    billingCustomerNumberIngress: 'Overstyr fakturanummeret hvis faktureringen skal skje på et annet kundenummer.',
    addBillingCustomerNumber: 'Legg til faktureringskundenummer',
    billingCustomerNumberAdded: 'Faktureringskundenummer lagt til',
    searchPage: {
      fromDate: 'Fra dato',
      toDate: 'Til dato',
      today: 'I dag',
      tomorrow: 'I morgen',
      yesterday: 'I går',
      last30days: 'Siste 30 dager',
      plusMinus15Days: '+/- 15 dager',
      plusMinus30Days: '+/- 30 dager'
    },
    smsText: {
      title: 'Overstyr SMS-tekst',
      ingress: 'Sett opp kundespesifikke tekster i SMS-er til mottakere.',
      addEditSmsText: 'Opprett/rediger tekster',
      smsTextUpdated: 'SMS-tekst opprettet/endret',
      en: 'ENG',
      se: 'SVE',
      no: 'NOR',
      fi: 'FIN',
      dk: 'DAN',
      fr: 'FRA',
      description: 'Beskrivelse',
      smsType: 'Varslingstype',
      smsTypeTexts: {
        common: 'SMS',
        preadvice: 'Preavisering',
        pickup: 'Sporings-SMS',
        pre_pickup: 'Forhåndssend sporings-SMS',
        manual_delay: 'Manuell forsinkelse SMS',
        eta_pickup: 'ETA SMS opphenting',
        eta_delivery: 'ETA SMS levering',
        flex_delivery_confirmation: 'Flex levering SMS-bekreftelse',
        advise: 'Rådgi SMS',
        delivery_confirmation: 'Leveringsbekreftelse SMS',
        pre_advice_push: 'Push-SMS',
        pre_advice_push_for_prebooked: 'Push-SMS for forhåndsbookede kunder',
        pre_advice_push_return: 'Push retur-SMS',
        pre_advice_push_email: 'Push-e-post',
        pre_advice_push_2nd: 'Push SMS for 2. preavisering',
        pre_advice_push_2nd_email: 'Push e-post for 2. preavisering',
        pre_advice_push_return_to_sender_email: 'Push retur til avsender e-post',
        pre_advice_pull: 'Pull-SMS',
        pre_advice_pull_email: 'Pull-e-post',
        pre_advice_pull_reminder: 'Pull påminnelse-SMS',
        pre_advice_pull_reminder_email: 'Pull påminnelse e-post',
        pre_advice_pull_reminder_to_sender_email: 'Pull påminnelse til avsender e-post',
        pre_advice_pull_return_to_sender_email: 'Pull retur til avsender e-post',
        pre_advice_return: 'Returlevering SMS',
        pre_advice_return_email: 'Returlevering e-post',
        pre_advice_return_reminder: 'Returlevering påminnelse SMS',
        pre_advice_return_reminder_email: 'Returlevering påminnelse e-post',
        pre_advice_return_2nd: 'Returlevering SMS for 2. preavisering',
        pre_advice_return_2nd_email: 'Returlevering e-post for 2. preavisering',
        pre_advice_return_return_to_sender_email: 'Returlevering retur til avsender e-post',
        pre_advice_pup: 'PUP-SMS',
        pre_advice_pup_email: 'PUP-e-post',
        pre_advice_pup_reminder: 'PUP påminnelse-SMS',
        pre_advice_pup_reminder_email: 'PUP påminnelse e-post',
        pre_advice_pup_reminder_to_sender_email: 'PUP påminnelse til avsender e-post',
        pre_advice_pup_return_to_sender_email: 'PUP retur til avsender e-post',
        delivery: 'Leverings SMS',
        deviated: 'Leveringsavvik SMS',
        pre_advice_push_prebooked_recycle_sms: 'Push prebooked recycle SMS'
      }
    },
    addNPSFromDate: 'Legg til startdato for NPS',
    showNotCollected: 'Ikke lastet',
    booking: {
      pickupReady: 'Klar for henting',
      pickup: 'Hentes',
      delivery: 'Leveres',
      deliveryAvailable: 'Levering tilgjengelig',
      serviceMessage: 'Husk å legge inn både hente- og leveringsinformasjon for å se tilgjengelige tjenester',
      priceComment:
        'Du blir fakturert i henhold til din kundeavtale med Bring. Avgifter er ikke inkludert i denne prisen.',
      serviceUnavailable: 'Den valgte tjenesten er ikke tilgjengelig for postnummer {{postalCode}}',
      recipientPrice: 'Mottakerpris:',
      customerContactPlaceholder: 'Bestilt av – Dette feltet er synlig på kundens faktura'
    },
    email: {
      addToList: 'Legg til e-post i listen',
      addChangesToList: 'Legg til e-postendringer i listen',
      emailTitle: 'E-post til kunde',
      getNotificationsFor: 'Få varsler for',
      emailAddress: 'E-mail address',
      emailAddressError: 'Du må oppgi en e-postadresse',
      createdEvent: 'Registrert',
      collectedEvent: 'Henting',
      deliveredEvent: 'Levering',
      returnToSender: 'Retur til avsender',
      reminderToSender: 'Påminnelse til avsender',
      save: 'Lagre',
      email: 'E-post',
      edit: 'Rediger',
      delete: 'Slett',
      emailExists: 'E-postadressen finnes allerede',
      invalidEmail: 'Ugyldig e-postadresse',
      true: 'yes',
      false: 'no',
      claimsReported: 'Reklamasjoner meldt av mottaker',
      claims: 'Claims',
      notificationType: {
        standard: 'Standardinformasjon',
        hdPreAdvice: 'HD-preavisering',
        reportsFromRecipients: 'Meldinger fra mottakere',
        error: 'Du må angi type varsler'
      },
      customizedNotifications: 'Tilpassede varsler ({{count}})',
      mustAddEmailToList:
        'For at e-postadressene skal lagres når du trykker på legg til innstilling, må du legge dem til i listen',
      informationToCustomer: 'Informasjon til kunden',
      returnToCustomer: 'Retur til kunden',
      addEmailToList: 'Legg til e-post på listen',
      registeredEmailSubscription: 'Registrert e-postabonnement',
      updateEmail: 'Oppdater e-post',
      noRegisteredEmails: 'Ingen registrerte e-poster',
      detailsSavedSuccessfully: 'E-post til avsender ble lagret med suksess'
    },
    customerDeviations: {
      new: 'Legg til nytt avvik',
      deviationTitle: 'Avvik for kunde',
      addDeviation: 'Legg til nytt avvik',
      editDeviation: 'Rediger avvik',
      en: 'ENG',
      sv: 'SVE',
      nb: 'NOR',
      fi: 'FIN',
      dk: 'DAN',
      event: 'Hendelse',
      reason: 'Årsak',
      action: 'Handling',
      submit: 'Send inn',
      deviationType: 'Type avvik',
      description: 'Beskrivelse',
      code: 'Kode',
      edit: 'Rediger',
      delete: 'Slett',
      deviationAdded: 'Avvik lagt til',
      deviationEdited: 'Avvik endret',
      deviationExists: 'Avviket finnes allerede',
      deviationDeleted: 'Avvik slettet',
      deviation: 'Avvik',
      deviationCode: 'Avvikskode',
      deviationCodesLabel: 'Avvikskoder'
    },
    customerInfo: 'Kundeinfo',
    customerInformation: 'Kundeinformasjon',
    customerName: 'Kundenavn',
    invoicingAddress: 'Fakturaadresse',
    organisationNumber: 'Organisasjonsnummer',
    visitingAddress: 'Besøksadresse',
    creditBlocked: 'Kredittsperret',
    creditBlockedFrom: 'Kredittblokkert fra dato',
    creditBlockedFromInfo: 'Blokkér kreditt for denne kunden fra valgt dato',
    creditBlockedIngress: 'Angi siste dato for å opprette ordre i Glow for denne kunden.',
    from: 'Fra',
    address: 'Adresse',
    zipCode: 'Postnummer',
    zipArea: 'Sted',
    country: 'Land',
    edit: 'Rediger {{name}}',
    selectCountry: 'Velg land',
    settingsInGlow: 'Innstillinger i Glow',
    addSetting: 'Legg til innstilling',
    editSetting: 'Rediger innstilling',
    addNewCustomer: 'Legg til ny kunde',
    bookingPageModalHeading: 'Booking i kundeportalen',
    bookingPageModalDescription: 'Kunden skal kunne booke sendinger på dette kundenummeret i Glow kundeportal',
    bookingPage: 'Bookingside',
    bookingPageCustomerPortal: 'Bookingside i kundeportalen',
    bookingPageIngress:
      'Slå av booking hvis kunden ikke skal kunne booke sendinger på dette kundenummeret i Glow kundeportal.',
    bookingActive: 'På',
    bookingInactive: 'Av',
    returnAddressUpdated: 'Returadresse oppdatert',
    returnAddressRemoved: 'Returadresse fjernet',
    returnAddressModalHeading: 'Returadresse for varer',
    removeReturnAddressModalHeading: 'Fjern nåværende returadresse',
    removeReturnAddressConfirm: 'Er du sikker på at du vil fjerne den nåværende returadressen for varer?',
    returnAddressModalDescription: 'Oppgi returadressen som skal brukes når varer returneres fra terminalen',
    brandedTrackingActive: 'På',
    brandedTrackingInactive: 'Av',
    bookingPageAvailable: 'Ja',
    bookingPageHidden: 'Nei',
    customerBookingPageAccessUpdated: 'Tilgang til bookingsiden er oppdatert',
    brandedTrackingAccessUpdated: 'Faktureringsstatus for Branded Tracking er oppdatert',
    brandedTrackingModalDescription: 'Skru på for å aktivere fakturering for Branded Tracking.',
    returnLastLegUpdated: 'Status for siste returledd er oppdatert',
    token: {
      warningDark:
        'Denne kunden er blokkert og kan ikke opprette noen bestillinger. Opphev blokkeringen for å aktivere kunden.',
      warningLight: 'Husk å kopiere API-nøkkelen nå. Du vil ikke kunne se den igjen!',
      success: 'Du har allerede generert en API-nøkkel for denne kunden',
      allowApiKey: 'Tillat API-nøkkel for kunde',
      allowApiKeyDescription: 'Før du genererer en API-nøkkel, må du først tillate at denne handlingen utføres.',
      allowApiKeyButtonText: 'Tillat API-nøkkel',
      apiKeyCopied: 'API-nøkkelen er kopiert',
      generateApiKeyDescription:
        'API-nøkkelen er en unik nøkkel per kunde. Nøkkelen brukes når kunden din oppretter en bestilling i kundeportalen. Les mer om vårt API <0>her</0>.',
      generateApiKey: 'Generer API-nøkkel'
    },
    nonInvoiceable: 'Ikke faktura',
    internalNonInvoiceable: 'Intern / Kunden vil ikke bli fakturert'
  },
  texts: {
    tabTitle: 'Tekster og oversettelser',
    successfullyAdded: 'Teksten ble lagt til i listen',
    successfullyUpdated: 'Teksten ble oppdatert',
    successfullyDeleted: 'Teksten ble slettet',
    allTextsAndVases: 'Liste over alle tekster og oversettelser',
    searchText: 'Søk etter tekst',
    deleteModalTitle: 'Slett tekst',
    deleteModalDescription: 'Du kan ikke angre denne handlingen',
    createNewText: 'Opprett ny tekst',
    title: 'Tekster',
    update: 'Oppdater tekst',
    name: 'Navn på tekst',
    group: 'Gruppering',
    edit: 'Endre',
    delete: 'Slett',
    add: 'Legg til tekst',
    reset: 'Nullstill',
    confirmDelete: 'Er du sikker på at du vil slette teksten?',
    added: 'Tekst lagt til',
    deleted: 'Tekst slettet',
    updated: 'Text endret',
    nameToolTip: 'Navn vises når tekst kobles til tjenesten'
  },
  billingType: { day: 'dag', evening: 'kveld', weekend: 'helg', weekendEvening: 'helgekveld' },
  importExport: {
    dropText: 'Dra fil hit for å laste opp',
    export: 'Eksporter',
    exportAddresses: 'Eksporter kundeadresser til Excel',
    importExcel: 'Importer fra Excel',
    imported: 'adresser importert',
    or: 'eller',
    selectFile: 'Velg fil',
    uploadingFile: 'Laster opp...'
  },
  customMeasurements: {
    name: 'Navn',
    weight: 'Vekt',
    height: 'Høyde',
    length: 'Lengde',
    width: 'Bredde',
    heading: 'Egendefinerte godstyper',
    error: 'Feil ved lagring av godstype: ',
    confirmDelete: 'Er du sikker på at du vil slette denne godstypen?',
    new: 'Lag ny',
    customGoodsTypes: 'Egendefinerte godstyper',
    defaultGoodsTypes: 'Standardgodstyper',
    invalidName: 'Navnet må inkludere minst én bokstav'
  },
  unresolved: {
    unresolvedAddresses: 'Uløste adresser',
    allResolved: 'Alle adresser er løst!',
    address: 'Addresse',
    noOfShipments: 'Antall leveranser',
    shipment: 'leveranse',
    shipment_other: 'leveranser',
    shipmentNumber: 'Sendingsnummer',
    customerRef: 'Kundereferanse',
    senderName: 'Avsenders navn',
    senderPhone: 'Avsenders telefonnummer',
    recipientName: 'Mottakers navn',
    recipientPhone: 'Mottakers telefonnummer',
    searchAndSetLocation: 'Søk og velg lokasjon',
    setALocationToContinue: 'Velg lokasjon for å fortsette',
    resolveAddress: 'Løs adresse',
    suggestedAddressFound: 'Foreslått adresse funnet',
    thereIsOneUnresolvedAddress: 'Det er {{count}} uløst adresse',
    thereIsOneUnresolvedAddress_other: 'Det er {{count}} uløste adresser'
  },
  optimizing: {
    title: 'Optimalisering',
    optimizingId: 'Optimaliserings-ID',
    reqTime: 'Forespørselstid',
    respTime: 'Svartid',
    showOnlyErrors: 'Vis kun feil',
    department: 'Avdeling',
    userName: 'Bruker',
    graphID: 'ID',
    request: 'Forespørsel',
    response: 'Svar',
    error: 'Feil',
    viewReqResp: 'Vis',
    status: 'Status',
    totalTime: 'Tid',
    selectOptimizingObjective: 'Velg optimeringsmål',
    cancelRequest: 'Avbryt forespørsel',
    noOptimizations: 'Ingen optimaliseringer for valgt søk',
    viewRaw: 'Vis rådata',
    quality: {
      STANDARD: 'Standard',
      HIGH: 'Høy',
      PREMIUM: 'Premium'
    },
    objectives: {
      completion_time: 'Kortest samlet leveringstid (standard)',
      min_vehicles: 'Færrest antall kjøretøy totalt',
      work_time: 'Jevn leveringstid',
      number_of_deliveries: 'Jevnt antall leveranser',
      deliveries_and_work_time: 'Jevn arbeidstid og jevnt antall leveranser'
    },
    kbSize: 'KB forespørsel',
    showAll: 'Vis alle',
    numberOfShipments: 'Antall sendinger',
    numberOfVehicles: 'Antall kjøretøy',
    processingTime: 'Behandlingstid',
    stats: 'Statistikk',
    addToCompare: 'Legg til kjøring å sammenligne med',
    noRunsToCompare: 'Ingen andre ferdige kjøringer denne dagen',
    removeFromCompare: 'Fjern fra sammenligning',
    noStats: 'Ingen statistikk',
    routesUsed: 'Ruter brukt',
    leftOut: 'Ikke planlagt',
    stops: 'Stopp',
    distanceKm: 'Distanse (km)',
    drivingTime: 'Kjøretid',
    waitingTime: 'Ventetid',
    routeTime: 'Total rutetid',
    longestRoute: 'Lengste rute',
    type: 'Type'
  },
  date: {
    date: 'Dato',
    today: 'I dag',
    tomorrow: 'I morgen',
    yesterday: 'I går',
    dateAndTime: 'Dato og tid',
    from: 'Fra',
    fromDate: 'Fra dato',
    rangeOptions: {
      '15d': '+/- 15 dager',
      '30d': '+/- 30 dager',
      custom: 'Tilpassede datoer',
      last30d: 'Siste 30 dager',
      last7d: 'Siste 7 dager',
      month: 'Måned',
      months: 'Måneder',
      today: 'I dag',
      tomorrow: 'I morgen',
      yesterday: 'I går',
      thisMonth: 'Denne måneden',
      lastMonth: 'Forrige måned'
    },
    to: 'Til',
    toDate: 'Til dato'
  },
  areaSequence: {
    title: 'Sekvensområde',
    description:
      'Legg til opptil {{max}} kartpunkter for å styre leveringsrekkefølgen. Leveransen nærmest hvert punkt prioriteres i valgt rekkefølge, mens leveransene mellom punktene optimaliseres for den mest effektive ruten. Dette styrer rekkefølgen, men tvinger ikke frem hele områder.',
    order: 'Rekkefølge på områder',
    orderWhileEditing: 'Rekkefølge på områder - dra kortene for å endre rekkefølgen',
    added: '{{count}} av {{max}} områder lagt til',
    save: 'Lagre område',
    unsaved: 'Lagre eller avbryt endringene i kartområdene før du lagrer ruten.',
    pin: 'Område {{number}}',
    overlap: 'Område {{number}} overlapper med område {{other}}. Flytt ett av dem lenger unna.',
    maxReached: 'Du kan legge til opptil {{max}} kartpunkter.',
    tool: {
      add: 'Legg til område',
      move: 'Flytt områder',
      delete: 'Slett områder'
    },
    hint: {
      add: 'Klikk i kartet for å legge til et område',
      move: 'Dra markøren for å flytte området. Lagre for å beholde endringene, eller Avbryt for å forkaste dem.',
      delete: 'Klikk på en markør for å slette området'
    }
  },
  routeReceipt: {
    printRouteReceiptList: 'Skriv ut kvitteringsliste',
    noRoutesInfoAvailable: 'Ingen ruteinformasjon tilgjengelig ennå'
  },
  homeDeliveryRouteList: {
    receiptList: 'Kvitteringsliste',
    shipments: 'Sendinger',
    weight: 'Vekt',
    volume: 'Volum',
    bookedWeight: 'Bestilt vekt{{unit}}',
    bookedVolume: 'Bestilt volum{{unit}}',
    sender: 'Avsender',
    package: 'Kolli',
    shipmentNo: 'Sendingsnummer',
    ref: 'Ref.',
    recipient: 'Mottaker',
    time: 'Tid',
    mobile: 'Mobil',
    other: 'Øvrig',
    attemptedDelivery: 'Bomtur',
    receipt: 'Kvittering',
    dateOfBirth: 'Fødselsdato',
    signature: 'Signatur',
    nameClarification: 'Navn',
    goodsLine1: 'Husk å sjekke varene for synlige skader før signering.',
    goodsLine2: 'Hvis det er synlige skader, be sjåføren registrere dem innen du signerer.',
    damage: 'Skade',
    missing: 'Mangler',
    packageNumber: 'Kollinummer',
    comments: 'Kommentar'
  },
  columnCategories: {
    aboutTheShipment: 'Om forsendelsen',
    goods: 'Varer',
    timeAndDate: 'Tid og dato',
    planning: 'Planlegging',
    pickupInformation: 'Henteinformasjon',
    customer: 'Kunde',
    deliveryInformation: 'Leveringsinformasjon',
    originalSender: 'Opprinnelig avsender',
    originalDelivery: 'Opprinnelig levering',
    service: 'Tjeneste',
    preAdvice: 'Forhåndsvarsel',
    invoicingInformation: 'Faktureringsinformasjon'
  },
  shipment: {
    offeredOrdersPending: 'Tilbudte ordrer venter på svar',
    shipment: 'Leveranse',
    multileg: 'multileg',
    pickupLeg: 'Pickup leg',
    deliveryLeg: 'Leveringsbein',
    customer: 'Kunde',
    customerContact: 'Kontaktperson hos kunden',
    customerReference: 'Kundereferanse',
    customerNumber: 'Kundenummer',
    route: 'Rute',
    service: 'Tjeneste',
    additionalServices: 'Tilleggstjenester',
    quantity: 'Antall',
    totalWeight: 'Total vekt',
    totalVolume: 'Totalt volum',
    totalLoadingMeters: 'Lastmeter totalt',
    totalPalletFootPrints: 'Pallplass totalt',
    goodsInfo: 'Forsendelsesinformasjon',
    packages: 'Kolli',
    pickupInfo: 'Henteinformasjon',
    pickupDate: 'Hentedato',
    pickupTime: 'Hentetid',
    pickupInstructions: 'Henteinstrukser',
    deliveryInfo: 'Leveringsinformasjon',
    deliveryDate: 'Leveringsdato',
    deliveryTime: 'Leveringstid',
    eta: 'ETA',
    ata: 'ATA',
    receiverReference: 'Mottakerreferanse',
    deliveryInstructions: 'Leveringsinstrukser',
    trackingPage: 'Mottakers sporingsside',
    internalNote: 'Intern merknad',
    name: 'Navn',
    address: 'Addresse',
    zipCode: 'Postnummer',
    zipArea: 'Poststed',
    phone: 'Telefon',
    secondPhone: 'Telefon 2',
    email: 'E-postadresse'
  },
  bookingTimeWindow: {
    week: 'Uke',
    bookButton: 'Bestill',
    customButton: 'Tilpasset tidsvindu',
    removeBookingButton: 'Fjern bestilling',
    noBookingYet: 'Ikke booket ennå',
    serverError: 'En feil har oppstått. Vennligst forsøk igjen senere.',
    previousButton: 'Forrige',
    nextButton: 'Neste',
    noAvailableDeliveryTimes: 'Ingen tilgjengelige leveringstider denne måneden',
    customTimeTitle: 'Angi tilpasset tidsvindu for forsendelse',
    customDateLabel: 'Dato',
    errorEarliestNotBeforeLatest: 'Tidligste leveringstid må være før seneste',
    arrivedAtTerminal: 'Ankommet på terminal',
    bookCustomTimeSlot: 'Book tidsvindu',
    shipmentBooked: 'Sending booket',
    shipmentBookedWithCustomTimeWindow: 'Sending booket med tilpasset tidsvindu',
    updateBooking: 'Oppdater booking',
    bookingChanged: 'Bookingen er endret',
    bookingSuccessful: 'Bookingen ble gjennomført',
    customTimeWindowAdded: 'Tilpasset tidsvindu for sending ble lagt til',
    timeFrom: 'Tid fra',
    timeTo: 'Tid til',
    timeFieldError: 'Den tidligste leveringstiden må være før den siste',
    availableTimeSlot: 'Tilgjengelige tidsvinduer',
    submitNotSelectedError: 'Du må velge et tidsvindu'
  },
  manualOverride: {
    manuallyAddEvents: 'Manuelt legge til hendelser',
    selectEvent: 'Velg hendelse',
    shipmentEvent: 'Forsendelseshendelse',
    terminalEvent: 'Terminalhendelse',
    scannedFormDescription: 'Type ankomstscan trigges av hvilken avdeling du velger.',
    suggestPageReload: 'Noe gikk galt. Last inn siden på nytt og prøv igjen.',
    eventType: {
      delivered: 'Levert',
      collected: 'Hentet',
      returned: 'Returnert',
      deviated: 'Avvik',
      scanned: 'Skannet',
      preadvised: 'Preadvice-forsøk',
      'order-sorted': 'Sortert',
      'not-arrived-at-distributing-terminal': 'Ikke ankommet',
      'ready-for-pickup': 'Klar for henting (PUP på terminal)'
    },
    selectEventType: 'Velg en hendelsestype',
    noEventSelected: 'Ingen hendelsestype valgt',
    selectManifest: 'Velg flight',
    noManifestSelected: 'Ingen flight valgt',
    disabledEventReason: {
      returned: ' - Avvik påkrevd',
      collected: ' - Dispatching påkrevd',
      default: ' - Ikke tillatt',
      'order-sorted': 'Kun for H2-ordre',
      'not-arrived-at-distributing-terminal': 'Kun for HD-ordre'
    },
    fillDeliverOrReturnEventInfo: 'Fyll inn navn, dato og tid',
    fillDeviationEventInfo: 'Velg avvik og fyll inn dato og tid',
    fillGeneralEventInfo: 'Fyll inn dato og tid',
    eventMessage: 'Hendelser opprettet',
    allPackagesSelected: 'Alle kolli valgt',
    noActiveDriverError: 'Ingen aktive sjåfører på enheten',
    selectPackages: 'Velg kolli',
    selectDriver: 'Velg sjåfør',
    selectUnit: 'Velg enhet',
    selectDepartment: 'Overstyr avdeling'
  },
  zendesk: {
    email: 'Din epostadresse:',
    confirmEmail: 'Gjenta epostadresse:',
    send: 'Lagre',
    missingEmail:
      'For å kunne bruke de nye supportsidene, må du registrere din Posten- eller Bring-epostadresse. Du trenger bare å gjøre dette én gang.'
  },
  shipmentFormPage: {
    activeOrders: 'Aktive ordre',
    deletedOrders: 'Slettede ordre',
    deletedOrdersDescription: 'Slettede ordre søkes separat og kan inneholde annen informasjon enn aktive ordre.',
    searchPhraseError: 'Du må oppgi minst 3 tegn',
    selectStateLabel: 'Velg status nedtrekksmeny',
    selectDateLabel: 'Velg dato nedtrekksmeny',
    submit: 'Vis resultater',
    inputPlaceholder: 'Søk sendingsnummer, telefonnummer, adresse, område, postnummer ...',
    clearButtonLabel: 'tøm søkefraseknapp',
    allStates: 'Alle statuser',
    customDate: 'Tilpasset',
    noDate: 'Ingen datobegrensning',
    withoutDeliveryDate: 'Uten leveringsdato',
    selectFromDate: 'Velg fra dato',
    selectToDate: 'Velg til dato',
    include: 'Inkluder',
    exclude: 'Ekskluder',
    tableColumn: 'Tabellkolonne',
    condition: 'Betingelse',
    searchTerm: 'Søkeord',
    tableDropdown: 'Velg tabell nedtrekksmeny',
    conditionDropdown: 'Velg betingelse nedtrekksmeny',
    typeSearch: 'Skriv inn søkeord',
    typeSearchCommaSeparated: 'Skriv inn søkeord, skilt med komma',
    addNewRow: 'Legg til ny rad',
    deleteRow: 'Slett nåværende rad',
    service: 'Tjeneste',
    goodsDescription: 'Varebeskrivelse',
    unit: 'Enhet',
    deliveryArea: 'Leveringsområde',
    deliveryZipcode: 'Leverings postnummer',
    state: '{{count}} Status',
    state_other: '{{count}} Statuser',
    today: 'I dag',
    tomorrow: 'I morgen',
    yesterday: 'I går',
    last30Days: 'Siste 30 dager',
    plusMinus15Days: '+/- 15 dager',
    plusMinus30Days: '+/- 30 dager',
    shipmentIds: 'Flere forsendelser',
    advancedFilter: 'Avansert filter',
    advancedSearch: 'Avansert søk',
    closeAdvancedSearch: 'Lukk avansert søk',
    selectTable: 'Velg tabell',
    selectCondition: 'Velg betingelse',
    orderId: 'Internt ordrenummer',
    allAnd: 'Alle (og)',
    anyOr: 'Noen (eller)',
    customers: {
      placeholder: 'Alle kunder',
      label: 'Velg kunder'
    },
    allOrderSources: 'Alle interne ordrekilder',
    orderSource: '{{count}} intern ordrekilde',
    orderSource_other: '{{count}} interne ordrekilder',
    vasCodes: '{{count}} VAS-kode',
    vasCodes_other: '{{count}} VAS-koder',
    vasCodesPlaceholder: 'Søk på VAS-kode eller navn',
    orderSourceOption: {
      GLOW: 'GLOW',
      GLOW_CUSTOMER_BOOKING: 'GLOW Kundebooking',
      GLOW_EXCEL: 'GLOW Excel'
    }
  },
  shipmentResultPage: {
    deletedOrdersLimitReached: 'Viser de {{limit}} sist slettede ordrene. Vurder å begrense søket ditt.',
    noResultTitle: 'Ingen resultater funnet',
    batchLimitReached: 'Viser maksimalt 2000 sendinger, vurder å begrense søket',
    withoutDateLimitReached:
      'Når du søker uten dato, vil vi vise maksimalt {{limit}} forsendelser. Vurder å begrense søket ditt.',
    withoutDeliveryDateLimitReached:
      'Når du søker etter forsendelser uten leveringsdato, viser vi maksimalt {{limit}} forsendelser. Vurder å begrense søket ditt.',
    findYourShipments: 'Finn dine sendinger',
    findYourShipmentsDescription:
      'Skriv inn det du leter etter i søkefeltet ovenfor. Flere alternativer finnes under avansert søk',
    searchByShipmentIdsLimitReached:
      'Ved søk etter sendings-ID viser vi maksimalt {{limit}} sendinger. Vurder å begrense søket ditt.',
    searchError: 'Søket mislyktes. Prøv å laste siden på nytt eller endre søkeparametrene'
  },
  shipmentTable: {
    quantity: 'Kvantitet',
    delEta: 'LEV ETA',
    delDuration: 'LEV Varighet',
    delDurationTitle: 'Leveringsvarighet',
    delPreparation: 'LEV Forberedelse',
    delPreparationTitle: 'Forberedelse levering',
    delDeliveryFrom: 'LEV fra',
    delDeliveryFromTitle: 'Leveransetid fra',
    delDeliveryTo: 'LEV til',
    delDeliveryToTitle: 'Leveransetid til',
    timeOfDelivery: 'Leveransetidspunkt',
    puDuration: 'HENT Varighet',
    puDurationTitle: 'Opphentingsvarighet',
    puPreparation: 'HENT Forberedelse',
    puPreparationTitle: 'Forberedelse henting',
    puPickupFrom: 'HENT fra',
    puPickupFromTitle: 'Opphenting fra',
    puPickupTo: 'HENT til',
    puPickupToTitle: 'Opphenting til',
    timeOfPickup: 'Opphentingstidspunkt',
    timeFrom: 'Tid fra',
    timeFromTitle: 'Stopptid fra',
    timeTo: 'Tid til',
    timeToTitle: 'Stopptid til',
    delEtaTitle: 'Forventet leveringstidspunkt',
    recipientRef: 'Mottakerreferanse',
    loading: 'Laster...',
    pickupName: 'Opphentingsnavn',
    deliveryName: 'Leveringsnavn',
    pickupColumn: 'Henting: {{column}}',
    deliveryColumn: 'Levering: {{column}}',
    selectAllOnPage: 'Velg alle på siden ({{count}})',
    selectAll: 'Velg alle ({{count}})',
    deselectAll: 'Fjern alle valg',
    numSelectedShipments: '{{numSelected}} valgt',
    createLabels: 'Lag etiketter',
    yourSearchResult: 'Ditt søkeresultat',
    numberOfShipmentsFound: '{{count}} forsendelser funnet',
    orderedDeliveryDate: 'Bestilt leveringsdato',
    vendorInvoice: 'Leverandørfaktura',
    customerInvoice: 'Kundefaktura'
  },
  shipmentResultActions: {
    confirmDeleteTitle: 'Slette sending?',
    confirmDuplicateTitle: 'Dupliser sending?',
    confirmDuplicateButton: 'Dupliser',
    deleteSuccess: 'Sendingen ble slettet',
    manuallyPreAdviceSuccess: 'Preavisering(er) opprettet for forsendelse',
    manuallyPreAdviceSuccess_other: 'Preavisering(er) opprettet for forsendelser',
    confirmDeleteTitle_other: 'Slette valgte sendinger?',
    deleteSuccess_other: 'Sendelse slettet',
    invoiceActions: 'Fakturahandlinger',
    shipmentActions: 'Sendingshandlinger',
    showInvoicePayloadDisableTooltip: 'Sendinger må ha faktureringsstatus mislykket eller OK'
  },
  moveDepartmentModal: {
    errorMessage: 'Ordre: {{orderIds}}, feilmelding: {{error}}',
    ordersMovedText: 'Ordren har blitt flyttet til avdeling {{department}}',
    errorMessage_other: 'Ordre: {{orderIds}}, feil: {{error}}',
    ordersMovedText_other: 'Ordrene har blitt flyttet til avdeling {{department}}',
    partialSuccessMessage: '{{count}} av {{fullCount}} sendinger ble flyttet',
    title: 'Flytt valgte sending(er) til en annen avdeling'
  },
  updateDeliveryTimeBulk: {
    menuItem: 'Endre leveringsdato og tid',
    heading: 'Endre leveringsdato og tid',
    buttonTitle: 'Endre og avisere',
    smsDescription:
      'Mottakerne får en SMS med ny leveringsdato og nytt tidsvindu, og en lenke der de kan endre tidspunktet.',
    successMessage: '{{count}} sending ble oppdatert',
    successMessage_other: '{{count}} sendinger ble oppdatert',
    notNotified:
      'Det ble ikke sendt SMS for {{shipmentIds}} - mottakeren har ikke gyldig telefonnummer eller e-postadresse',
    notNotified_other:
      'Det ble ikke sendt SMS for {{shipmentIds}} - mottakerne har ikke gyldig telefonnummer eller e-postadresse',
    disabledTooltip: 'Leveringstid kan bare endres før sendingen er tildelt en rute',
    dateInPast: 'Leveringsdatoen kan ikke være tilbake i tid',
    invalidDate: 'Ugyldig dato'
  },
  sendManualDelaySmsModal: {
    errorMessage: '{{error}} {{shipmentIds}}',
    partialSuccessMessage: '{{count}} av {{fullCount}} SMS ble sendt',
    successMessage: 'Manuell forsinkelses-SMS ble sendt vellykket'
  },
  sendPrePickupSmsModal: {
    successMessage: 'SMS med sporing før henting ble sendt',
    'return-order': 'Ordrene kan ikke være returordre',
    'invalid-state': 'Ordrene må være i status Tildelt til rute'
  },
  multistopModal: {
    title: 'Gruppeinformasjon',
    description: 'Gruppevisning for bestillinger som betales sammen.',
    debitLines: 'Debetlinjer',
    notFound: 'Ingen gruppeinformasjon funnet',
    shipmentId: 'Sendingsnummer',
    deliveryDate: 'Leveringsdato',
    stopAddress: 'Stoppadresse',
    postalCode: 'Postnummer',
    noPrice: 'Ingen prisinformasjon tilgjengelig for gruppe',
    priceUpdated: 'Gruppens priser har blitt oppdatert'
  },
  shipmentDetails: {
    notFoundTitle: 'Fant ikke sendingen',
    notFoundDescription: 'Den kan være slettet.',
    overview: 'Oversikt',
    details: 'Detaljer',
    orderInformation: 'Ordreinformasjon',
    volumeAndWeight: 'Volum og vekt',
    references: 'Referanser',
    goods: 'Gods',
    contactInformation: 'Kontaktinformasjon',
    pickupContactInformation: 'Kontaktinformasjon for henting',
    deliveryContactInformation: 'Kontaktinformasjon for levering',
    eventWasAdded: 'Hendelse ble lagt til',
    issueSaving: 'Det oppstod et problem med lagringen',
    noSelectedPackages: 'Ingen pakker ble valgt',
    pickupAndDelivery: 'Henting og levering',
    whereIsTheOrder: 'Hvor er bestillingen',
    communicationToRecipient: 'Kommunikasjon til mottaker',
    yesPremium: 'Ja, premium',
    alerts: 'Varsler',
    pickupDeliveryInfo: 'Hentings- og leveringsinformasjon',
    quickEdit: 'Hurtigredigering',
    quickEditTitle: 'Rediger hentings- og leveringsdetaljer',
    aboutShipment: 'Om sending',
    mapLinkText: 'Vis kartkoordinater',
    copyShipment: 'Kopier sending',
    editShipment: 'Rediger sendingsdetaljer',
    location: 'Sted',
    time: 'Tid',
    selectDate: 'Velg dato',
    manualChangeEvent: 'Manuelt endre hendelse',
    disabledEventReason: { returned: 'Avvik kreves', collected: 'Må være tildelt rute', default: 'Ikke tillatt' },
    selectDeviation: 'Velg avvik',
    required: 'Påkrevd',
    allPackages: 'Alle kolli',
    packages: 'kolli',
    package: 'kolli',
    changeDepartment: 'Endre avdeling',
    moveDepartment: 'Flytt avdeling',
    shipmentMoved: 'Sending flyttet',
    shipmentMovedText: 'Sending {{shipmentId}} er flyttet til avdeling {{department}}',
    shipmentMovedGoBack: 'Gå tilbake til søkesiden',
    shipmentCouldNotBeMoved: 'Sending kunne ikke flyttes',
    moveShipmentDescription:
      'Hvis du ikke har tilgang til avdelingen, vil du ikke kunne finne sendingen etter flyttingen',
    moveShipmentConfirmText: 'Flytt sendingen til en annen avdeling?',
    addShipmentToSlot: 'Legg til sending i {{slot}}?',
    changeSlotConfirm: 'Endre rute for sending til {{slot}}?',
    changeSlot: 'Endre rute',
    selectSlot: 'Velg rute',
    AddToSlot: 'Legg til på rute',
    optimisationInProgress: 'Optimalisering pågår. Du kan ikke endre rute mens optimalisering pågår.',
    removeFromSlot: 'Fjern fra rute',
    removeShipmentFromSlot: 'Fjern sendingen fra rute',
    removeShipmentFromSlotHeading: 'Fjern sendingen fra denne ruten?',
    successRemoveFromSlot: 'Sendingen ble fjernet fra rute',
    successChangeSlot: 'Sendingen endret rute',
    successAddToSlot: 'Sendingen ble lagt til i rute',
    changeSlotDescription: 'Endring av rute utføres uten ruteoptimalisering.',
    addToSlotDescription:
      'Den valgte ruten vil bli optimalisert med de eksisterende sendingene som forblir i samme rekkefølge',
    pickupOrDeliveryChange: 'Hentingen eller leveringen er endret',
    pickupOrDeliveryChangeDescription:
      'Hentings- eller leveringsadressen er endret. Hvis du vil endre adressen tilbake, trykk på en av knappene nedenfor.',
    addressWasUnresolved: 'Adressen ble gjort uløst',
    eventTimeCannotBeInFuture: 'Hendelsestidspunktet kan ikke være i fremtiden',
    shipmentSuccessfullyUpdated: 'Sendingen ble oppdatert',
    connectedShipments: 'Relaterte sendinger',
    goToShipment: 'Gå til sending',
    currentShipment: 'Nåværende sending',
    duplicate: 'Duplikat'
  },
  terminal: 'Terminal',
  location: 'Plassering',
  scannedAtDelegatedDepartment: 'Skannet fra den delegerte avdelingen.',
  pickupOrders: {
    acceptOrders: 'Aksepter ordre',
    selected: 'valgte',
    handleOrders: 'Håndter Opphentingsordre',
    found: 'funnet',
    accept: 'Aksepter',
    reject: 'Avvis',
    noResultText: 'Vi kunne ikke finne noe resultat. Vennligst forsøk med en annen dato.',
    last7d: 'I dag + 7 forrige dager',
    rejectOptions: {
      notFound: 'Avsender ikke funnet på opphentingsadressen. Ingen flere forsøk. Opphenting stengt.',
      terminatesPickupOrder: 'Avsender avslutter opphentingsoppdrag. Ingen flere forsøk. Opphenting stengt.',
      handedOver: 'Avsender har avlevert opphentingen til en annen tranrutetør. Ingen flere forsøk. Opphenting stengt.',
      noMoreAttempts: 'Avsender har flyttet. Ingen flere forsøk. Opphenting stengt.',
      pickupCorrected: 'Avsender har flyttet. Opphenting korrigert og sendt tilbake til underleverandør.',
      goodsNotReady: 'Gods ikke klart for opphenting. Ingen flere forsøk. Opphenting stengt.',
      incorrectBooking: 'Feil bestilling. Opphenting kansellert.',
      senderRefuses: 'Avsender nekter å overlevere godset. Ingen flere forsøk. Opphenting stengt.',
      addressCorrected: 'Feil opphentingsadresse. Adressen er korrigert.',
      incorrectAddressNoMoreAttempts: 'Feil opphentingsadresse. Ingen flere forsøk. Opphenting stengt.',
      senderNotified: 'Feil opphentingsadresse. Ingen flere forsøk. Opphenting stengt.',
      forbiddenGoods: 'Forbudte varer. Ingen flere forsøk. Opphenting stengt.',
      timeFrame: 'Henting kan ikke gjøres innen tidsrammen. Hentebestillingen er sendt tilbake til bestillingskontoret.'
    },
    mustSelectReason: 'Du må velge en grunn for avslaget',
    selectRejectReason: 'Velg grunn for avslaget*',
    selectReason: 'Velg grunn',
    commentPlaceholder: 'Valgfritt - gi ekstra informasjon for avslaget',
    acceptedSuccessToast: 'ble godkjent',
    rejectedSuccessToast: 'ble avvist',
    errorToast: 'Noe gikk galt',
    rejectOrders: 'Avvis bestillinger',
    shipment: '{{count}} forsendelse',
    shipment_other: '{{count}} forsendelser'
  },
  editShipments: {
    pickupShouldBeBeforeDeliveryForAllShipments:
      'Sending [{{shipmentIds}}] kunne ikke endres fordi kombinasjonen av nye og eksisterende tider ikke er gyldig. Fjern markeringen av sendingen som feilet, og prøv igjen.',
    pickupShouldBeBeforeDeliveryForAllShipments_other:
      '{{count}} sendinger kunne ikke endres fordi kombinasjonen av nye og eksisterende tider ikke er gyldig. Fjern markeringen av sendingene som feilet, og prøv igjen. Sendingsnumre som feilet - {{shipmentIds}}',
    useExistingTimes: 'Bruk eksisterende tider',
    pickupShouldBeBeforeDelivery: 'Opphentingstidsvindu må være før leveringstidsvindu',
    pickupEarliestShouldBeBeforeLatest: 'Den tidligste opphentingstiden må være før den seneste',
    deliveryEarliestShouldBeBeforeLatest: 'Den tidligste leveringstiden må være før den seneste',
    success: 'Sendingsinformasjon ble vellykket oppdatert',
    mixedShipmentsSelected: 'Du har valgt sendinger med og uten dato. Opphenting og leveringsinformasjon er påkrevd.',
    fieldNotEditable: 'Denne informasjonen kan ikke endres for ordre med status Tildelt til rute eller Opphentet',
    bulkActionDisabledReason: 'Ordre i status Avvik, Levert, Avvist eller Returnert kan ikke redigeres',
    withoutDateDisabledReason:
      'Kombinasjonen av ordre i status Tildelt til rute eller Opphentet og uten dato kan ikke redigeres',
    pickupDateTime: 'Opphenting dato og tid',
    deliveryDateTime: 'Levering dato og tid',
    earliestPickupTime: 'Tidligste hentetidspunkt',
    latestPickupTime: 'Seneste hentetidspunkt',
    earliestDeliveryTime: 'Tidligste leveringstid',
    latestDeliveryTime: 'Seneste leveringstid',
    pickupName: 'Opphenting navn',
    pickupPhoneNumber: 'Opphenting telefonnummer',
    deliveryName: 'Levering navn',
    deliveryPhoneNumber: 'Levering telefonnummer',
    pickupInstructions: 'Henteinstruksjoner',
    deliveryInstructions: 'Leveringsinstruksjoner'
  },
  shipmentSelectColumn: {
    titleDeletedOrders: 'Tilpass datatabellen for slettede ordre',
    title: 'Tilpass kolonneoverskrift',
    addColumnHeader: 'Legg til kolonneoverskrift',
    addColumnBody:
      'Velg overskriftene du vil vise i tabellen. Vi anbefaler å bruke 10–15 ulike\n    overskrifter, slik at informasjonen ikke blir kuttet. Det nøyaktige antallet avhenger av størrelsen på\n    enheten du jobber på.',
    orderOfTable: 'Rekkefølgen på kolonneoverskriftene'
  },
  bulkActions: {
    routeReceiptList: { disabledTooltip: 'Bestillinger kan ikke være i tilstanden løst eller uløst' },
    unassignShipmentFromSlot: 'Fjern sendingene fra rute',
    unassignShipmentFromSlotDisabledReason: 'Ordrene må være i status Tildelt til rute eller Tilbudt',
    forceUnassignShipmentFromSlot: 'Tving fjerning fra rute',
    disabledMoveDepartmentTooltip: 'Ordrer må være i tilstand Opprettet, Løst, Uavklart eller Avvist for å bli flyttet',
    deleteDisableTooltip:
      'Forsendelsen kan ikke slettes hvis den er i tilstand Opprettet, Uavklart, Løst, Tilbudt eller Tildelt',
    duplicateDisableTooltip: 'Sendinger må være i tilstand Avviket eller Returnert, og avdelingstype må være Bud',
    onlyReleasePausedOrders: 'Du kan bare frigi ordre som er satt på pause.',
    onlyOverrideTheseInvoicingStatuses: 'Du kan bare overstyre ordre med disse faktureringsstatusene: {{statuses}}',
    shipmentForPauseDisableText:
      'Sendingene må ha status Med ordrekorrigering, Skal faktureres eller Fakturering feilet',
    creditDisableTooltip: 'Du kan bare kreditere ordre som har status Fakturert OK',
    copyDisableTooltip: 'Kopier til faktureringsordre er bare tillatt for ordre med faktureringsstatus Fakturert OK',
    createWaybills: 'Opprett fraktbrev',
    createWaybillsTooltip: 'Fraktbrev kan bare opprettes for IKEA-sendinger',
    createDeliveryNotes: 'Opprett følgesedler',
    createDeliveryNotesTooltip: 'Følgesedler kan bare opprettes for IKEA-sendinger',
    viewGroupDisabledTooltip: 'Bestillingen må tildeles før du kan vise og redigere gruppen'
  },
  dispatchModal: {
    title: 'Opphentinger og leveranser på rute {{name}}',
    overridePalletRule: {
      question: 'Overstyre pallregelen?',
      description:
        'Sendingen inneholder paller, men kjøretøyet på denne ruten er ikke merket som at det kan frakte paller. Vil du likevel legge den på ruten?',
      confirm: 'Legg på ruten likevel'
    },
    palletRule: 'Pallregel',
    ignorePalletRule: 'Tillat paller på kjøretøy som ikke kan frakte paller',
    partialForcedOrderLabel: 'Definer rekkefølge for områder/ordrer',
    partialForcedOrder: 'Valgt rekkefølge',
    partialForcedOrderInfo:
      'Du har valgt å angi rekkefølge på utvalgte stopp/områder. Øvrige stopp optimaliseres rundt disse.',
    flex: 'Fleks',
    force: 'Tvungen',
    optimizingEngine: 'Optimaliseringsmotor',
    invalidRouteOrder: 'Leveranse kan ikke være før opphenting. Endre rekkefølgen på ruten',
    submitDisabled: 'Planlegg rute på nytt for å aktivere knappen',
    replanDisabled: 'Rekkefølgen på ruten må være gyldig for å planlegge på nytt',
    noShipments: 'Ingen ordre på ruten',
    noShipmentsDescription: ' Du har fjernet alle ordre på ruten, trykk <i>Bekreft rute</i> for å lagre endringene',
    unassignBreakFromRoute: 'Klikk for å fjerne pausen fra ruten',
    editBreakOnRoute: 'Klikk for å endre pausen på ruten',
    routeEnd: 'Ruteslutt',
    routeStart: 'Rutestart',
    earliestStartOfBreak: 'Tidligste start på pausen',
    latestStartOfBreak: 'Seneste start på pausen',
    openRowMenu: 'Åpne radmeny',
    openPlannedStopMenu: 'Åpne meny for planlagt stopp',
    newPositionForStop: 'Velg ny posisjon for stopp',
    replan: 'Planlegg rute på nytt',
    overrideOptimizingEngine: 'Overstyr standard optimaliseringsmotor',
    warning: 'Du har valgt å ikke bruke en optimaliseringsmotor på denne ruten. Det vil påvirke mottakeropplevelsen.',
    flexDisabled: 'Du kan ikke <strong>flekse</strong> individuelle ordre i en gruppe',
    forceDisabled: 'Du kan ikke <strong>tvinge</strong> individuelle ordre i en gruppe',
    removeDisabled: 'Du kan ikke <strong>fjerne</strong> individuelle ordre i en gruppe',
    orderDisabled: 'Du kan ikke <strong>endre rekkefølge</strong> på individuelle ordre i en gruppe',
    plannedStopRowDisabled:
      'Du har ikke tillatelse til å <strong>endre rekkefølgen</strong> på et planlagt stopp mens du redigerer',
    showStops: 'Vis stopp',
    viewStopsOnSameAddress: 'Vis stopp på samme adresse gruppert sammen',
    addPlannedStopLocations: 'Legg til planlagte stoppsteder',
    selectPlannedStopLocation: 'Velg planlagt stoppsted',
    plannedStop: 'Planlagt stopp',
    visitEarliest: 'Tidligste besøk',
    visitLatest: 'Seneste besøk',
    serviceTime: 'Varighet',
    addPlannedStop: 'Legg til stopp og planlegg på nytt',
    updatePlannedStop: 'Oppdater stopp og planlegg på nytt',
    editPlannedStopOnRoute: 'Rediger planlagt stopp på rute',
    unassignPlannedStopFromRoute: 'Fjern planlagt stopp fra rute',
    settings: 'Innstillinger',
    multipleRecipients: 'Flere mottakere ({{number}})',
    multiplePickups: 'Flere hentinger ({{number}})',
    mustProvideStopLocation: 'Du må oppgi et stoppested',
    editingLockBanner: 'Ruten redigeres av {{name}} siden {{time}}.',
    editingLockBannerBody: 'Du må ta over ruting for å planlegge ruten på nytt.',
    takeOver: 'Ta over',
    routeChangedByOtherUser: '{{name}} er ferdig med å redigere. Last inn på nytt for å fortsette.',
    reloadRoute: 'Last inn rute på nytt',
    noShipmentsRouteUpdated: 'Last inn ruten på nytt for å se forsendelser',
    duplicateTabBanner: 'Denne ruten er åpen i en annen fane (siden kl. {{time}}).',
    duplicateTabBannerBody: 'Ta over her for å redigere i denne fanen.'
  },
  vehicle: {
    weightCapacity: 'Vektkapasitet',
    volumeCapacity: 'Volumkapasitet',
    maxRangeKm: 'Rekkevidde',
    createNewVehicle: 'Opprett nytt kjøretøy',
    vehiclesInDepartment: 'Kjøretøy i {{departmentName}}',
    listAllVehicle: 'Liste over alle kjøretøy i denne avdelingen',
    deleteSuccessMessage: 'Kjøretøyet ble slettet',
    createdSuccessMessage: 'Kjøretøyet ble opprettet',
    updatedSuccessMessage: 'Kjøretøyet ble oppdatert',
    deleteVehicle: 'Slett kjøretøy',
    notRecover: 'Denne handlingen kan ikke angres',
    createVehicle: 'Opprett kjøretøy',
    editVehicle: 'Rediger {{name}}',
    vehicleInformation: 'Kjøretøyinformasjon',
    selectFuelType: 'Velg drivstofftype',
    selectEuroClass: 'Velg Euro-klasse',
    settings: 'Innstillinger',
    activeDriver: 'Aktiv sjåfør',
    noVehicleControl: 'Ingen kjøretøykontroll',
    slower: 'Saktere',
    slow: 'Sakte',
    normal: 'Normal',
    faster: 'Raskere',
    speedFactorVehicle: 'Kjøretøyets hastighetsfaktor',
    driverSpeed: 'Sjåførhastighet',
    serviceSpeed: 'Servicehastighet',
    defaultStartLocation: 'Standard startsted er avdelingsadressen',
    specifyEndLocation: 'Angi sluttsted',
    earliest: 'Tidligst',
    latest: 'Senest'
  },
  lmEvents: {
    heading: 'LM-hendelser',
    event: 'Hendelse',
    lmEventReasonAction: 'LM hendelse-årsak-tiltak',
    eventTime: 'Hendelsestidspunkt',
    eventSentAt: 'Hendelse sendt',
    lmPayload: 'LM-payload',
    view: 'Vis',
    enterShipmentId: 'Du må oppgi et sendingsnummer',
    searchForShipmentId: 'Søk etter sendingsnummer'
  },
  cms: {
    scheduleBanner: 'Planlegg banner',
    cms: 'CMS',
    publicationDate: 'Publiseringsdato',
    lastEdited: 'Sist redigert',
    dateForUnpublish: 'Dato for avpublisering',
    createNewBanner: 'Opprett ny banner',
    createNewWhatsThisModal: 'Opprett ny "Hva er dette"-modal',
    publish: 'Publiser',
    schedule: 'Planlegg',
    unpublish: 'Avpubliser',
    savePublish: 'Lagre og publiser',
    saveAsDraft: 'Lagre som utkast',
    saveAsDraftUnpublish: 'Lagre som utkast og avpubliser',
    noBannersFound: 'Ingen bannere funnet',
    noModalsFound: 'Ingen modaler funnet',
    DRAFT: 'Utkast',
    PUBLISHED: 'Publisert',
    SCHEDULED: 'Planlagt',
    content: 'Innhold',
    nameOfBanner: 'Navn på banner',
    placementOfBanner: 'Plassering av banner',
    placementOfBannerDescription:
      'Lim inn Glow-URL-en du vil legge til en banner på. Hvis du vil publisere en banner for alle avdelinger eller spesifikke, kan du ententrykke på knappen "Legg til URL" eller endre lenken selv.',
    urlToPageInGlow: 'URL til side i Glow',
    addUrl: 'Legg til URL',
    typeOfBanner: 'Type banner',
    typeOfBannerDescription: 'Velg mellom Advarsel (oransje), Nøytral (grå) eller Feil (rød).',
    bannerNeutral: 'Nøytral (grå)',
    bannerWarning: 'Advarsel (oransje)',
    bannerError: 'Feil (rød)',
    links: 'Lenker',
    linksDescription:
      'Artikkellenken plasseres rett etter brødteksten. Hvis du legger til en "Gå tilbake til gammel side"-lenke, plasseres den før brødteksten.',
    goBackToOldPageLink: 'Lenke for å gå tilbake til gammel side',
    messageInBanner: 'Melding i banner',
    messageInBannerDescription:
      'Engelsk er obligatorisk. Hvis ingen andre språk velges, brukes engelsk som reserve på alle sider.',
    addAdditionalLanguages: 'Legg til flere språk',
    bannerText: 'Tekst',
    nameOfLink: 'Navn på lenke',
    englishText: 'Engelsk tekst',
    englishLinkText: 'Engelsk: lenkens navn',
    selectLanguage: 'Velg språk',
    addNewLanguage: 'Legg tilnytt språk',
    deleteBanner: 'Slett {{name}}',
    bannerWasSaved: '{{name}} ble lagret',
    bannerWasPublished: '{{name}} ble publisert',
    bannerWasScheduled: '{{name}} bleplanlagt',
    articleLink: 'Artikkellenke',
    goBackToOldPage: 'Gå tilbake til gammel side',
    previousPageNote: 'Merk: bruk jokertegnene *department-id* og *date* i dettefeltet',
    selectTime: 'Velg tid',
    setStartDate: 'Angi startdato for banner',
    setEndDate: 'Angi sluttdato for banner',
    endTimeIsBeforeStartTime: 'Sluttiden kan ikke værefør starttiden',
    endDateIsBeforeStartDate: 'Sluttdato kan ikke være før startdato',
    oneBannerPerPageError: 'Kun én banner per side er tillatt. URL overlapper med eksisterende banner: {{banners}}',
    mustProvideUrl: 'Du må oppgi en URL',
    mustProvideNameOfBanner: 'Du må oppgi navn på banner',
    mustProvideNameOfModal: 'Du må oppginavn på modal',
    mustProvideEnglishText: 'Du må oppgi engelsk tekst',
    mustProvideArticleLink: 'Du må oppgi artikkellenke',
    mustProvideNameOfArticleLink: 'Du må oppginavn på artikkellenken',
    mustProvideDate: 'Du må oppgi en dato',
    invalidArticleLink: 'Du må oppgi en gyldig artikkellenke, f.eks. https://example.com',
    errorDuplicateBanner: 'Bannernavnet må være unikt. En banner med dette navnet finnes allerede.',
    draftScheduleTooltip: 'Fjern planleggingenfor å lagre som utkast',
    banner: 'Banner',
    listOfBanners: 'Liste over bannere',
    whatsThisModal: 'Hva er dette-modal',
    whatsThis: 'Hva er dette',
    listOfWhatsThisModals: 'Liste over "Hva er dette"-modaler',
    nameOfWhatsThisModal: 'Navn på "Hva er dette"-modal',
    descriptionWhatsThisModal:
      'Navnet må være unikt. Et tips er å navngi "Hva er dette"-modalen etter plassering, for eksempel "Admin Pre-advice" eller "Planner Live".',
    nameOfModal: 'Navn på modal',
    pageLinkOfModal: 'Side der modalen skal vises',
    pageLinkOfModalDescription:
      'Lim inn Glow-URL-en du vil legge til modalen på. Husk å endre avdelings-ID til * for at modalen skal publiseres på alle avdelinger.',
    linkToPageGlow: 'Lenke til side i Glow',
    modalPreviewEmptyTitle: 'Ingen informasjon ennå',
    modalPreviewEmptyDescription: 'Du må legge til informasjon for å få en forhåndsvisning av modalen',
    addTextForModal: 'Legg til tekst for modal',
    addTextForModalDescription:
      'Engelsk er obligatorisk og vil bli brukt som reserve på allemodaler hvis du ikke skriver informasjon for de andre språkene. Klikk på "Hva er dette"-lenken for tips om hvordan du utformer lenken.',
    searchBannerPlaceholder: 'Søketter banner',
    searchModalPlaceholder: 'Søk etter modal',
    cmsNews: 'Oppdatering',
    cmsNewsLabel: 'Oppdateringer',
    listOfCMSNews: 'Liste over oppdateringer',
    noCMSNewsFound: 'Ingen oppdateringer funnet',
    searchCMSNewsPlaceholder: 'Søk etter oppdatering',
    cMSNewsSettingsTitle: 'Plassering av oppdatering',
    cMSNewsSettingsDescription:
      'Oppdateringen din vises på startsiden og er synlig for alle brukere når de logger inn på Glow.',
    nameOfCMSNews: 'Navn på oppdatering',
    descriptionOfCMSNewsName: 'Gi oppdateringen et navn slik at du enkelt kan finne den. Navnet må være unikt.',
    typeOfCMSNews: 'Type oppdatering',
    typeOfCMSNewsDescription: 'Velg mellom Servicestatus, Ny funksjon eller Informasjon.',
    selectTypeOfCMSNews: 'Velg type oppdatering',
    newFeatureCMSNews: 'Ny funksjon',
    serviceStatusCMSNews: 'Servicestatus',
    informationCMSNews: 'Informasjon',
    NEW_FEATURE: 'Ny funksjon',
    SERVICE_STATUS: 'Servicestatus',
    INFORMATION: 'Informasjon',
    scheduleCMSNews: 'Planlegg oppdatering',
    scheduleCMSNewsDescription: 'Når du planlegger en oppdatering, kan du ikke lagre den som utkast.',
    setStartDateForCMSNews: 'Angi startdato for oppdatering',
    setEndDateForCMSNews: 'Angi sluttdato for oppdatering',
    cMSNewsPreviewEmptyTitle: 'Ingen informasjon ennå',
    cMSNewsPreviewEmptyDescription: 'Du må legge til informasjon for å få en forhåndsvisning av oppdateringen',
    addTextForCMSNews: 'Legg til tekst for oppdatering',
    addTextForCMSNewsDescription:
      'Engelsk er obligatorisk og vil bli brukt som reserve på alle oppdateringer hvis du ikke skriver informasjon for de andre språkene. Klikkpå "Hva er dette"-lenken for tips om hvordan du utformer oppdateringen.',
    mustProvideNameOfCMSNews: 'Du må oppgi navn på oppdatering',
    createNewCMSNews: 'Opprett ny oppdatering',
    continueToYourPage: 'Fortsett til siden din',
    clearSelection: 'Fjern valg'
  },
  invoicingStatus: {
    TO_BE_INVOICED: 'Ikke fakturert',
    INVOICING_FAILED: 'Fakturering mislyktes',
    CORRECTION_PENDING: 'Retting venter',
    INVOICING_PAUSED: 'Fakturering satt på pause',
    EXCLUDED_FROM_INVOICING: 'Ekskludert',
    NOT_READY_FOR_INVOICING: 'Ikke klar',
    INVOICED_OK: 'Fakturert OK',
    ZERO_PRICE: 'Mangelfull pris',
    AWAITING_ACKNOWLEDGEMENT: 'Avventer bekreftelse',
    disallowedStatusLegend:
      'Ordre i status "Fakturert OK" og "Avventer bekreftelse" kan ikke settes til "Ikke fakturert" eller "Ekskludert".'
  },
  invoice: {
    articleCode: 'Artikkel',
    allOrdersInvoice: 'Alle ordre faktureres',
    allOrdersInvoiceDescription: 'Vi kunne ikke finne noen ufakturerte ordre.',
    handledBy: 'Håndtert av',
    invoicing: 'Fakturering',
    credit: 'Kreditt',
    invoiceVerb: 'Fakturere',
    invoiceOrderAction: 'Fakturere ordre',
    invoiceOrderAction_other: 'Fakturer ordre',
    searchShipmentIdOrCustomerRef: 'Søk sendingsnummer eller kundereferanse',
    state: '{{count}} status',
    state_other: '{{count}} statuser',
    quantity: 'Mengde',
    perUnitCustomer: 'Kundepris pr enhet',
    carrierPerUnitPrice: 'Transportørpris pr enhet',
    enableCalculator: 'Aktiver multiplikasjon av pris og antall',
    mustBeNegative: 'Må være < 0',
    mustBePositive: 'Må være > 0',
    description: 'Beskrivelse',
    customerAmount: 'Kundebeløp',
    carrierAmount: 'Enhetsbeløp',
    failedPriceListLink: 'Prisliste som feilet i Prismotor',
    failedPriceList: 'Mislykket prisliste',
    priceFailureDetail: 'Feildetaljer',
    priceFailureReason: 'Feilårsak',
    priceFailureReasons: {
      missingAttributeValue: 'Attributt mangler',
      matrixLookupMiss: 'Matrisefeil',
      invalidExpression: 'Ugyldig uttrykk',
      scriptError: 'Skriptfeil'
    },
    invoiceFailureDetail: 'Faktureringsfeildetaljer',
    invoiceDepartment: 'Fakturér avdeling',
    invoiceDepartment_other: 'Fakturér avdelinger',
    invoiceDepartments: 'Fakturér avdeling(er)',
    dashboard: 'Dashbord',
    invoicingJobsSummary: 'Oppsummering av faktureringsjobber',
    invoicingStatus: 'Faktureringsstatus',
    invoicingStatusDescription: 'Viser order fra de siste {{months}} månedene.',
    ordersOnPage: '{{count}} ordre på siden',
    ordersFoundCount: '{{count}} ordre funnet',
    ordersFoundCount_other: '{{count}} ordre funnet',
    ordersNotInvoiced: 'Ordre som ikke er fakturert ennå',
    invoicingFailedDescription: 'Ordre som er behandlet, men mislykket',
    text: 'Fakturatekst',
    correctionPendingDescription: 'Ordre med ventende rettelser',
    ordersPausedFromInvoiced: 'Ordre som er satt på pause fra å bli fakturert',
    invoicingZeroPriceDescription: 'Ordre med ikke-godkjente nullrader',
    sendInvoices: 'Send fakturaer',
    sendInvoicesDescription:
      'Du er i ferd med å fakturere {{departments}}. Velg dato eller datoperiode for faktureringsperioden.',
    sendInvoiceDateValidationErrorOneMonth: 'Maks datospenn er 1 måned',
    invoicingInProgress: 'Fakturering for {{departmentName}} pågår, {{count}} faktureringsjobber gjenstår',
    invoicingInFinished: 'Faktureringen for {{departmentName}} er fullført',
    orderEnqueuedForInvoicing: 'Ordren er satt i kø for fakturering',
    orderEnqueuedForInvoicing_other: 'Ordre er satt i kø for fakturering',
    orderSuccessNotInvoiced: 'Ordren ble endret til ikke fakturert',
    orderSuccessNotInvoiced_other: 'ordre ble endret til ikke fakturert',
    orderSuccessInvoicedOk: 'Ordren ble markert som fakturert OK',
    orderSuccessInvoicedOk_other: 'Ordre ble markert som fakturert OK',
    orderSuccessExcluded: 'Ordren ble ekskludert fra fakturering',
    orderSuccessExcluded_other: 'Ordre ble ekskludert fra fakturering',
    howManyInvoices: 'Hvor mange fakturaer vil bli sendt',
    fetchAmount: 'Hent beløp',
    wantToResend: 'Denne ordren er allerede fakturert. Er du sikker på at du vil sende den på nytt?',
    adHocInvoiceOrder: 'Du er i ferd med å fakturere denne ordren. Vil du fortsette?',
    adHocInvoiceOrder_other: 'Du er i ferd med å fakturere disse ordrene. Vil du fortsette?',
    pauseOrders: 'Sett ordre på pause',
    datePeriod: 'Dato periode',
    ordersWereSuccessfullyPaused: '{{count}} ordre ble midlertidig stoppet fra fakturering',
    ordersWereSuccessfullyPaused_other: '{{count}} ordre ble midlertidig stoppet fra fakturering',
    releaseOrders: 'Frigi ordre',
    recalculatePrices: 'Beregn priser på nytt',
    ordersSentForPriceRecalculation: '{{count}} order er blitt lagt i køen for ny beregning',
    ordersSentForPriceRecalculation_other: '{{count}} ordre er blitt lagt i køen for ny beregning',
    ordersWereSuccessfullyReleased: '{{count}} ordre ble frigitt for fakturering',
    ordersWereSuccessfullyReleased_other: '{{count}} ordre ble frigitt for fakturering',
    addUnit: 'Legg til enhet',
    overrideUnit: 'Overstyr enhet',
    addUnitDescription: 'Legg til en enhet til dine valgte ordre. Denne enheten er den som vil bli egenfakturert.',
    addUnitToOrders: 'Legg til enhet i ordre',
    addUnitToOrder: '{{unit}} ble lagt til i {{count}} ordre',
    addUnitToOrder_other: '{{unit}} ble lagt til i {{count}} ordre',
    addUnitBulkDisabled: 'Enhet kan kun legges til ordre uten enhet',
    approveIncompletePrices: 'Godkjenn med manglende priser',
    manualOverrideTitle: 'Manuell overstyring av faktureringsstatus',
    selectStatus: 'Velg ny faktureringgssatatus',
    status: 'Den nåværende statusen er',
    status_other: 'De nåværende statuser er',
    manualOverrideLegend:
      'Du er i ferd med å skrive over faktureringsstatus for én valgt ordre. Nåværende status er: {{statuses}}.',
    manualOverrideLegend_other:
      'Du er i ferd med å skrive over faktureringsstatus for {{count}} valgte ordre. $t(invoice.status, {"count": {{statusCount}} }): {{statuses}}.',
    manualOverrideLegend2: 'Velg ønsket faktureringsstatus for denne ordren nedenfor.',
    manualOverrideLegend2_other: 'Velg ønsket faktureringsstatus for disse ordrene nedenfor.',
    unitId: 'Enhets ID',
    bannerOldInvoicePage:
      'Den 26. august vil <0>den nye faktureringssiden</0> åpnes som standard. Vi oppfordrer deg til å begynne å bruke den nye siden. Mer info om den nye siden <1>her</1>.',
    acceptIncompletePricesTitle: 'Godkjenn mangelfulle priser',
    acceptIncompletePricesModalQuestion:
      'Du er i ferd med å godkjenne {{count}} ordre med mangelfull pris. Er du sikker på at du vil fortsette?',
    acceptIncompletePricesModalQuestion_other:
      'Du er i ferd med å godkjenne {{count}} ordre med mangelfulle priser. Er du sikker på at du vil fortsette?',
    confirmCancelDialog: {
      title: 'Du har ulagrede endringer',
      question: 'Du har ulagrede endringer. Ønsker du å fortsette?',
      abort: 'Bli på siden',
      confirm: 'Fortsett uten å lagre'
    },
    download: 'Last ned faktura',
    downloadVendor: 'Last ned leverandørfaktura',
    downloadInvoiceTooltip: 'Faktura kan kun vises når den er utstedt av eksternt system',
    multilegFilter: {
      label: 'Filtrer delvis multileg',
      ALL: 'Vis alle',
      ONLY_PARTIALLY_READY_MULTILEG: 'Vis kun delvis klare',
      EXCLUDE_PARTIALLY_READY_MULTILEG: 'Ekskluder delvis klare'
    },
    invoicingAwaitingAcknowledgementDescription:
      'Fakturerte ordre som avventer registreringsbekreftelse fra eksternt system',
    invoicedOn: 'Sist sendt',
    filterStates: 'Filtrer statuser',
    filterDeliveryDate: 'Leveringsdato',
    clearFilters: 'Fjern filtre'
  },
  live: {
    late: 'forsinket',
    onlyDeviated: 'Vis kun ruter med avvik',
    bannerOldLivePage:
      '<0>Prøv</0> den nye Live-siden, med forbedrede funksjoner og nytt design. Vi oppfordrer deg til å bruke den nye live-siden for å venne deg til den før vi fjerner den gamle siden fullstendig.',
    shipment: 'Leveranse',
    shipmentFrom: 'Fra',
    shipmentTo: 'Til',
    confirm: 'Bekreft',
    unconfirm: 'Avkreft',
    confirmedBy: 'Bekreftet av {{name}} klokken {{time}}',
    theCourier: 'Sjåføren',
    activeRoutes: 'Aktive ruter',
    routeDeviation: 'Avvik på ruten',
    routeDeviations: 'Avvik på ruten',
    multipleDeviations: 'Flere avvik',
    recentDeviations: 'Nylige avvik',
    noRoutesFound: 'Ingen ruter funnet',
    noDeviationsFound: 'Ingen avvik funnet',
    consignmentDamage: 'Skade på leveranse',
    shipmentDeviation: 'Avvik på leveranse',
    outsideServiceTime: 'Utenfor servicevindu',
    outsideEstimatedTime: 'Utenfor estimert tidsvindu',
    deliveryLocationDeviation: 'Uventet lokasjon',
    eventTextDeviationOne: '{{name}} har et leveranseavvik',
    eventTextDeviationMany: '{{name}} har {{count}} leveranseavvik.',
    eventTextDamageOne: '{{name}} har skader på {{count}} leveranser.',
    eventTextDamageMany: '{{name}} har skader på en leveranse',
    eventTextServiceTimeWindow: '{{name}} leverte utenfor servicevinduet',
    eventTextEstimatedTimeWindow: '{{name}} leverte utenfor det estimerte tidsvinduet',
    eventTextDeviated: '{{name}} har avviket fra ruten sin',
    eventTextDeliveryLocationDeviation: '{{name}} leverte/avvek {{distance}} meter fra forventet sted.',
    eventHelpDeviation: '{{name}} har registrert et avvik på leveranse {{shipmentId}}',
    eventHelpDamage: '{{name}} har registrert en skade på leveranse {{shipmentId}}',
    filterOngoing: 'Aktive',
    filterNotStarted: 'Ikke startet',
    filterFinished: 'Vis fullførte',
    filterOnlyDeviated: 'Vis kun ruter med avvik',
    filterShipmentDeviations: 'Avvik på leveranse',
    filterShipmentDamage: 'Skade på leveranse',
    filterEstimatedTime: 'Estimert tid',
    filterServiceTime: 'Servicetid',
    filterRouteDeviations: 'Avvik på ruten',
    filterDeliveryLocationDeviation: 'Uventet lokasjon',
    filterConfirmed: 'Bekreftet',
    routeProgress: 'Fullført {{complete}} av {{total}}',
    routeDuration: 'Fra {{from}} til {{to}}',
    routeDelayed: 'Forsinket',
    routeAhead: 'Foran',
    routeOnTime: 'Tidsnok',
    routeUnknown: 'Ukjent',
    routeDeviationsNone: 'Ingen avvik',
    routeDeviationCount: '{{unhandledDeviations}} av {{totalDeviations}}',
    routeHasHandleDeviations: 'Ruten har {{count}} håndtert avvik',
    routeHasHandleDeviations_other: 'Ruten har {{count}} håndterte avvik',
    openRoute: 'Se rute',
    openShipment: 'Se leveranse',
    viewRoute: 'Se rute',
    deviated: 'Avvik',
    offRoute: 'Følger ikke ruten',
    onRoute: 'Følger ruten',
    routeStateFilter: 'Rutetilstand',
    allRoutesStates: 'Alle rutestatuser',
    selectedRouteStates: '{{count}} rutestatus',
    selectedRouteStates_other: '{{count}} rutestatuser',
    noSelectedStates: 'Ingen valgte statuser',
    allDeviationTypes: 'Alle avvikstyper',
    selectedDeviationTypes: '{{count}} avvikstype',
    selectedDeviationTypes_other: '{{count}} avvikstyper',
    showHandledDeviations: 'Vis håndterte avvik ({{count}})',
    noSelectedTypes: 'Ingen valgte typer',
    viewShipment: 'Se leveranse',
    selectAllRouteStates: 'Velg alle rutestatuser',
    noRoutesWithDeviations: 'Ingen ruter tilgjengelig',
    selectAllDeviationTypes: 'Velg alle avvikstyper',
    noDeviationOnRoute: 'Ingen avvik på ruten',
    noDeviationAvailable: 'Ingen ruter tilgjengelig',
    noDeviationsOnFilter: 'Det er ingen tilgjengelige avvik på det valgte filteret. Prøv et annet filter.',
    noRoutesOnFilter: 'Det er ingen tilgjengelige ruter på det valgte filteret. Prøv et annet filter.',
    eventHelpServiceTimeWindow:
      '{{name}} har levert leveranse {{shipmentId}} klokken {{actual}}, som er utenfor servicevinduet {{earliest}}-{{latest}}.',
    eventHelpEstimatedTimeWindow:
      '{{name}} har levert sendingsnummer {{shipmentId}} kl. {{actual}} som er utenfor det estimerte tidsvinduet {{earliest}}–{{latest}}.',
    eventHelpDriverDeviated: '{{name}} har levert leveranse {{shipmentId}} i feil rekkefølge.',
    eventHelpDriverDeviatedAtPickup: '{{name}} har hentet leveranse {{shipmentId}} i feil rekkefølge.',
    eventHelpDriverDeviatedAtPickupBefore:
      '{{name}} har hentet leveranse {{shipmentId}} i feil rekkefølge ved å hente #{{actual}} før #{{expected}}.',
    eventHelpDriverDeviatedAtPickupAfter:
      '{{name}} har hentet leveranse {{shipmentId}} i feil rekkefølge ved å hente #{{actual}} etter #{{expected}}.',
    eventHelpDriverDeviatedBefore:
      '{{name}} har levert leveranse {{shipmentId}} i feil rekkefølge ved å levere #{{actual}} før #{{expected}}.',
    eventHelpDriverDeviatedAfter:
      '{{name}} har levert leveranse {{shipmentId}} i feil rekkefølge ved å levere #{{actual}} etter #{{expected}}.',
    eventHelpDeliveryLocationDeviation: {
      withShipmentId:
        '{{name}} har levert eller avviket leveranse {{shipmentId}} <4>her</4>, {{distance}} meter unna <9>forventet lokasjon</9>.',
      withoutShipmentId:
        '{{name}} har levert eller avviket <4>her</4>, {{distance}} meter unna <9>forventet lokasjon</9>.'
    },
    search: 'Søk etter rute, enhet eller sjåfør',
    departmentFilter: 'Avdelingsfilter',
    allDepartments: 'Alle avdelinger',
    deviationTypeFilter: 'Avvikstypefilter',
    mostDeviations: 'Flest avvik',
    latestInTime: 'Senest på tid',
    earliestInTime: 'Tidligst på tid',
    sortOn: 'Sorter på',
    unhandled: 'uhåndterte',
    deviations: 'avvik',
    early: 'tidlig',
    stops: 'Stopp: {{stops}}',
    deviatedFromRoute: 'Avveket fra ruten',
    totalTimeMajorDeviations: 'Total tid for større avvik (≥5 min)',
    totalTimeMinorDeviations: 'Total tid for mindre avvik (<5 min)',
    lateOrEarlyFirstStop: 'For sen eller for tidlig til første levering',
    showAdjusted: 'Vis justert tid',
    showAdjustedTooltip: 'Justert tid vises på mottakerens sporingsside',
    showDiff: 'Vis stoppforskjell',
    diff: 'Stoppforskjell',
    showDiffTooltip: 'Forskjellen mellom planlagt (ETD) og faktisk tid mellom stopp',
    modalTableSummary: 'Total rutetid',
    liveModalActualTooltip1: 'Sammenlignet med ETD:',
    liveModalActualTooltip2: 'Grønn: Opptil 15 min',
    liveModalActualTooltip3: 'Oransje: 15–30 min',
    liveModalActualTooltip4: 'Rød: Mer enn 30 min',
    showSummary: 'Vis oppsummering'
  },
  userRolesAdmin: {
    price: 'Pris',
    searchPlaceholder: 'Søk etter brukerrolle',
    userRoles: 'Brukerroller',
    successCreateMessage: '{{name}} ble opprettet',
    successUpdateMessage: '{{name}} ble oppdatert',
    saveRole: 'Lagre rolle',
    editRole: 'Rediger {{name}}',
    createNewRole: 'Opprett ny rolle',
    nameOfRole: 'Rollenavn',
    nameRequired: 'Navn er påkrevd',
    descriptionRequired: 'Beskrivelse er påkrevd',
    descriptionLabel: 'Beskrivelse (maks 240 tegn)',
    iconLabel: 'Velg hvilket ikon du ønsker for brukerrollen',
    selectRoleTitle: 'Velg tilgangsrettigheter for rolle',
    emptyState: 'Ingen roller funnet for søkefrasen',
    deleteConfirm: 'Er du sikker på at du vil slette {{name}}?',
    deleteSuccess: 'Rolle {{name}} ble slettet',
    settings: 'Innstillinger',
    accessRights: 'Tilgangsrettigheter',
    settingsTitle: 'Innstillinger for rolle',
    settingsDescription: 'Engelsk er påkrevd. Hvis ingen andre språk velges, vil engelsk være reserve.',
    additionalLanguagesTitle: 'Legg til ekstra språk',
    customerPortalAccess: 'Tilgang til kundeportal',
    defaultForUserRole: 'Bruk som standardrolle (valgfritt)',
    event: 'Hendelse',
    financialAccess: 'Finansielle rettigheter',
    invoiceActions: 'Fakturahandlinger',
    orderAttributes: 'Ordreegenskaper',
    findApiOrder: 'Finn API-bestilling',
    optimus: 'Optimus',
    noAccess: 'Ingen tilgang',
    noAccessToApiOrder: 'Ingen tilgang til Finn API-bestilling',
    noAccessToOptimus: 'Ingen tilgang til Optimus',
    optimusViewDescription: 'Bruker kan se tjenester på avdelinger og kunder, men kan ikke gjøre endringer',
    optimusFullDescription: 'Bruker kan legge til og redigere tjenester for avdelinger og kunder',
    ordersApiSearchRestrictedDescription:
      'Bruker kan søke etter bestillinger fra avdelinger eller kunder de har tilgang til',
    ordersApiSearchFullDescription: 'Bruker kan søke etter bestillinger fra alle avdelinger og kunder',
    addRole: 'Legg til rolle',
    addedRole: 'Rolle lagt til',
    removeRole: 'Fjern rolle',
    importExport: 'Import / Eksport',
    importExportExtendedDescription: 'Inkludert tilgang til utvidet rapport for bud.',
    importExportExtendedSaaSDescription: 'Inkludert tilgang til sluttrapport for dagen.',
    billingOrdersReadOnlyDescription: 'Begrenset lesetilgang til {{billingOrderTypes}}',
    billingOrdersDescription: 'Full tilgang til {{billingOrderTypes}}'
  },
  webhook: {
    messages: {
      title: 'Webhook-meldinger',
      resendConfirmation: 'Webhook-melding sendt på nytt'
    },
    resend: 'Send på nytt',
    requestedAfter: 'Forespurt etter',
    messageDetails: {
      title: 'Webhook-melding',
      generalHeading: 'Generell informasjon',
      requestHeading: 'Informasjon om forespørsel',
      loading: 'Henter webhook-melding...',
      copyTooltip: 'Kopier payload',
      copied: 'Payload er kopiert'
    },
    messageId: 'Meldings-ID',
    messageCreatedAt: 'Melding opprettet',
    eventType: 'Hendelsestype',
    packageId: 'Kollinummer',
    shipmentId: 'Sendingsnummer',
    subscriptionUrl: 'Abonnements-URL',
    subscriptionId: 'Abonnements-ID',
    request: {
      at: 'Forespørsel sendt',
      after: 'Forespørsel sendt',
      retry: 'Nytt forsøk av melding'
    },
    response: {
      heading: 'Informasjon om svar',
      at: 'Svar mottatt',
      status: 'Svarstatus'
    },
    responseCategories: {
      Informational: 'Informasjon (100-199)',
      Successful: 'Vellykket (200-299)',
      Redirect: 'Omdirigering (300-399)',
      ClientError: 'Klientfeil (400-499)',
      ServerError: 'Serverfeil (500-599)',
      UnknownError: 'Ukjent feil',
      Pending: 'Venter'
    }
  },
  roles: {
    ADMIN_OPTIMIZING: 'Optimalisering',
    ADMIN_LM_EVENTS: 'LM-hendelser',
    ADMIN_PH: 'ParcelHub',
    ADMIN_INTEGRATIONS: 'Integrasjoner',
    ADMIN_NUMBER_SERIES: 'Nummerserier',
    ADMIN_TEXTS: 'Tjenester',
    ADMIN_JOBS: 'Jobbovervåking',
    ADMIN_PRE_ADVICE: 'Forhåndsvarsel',
    ADMIN_SETTINGS: 'Innstillinger',
    ADMIN_SHD: 'SHD',
    ADMIN_CUSTOMER: 'Begrenset tilgang',
    ADMIN_CUSTOMER_GROUP: 'Kundegrupper',
    ADMIN_HOLIDAYS: 'Helligdager',
    ADMIN_MATRIX: 'Matrise',
    ADMIN_USERS: 'Brukere',
    ADMIN_DEPARTMENT: 'Avdelinger',
    ADMIN_DEPARTMENT_GROUP: 'Avdelingsgrupper',
    ADMIN_CUSTOMER_ALL: 'Full tilgang',
    ADMIN_VENDORS: 'Leverandører',
    ADMIN_PRICE_ARTICLE: 'Opprette og vedlikeholde artikler',
    ADMIN_PRICE_ACCOUNTING: 'Endre innstillinger for regnskapssystem',
    ADMIN_PRODUCTION_TIME_WINDOW: 'Produksjonstidsvindu',
    OPTIMUS_VIEW: 'Lesetilgang til Optimus',
    OPTIMUS_EDIT: 'Full tilgang til Optimus',
    ORDERS_API_SEARCH_RESTRICTED: 'Begrenset søketilgang til Finn API-ordre',
    ORDERS_API_SEARCH_FULL: 'Full søketilgang til Finn API-ordre',
    CUSTOMER_PORTAL: 'Kundetilgang til kundeportalen',
    CUSTOMER_PORTAL_ADMIN: 'Administratortilgang til kundeportalen',
    CUSTOMER_PORTAL_VIEW_PRICE: 'Kan se priser i kundeportalen',
    VIEW_PRICE: 'Kan se priser',
    VIEW_PRICE_EVENTS: 'Kan se prishendelser',
    FINANCIAL_VIEW_CUSTOMER_AND_UNIT_PRICE: 'Kan se priser på ruter',
    BOOK_SHIPMENT: 'Kan booke sendinger',
    PLANNER_ADDRESSES: 'Adresser',
    PLANNER_BILLING_ORDERS: 'Faktureringsordre',
    PLANNER_BILLING_ORDERS_READ: 'Faktureringsordre (kun lesing)',
    PLANNER_BOOKING: 'Booking',
    PLANNER_CORRECTIONS: 'Korrigeringer',
    PLANNER_COURIERS: 'Sjåfører',
    PLANNER_DISPATCHING: 'Dispatching',
    PLANNER_IMPORT_EXPORT: 'Begrenset tilgang til rapporter',
    PLANNER_IMPORT_EXPORT_EXTENDED: 'Tilgang til alle rapporter',
    PLANNER_INVOICING: 'Fakturering',
    PLANNER_LIVE: 'Live',
    PLANNER_MANAGE_RETURNS: 'Administrer returer',
    PLANNER_PICKUP_ORDERS: 'Opphentingsordre',
    PLANNER_RECURRING_ORDERS: 'Gjentagende',
    PLANNER_ROUTE_PLANNING: 'Ruteplanlegging',
    PLANNER_SHIPMENTS: 'Sendinger',
    PLANNER_UNITS: 'Enheter',
    PLANNER_UNITS_REMOVE: 'Fjern enheter fra avdeling',
    PLANNER_UNRESOLVED: 'Uløste',
    PLANNER_REPORTS: 'Rapporter',
    PLANNER_VEHICLES: 'Kjøretøy',
    PLANNER_PRE_ADVICE: 'Forhåndsvarsel',
    ADMIN_ALCOHOL_DELIVERY_EDUCATION: 'Kan legge til alkoholleveringsutdanning for sjåfører',
    FINANCIAL_SHOW_INVOICING_PAYLOAD: 'Vis faktura-payload',
    FINANCIAL_DOWNLOAD_INVOICE: 'Last ned faktura',
    FINANCIAL_CREDIT_NOTE: 'Kreditnota',
    FINANCIAL_COPY_TO_BILLING_ORDER: 'Kopier til faktureringsordre',
    FINANCIAL_VIEW_GROUP: 'Vis gruppe',
    FINANCIAL_VIEW_MULTILEG: 'Vis multileg',
    FINANCIAL_REINVOICE_INVOICED_ORDERS: 'Fakturer fakturerte ordre på nytt',
    FINANCIAL_INVOICE_ACTIONS: 'Fakturahandlinger på sendinger',
    PRICING_ENGINE: 'Prismotor',
    READ_ANY_SHIPMENT: 'Sending'
  },
  validationError: {
    provideEmail: 'Du må oppgi en e-post',
    provideValidEmail: 'Du må oppgi en gyldig e-post',
    youMustSelectCustomer: 'Du må velge en kunde'
  },
  manageReturns: {
    title: 'Administrer returer',
    typesOfReturns: 'Returtype',
    ordersOverAPeriod: 'Viser ordre fra den siste måneden.',
    ordersOverAPeriod_other: 'Viser ordre fra de siste {{count}} månedene.',
    pickedUpByCustomer: 'Hentet av kunde',
    pickedUpByCustomerDescription: 'Returer som skal hentes av kunden',
    transferToDifferentTerminal: 'Overfør til annen terminal',
    transferToDifferentTerminalDescription: 'Returer som skal sendes til en annen terminal',
    environmentalReturns: 'Miljøreturer',
    environmentalReturnsDescription: 'Returer for resirkulering, samlet i en container',
    returnForDelivery: 'Retur for levering',
    returnForDeliveryDescription: 'Returer som skal planlegges og leveres',
    MANUAL_RETURNS: 'Manuelle returer',
    manualReturnsDescription: 'Ordre hvor returdelen ennå ikke er opprettet',
    returnToSenderTitle: 'Vil du returnere sendingene til avsender?',
    manuallyMarkAsHandled: 'Marker som håndtert',
    manuallyMarkAsHandledTooltip: 'Når en forsendelse er merket som håndtert, forsvinner den fra listen',
    ordersFoundCount: '{{count}} ordre funnet',
    ordersFoundCount_other: '{{count}} ordre funnet',
    PICKED_UP_BY_CUSTOMER: 'Hentet av kunde',
    TRANSFER_TO_DIFFERENT_TERMINAL: 'Overfør til annen terminal',
    ENVIRONMENTAL_RETURNS: 'Miljøreturer',
    RETURN_FOR_DELIVERY: 'Retur for levering',
    ordersAlreadyHandled: 'Alle ordre er håndtert',
    ordersAlreadyHandledDescription: 'Vi kunne ikke finne noen ubehandlede bestillinger.',
    manuallyMarkAsHandledModal: {
      title: 'Marker som håndtert',
      shipmentsCount: '{{count}} sendinger',
      shipmentsCount_other: '{{count}} sendinger',
      description:
        'Når sendingen(e) er merket som håndtert, forsvinner de fra listen. Denne handlingen kan ikke angres. Forsendelsen(e) kan finnes på søkesiden.',
      confirm: 'Marker som håndtert'
    },
    manuallyMarkAsHandledSuccess: '{{count}} sending ble merket som håndtert',
    manuallyMarkAsHandledSuccess_other: '{{count}} sendinger ble merket som håndtert',
    returnToSenderSuccess: '{{count}} sending ble returnert til avsender',
    returnToSenderSuccess_other: '{{count}} sendinger ble returnert til avsender',
    selectCustomer: 'Velg kunde',
    customer: 'Kunde',
    customer_other: 'Kunder',
    allCustomers: 'Alle kunder',
    selectDestination: 'Velg destinasjon',
    destination: 'Endelig destinasjon',
    destinationDIP: 'Mottaksterminal',
    returnShipmentColumns: 'Returinformasjon',
    allDestinations: 'Alle destinasjoner',
    noDate: 'Alle',
    zeroDays: '0 dager',
    oneTo6Days: '1–6 dager',
    moreThan7Days: '> 7 dager',
    moreThan15Days: '> 15 dager',
    moreThan30Days: '> 30 dager',
    customerDate: 'Tilpasset',
    daysOnTerminal: 'Dager på terminal',
    months: 'Måneder',
    lastMonths: 'Siste {{count}} måned',
    lastMonths_other: 'Siste {{count}} måneder',
    printList: 'Skriv ut liste',
    returnToSender: 'Returner til avsender',
    returnToSenderQueued: 'Retur til avsender er satt i kø',
    returnToSenderConfirmation: 'Vil du returnere denne sendingen til avsender?',
    returnToSenderFailed: 'Kunne ikke returnere sendingen til avsender',
    returnToSenderDisabledTooltip:
      'Du kan ikke returnere forsendelser som har avveket, blitt levert eller allerede er markert for retur',
    senderDIP: 'Avsendende DIP',
    createReturnLabel: 'Opprett returetikett'
  },
  parcelHubAdmin: {
    title: 'ParcelHub',
    startTitle: 'Søk etter en sending',
    startDescription: 'Skriv inn et sendingsnummer og klikk på søk.',
    noResultsTitle: 'Ingen meldinger funnet',
    loadFailedTitle: 'Kunne ikke hente meldinger',
    loadFailedDescription: 'ParcelHub-consumeren svarte ikke. Prøv igjen, eller sjekk at tjenesten kjører.',
    payloadLoadFailed: 'Kunne ikke hente payload for denne meldingen.',
    shipment: 'Sending',
    topic: 'Topic',
    partition: 'Partisjon',
    offset: 'Offset',
    operation: 'Operasjon',
    packageId: 'Kolli-ID',
    timestamp: 'Tidsstempel',
    payload: 'Payload',
    viewPayload: 'Vis payload',
    consignmentEvents: 'Sendingshendelse',
    consignmentItemEvents: 'Kollihendelse',
    eventCode: 'Hendelseskode',
    event: 'Hendelse',
    receivedAt: 'Mottatt',
    queuedAt: 'Satt i kø',
    processed: 'Behandlet',
    processedAt: 'Behandlet',
    processingLag: 'Behandlingstid',
    eventsNoResultsTitle: 'Ingen hendelser funnet',
    eventsLoadFailedTitle: 'Kunne ikke hente hendelser',
    eventsLoadFailedDescription: 'Henting av hendelser feilet. Prøv igjen.',
    eventPayloadLoadFailed: 'Kunne ikke hente payload for denne hendelsen.'
  },
  apolloAdmin: {
    title: 'Integrasjoner',
    emptyTitle: 'Ingen anrop',
    emptyDescription: 'Velg datoen du vil se og klikk på søk.',
    reqType: 'Type anrop',
    routeId: 'Rute-ID',
    routeName: 'Rutenavn'
  },
  preAdviceFollowup: {
    title: 'Administrer forhåndsvarsel',
    toBeHandled: 'Til håndtering',
    failedOrders: 'Feilede ordre',
    failedOrdersDescription: 'Mottakeren har ikke mottatt advisering',
    manualPreAdvice: 'Manuell advisering',
    manualPreAdviceDescription: 'Manuell advisering aktiveres fra administrasjonssiden',
    preAdviceLocked: 'Advisering låst',
    preAdviceLockedDescription: 'Ordre med låst advisering',
    missingRules: 'Adviseringsregel mangler',
    missingRulesDescription: 'Ordre som ikke er tilknyttet et adviseringsregelsett',
    inProgress: 'Advisering påbegynt',
    inProgressDescription: 'Ordre der adviseringsprosessen har startet',
    notStarted: 'Ikke påbegynt',
    notStartedDescription: 'Ordre med regel der advisering ikke er startet',
    ordersFoundCount: '{{count}} ordre funnet',
    ordersFoundCount_other: '{{count}} ordre funnet',
    FAILED_ORDERS: 'Advisering feilet',
    MANUAL_PRE_ADVICE: 'Manuell advisering',
    PRE_ADVICE_LOCKED: 'Advisering låst',
    MISSING_RULES: 'Adviseringsregler mangler',
    IN_PROGRESS: 'Advisering påbegynt',
    NOT_STARTED: 'Ikke påbegynt',
    ordersAlreadyHandled: 'Alle ordre er håndtert',
    ordersAlreadyHandledDescription: 'Vi kunne ikke finne noen ubehandlede ordre.',
    updatePhoneNumber: 'Endre eller legg til telefonnummer',
    updateEmailAddress: 'Endre eller legg til e-postadresse',
    removeShipmentFromPreAdvice: 'Fjern ordre fra advisering',
    bookDateAndTime: 'Bestill dato og tid',
    manuallyPreAdvice: 'Manuell advisering',
    unlockPreAdvice: 'Lås opp advisering',
    lockPreAdvice: 'Lås advisering',
    triggerPreAdvice: 'Start advisering',
    selectedCustomers: '{{count}} kunde',
    selectedCustomers_other: '{{count}} kunder',
    allCustomers: 'Alle kunder',
    selectRowWithOrderId: 'Velg rad med ordrenummer {{id}}',
    updateRecipientPhoneNumber: 'Oppdater telefonnummer',
    phoneNumberUpdated: 'Telefonnummeret er oppdatert for sendingsnummer {{shipmentId}}',
    phoneNumberUpdatedAndPreAdviceSent:
      'Telefonnummeret er oppdatert og advisering sendt for sendingsnummer {{shipmentId}}',
    samePhoneNumberAlreadySet: 'Duplikat. Angitt telefonnummer eksisterer allerede på sendingen.',
    updateRecipientEmailAddress: 'Oppdater e-postadresse',
    emailAddressUpdated: 'E-postadressen er oppdatert for sendingsnummer {{shipmentId}}',
    emailAddressUpdatedAndPreAdviceSent:
      'E-postadressen er oppdatert og advisering sendt for sendingsnummer {{shipmentId}}',
    emailAddressUpdatedBulk: 'E-postadressen er oppdatert for {{count}} ordre',
    emailAddressUpdatedBulk_other: 'E-postadressen er oppdatert for {{count}} ordre',
    emailAddressUpdatedAndPreAdviceSentBulk: 'E-postadressen er oppdatert og advisering sendt for {{count}} ordre',
    emailAddressUpdatedAndPreAdviceSentBulk_other:
      'E-postadressen er oppdatert og advisering sendt for {{count}} ordre',
    sameEmailAddressAlreadySet: 'Duplikat. Angitt e-postadresse eksisterer allerede på sendingen',
    manuallyPreAdvicedSuccess: 'Vellykket advisering utført for {{count}} ordre',
    nrOfSelected: '{{count}} valgt',
    nrOfSelected_other: '{{count}} valgt',
    sendPreAdvice: 'Send advisering',
    unlockPreAdviceSuccess: 'Advisering låst opp for {{count}} ordre',
    unlockPreAdviceAndPreAdviceSent: 'Advisering låst opp og advisering sendt på {{count}} ordre',
    lockPreAdviceSuccess: 'Advisering låst opp for {{count}} ordre',
    saveAndSendPreAdvice: 'Lagre og send advisering',
    finishPreAdviceFollowupSuccess: 'Vellykket fjerning av {{count}} ordre fra advisering'
  },
  articles: {
    title: 'Artikler',
    number: 'Artikkelnummer',
    name: 'Artikkelnavn',
    quantity: 'Antall',
    shipmentArticles: 'Artikler i sendingen',
    noArticlesPresent: 'Ingen artikler'
  },
  deliveryNote: {
    title: 'Følgeseddel',
    vatNumber: 'VAT no',
    orderNumber: 'Ordrenummer',
    sender: 'Avsender',
    receiver: 'Mottaker',
    phone: 'Telefon',
    shipmentId: 'Sendingsnummer',
    articles: 'Artikler',
    orderDate: 'Bestillingsdato',
    deliveryDate: 'Leveringsdato',
    deliveryTime: 'Leveringstid',
    printedDate: 'Utskriftsdato',
    receiversReference: 'Mottakers referanse',
    receiversReferenceNote: 'Bruk dette nummeret i all kontakt med oss',
    articleNumber: 'Nummer',
    articleName: 'Navn',
    articlePrice: 'Enhetspris',
    articleQuantity: 'Antall',
    numberOfPackages: 'Antall kolli',
    totalWeight: 'Totalvekt',
    totalVolume: 'Totalvolum',
    print: 'Skriv ut følgeseddel'
  },
  coordinates: {
    setCoordinates: 'Angi koordinater',
    title: 'Angi koordinater for adresser',
    setCoordinatesCount: 'Angi koordinater ({{count}})',
    zipCodeRange: 'Postnummerområde',
    goodJob: 'Bra jobbet',
    noUnresolvedShipments: 'Ingen uløste sendinger funnet for denne avdelingen eller avdelingsgruppen',
    coordinateSaved: 'Koordinater lagret for {{address}}',
    checkMapProvider: 'Sjekk på {{name}}',
    noDeliveryDate: 'Ingen leveringsdato',
    created: 'Opprettet',
    withDeliveryDate: 'Med leveringsdato ({{count}})',
    withoutDeliveryDate: 'Uten leveringsdato ({{count}})',
    applyFilter: 'Bruk filter',
    thereAreUnsetCoordinates: 'Du har {{count}} koordinat som må settes.',
    thereAreUnsetCoordinates_other: 'Du har {{count}} koordinater som må settes.',
    noCoordinateFound:
      'Vi kunne ikke finne koordinatene til adressen. Søk etter adressen eller skriv inn koordinater (f.eks. 59.289976807684084, 18.010318840107406) i søkefeltet.'
  },
  relatedOrders: {
    NONE: 'Ingen relaterte ordre',
    MULTILEG: 'Multileg',
    PICKUP: 'Henting',
    TRANSPORT: 'Transport',
    DELIVERY: 'Levering',
    CUSTOMER: 'Kundeordre'
  },
  vendors: {
    title: 'Leverandører',
    viewDetails: 'Vis detaljer',
    searchLabel: 'Søk etter leverandørnavn, leverandør-ID eller enhets-ID',
    searchVendorPlaceholder: 'Søk etter leverandørnavn eller leverandør-ID',
    searchUnitPlaceholder: 'Søk etter enhets-ID',
    vendorOption: 'Leverandørnavn/ID',
    unitOption: 'Enhets-ID',
    notFound: 'Fant ingen leverandører med søkefrasen',
    initialSearch: 'Søk for å finne leverandører',
    informationAboutTheVendor: 'Informasjon om leverandøren',
    connectUnit: 'Koble til enhet',
    connectUnits: 'Koble til enheter',
    connectedUnits: 'Tilkoblet enhet ({{count}})',
    connectedUnits_other: 'Tilkoblede enheter ({{count}})',
    unitsConnected: '{{count}} Tilkoblet enhet',
    unitsConnected_other: '{{count}} Tilkoblede enheter',
    unitsConnected_zero: 'Ingen tilkoblede enheter',
    paymentTerms: 'Betalingsbetingelser',
    connected: 'Tilkoblet',
    searchForUnitDescription: 'Å velge en enhet betyr at avdelingen enheten er lagt til vil ta kostnaden.',
    searchForUnitTitle: '{{vendorSite}} for {{operatingUnitName}}',
    successToast: 'Oppdaterte tilkoblede enheter til leverandør {{name}}',
    showConnectedUnits: 'Vis tilkoblede enheter',
    editConnectedUnits: 'Rediger tilkoblede enheter',
    searchForUnit: 'Søk etter enhet',
    searchPage: 'Søk side',
    currencyCode: 'Valutakode',
    connectedToCompany: 'Tilkoblet dette selskapet',
    noConnection: 'Ingen tilkobling',
    connectedTo: 'Tilkoblet til',
    nothingHereYet: 'Ingenting her ennå',
    emptyStateSelectedVendor: 'Velg en stedskode for å koble enheter eller se eksisterende tilkoblinger.',
    selfBilling: 'Avregning',
    setUnitSettingsTitle: 'Oppdater enhetsinnstillinger for {{name}}',
    setUnitSettingsSelfBillingInternalTrade: 'Avregning og intern handelstransaksjon er aktiv.',
    setUnitSettingsNone: 'Avregning og intern handelstransaksjon er ikke aktiv.',
    setUnitSettingsInternalTrade: 'Avregning er ikke aktiv, mens intern handelstransaksjon er aktiv.',
    state: {
      COMPLETE: 'Komplett',
      INCOMPLETE: 'Ufullstendig',
      ALL: 'Alle',
      label: 'Velg leverandørstatus'
    }
  },
  shdAdmin: {
    successfullyDeleted: 'Tidmatrisen ble slettet',
    successfullyUploaded: 'Tidmatrisen ble lastet opp',
    timeWindowForHomeDelivery: 'Tidsvindu for hjemlevering',
    filterByCustomerData: 'Søk etter kundens navn, underkunde eller kundens nummer',
    uploadTimeMatrixFile: 'Last opp tidmatrisefil',
    downloadExcelTemplate: 'Last ned Excel-mal',
    clickHereOrDragAndDrop: 'Klikk her eller dra og slipp',
    allowedFormats: 'Tillatte formater er XLS og XLSX',
    existingCustomers: 'Eksisterende kunder med SHD',
    customerPriceTooltip: 'Hvis sluttkundens pris skal vises, sett bryteren til på',
    deleteModalTitle: 'Slett tidsvinduer',
    deleteModalDescription:
      'Hvis du sletter dette tidsvinduet, vil alle SHD-tidsvinduer for denne kunden bli fjernet. Du vil ikke kunne angre denne handlingen.',
    exportToExcel: 'Eksporter til Excel',
    toggleLabel: 'Bytt kundens pris',
    customerNumber: 'Kundenummer',
    subCustomer: 'Underkunde',
    customerName: 'Kunde',
    amountOfPostalCodes: 'Antall postnummer',
    lastUpdatedAt: 'Sist oppdatert',
    showCustomerPrice: 'Vis kundens pris',
    uploadMaximumFileSizeLimit: 'Filstørrelsen kan ikke være større enn {{size}} KB'
  },
  serviceMapping: {
    title: 'Tjenester',
    serviceName: 'Tjenestenavn',
    pickupTime: 'Hentetid',
    pickupDuration: 'Varighet henting',
    pickupPreparation: 'Forberedelse henting',
    deliveryTime: 'Leveransetid',
    deliveryDuration: 'Varighet levering',
    deliveryPreparation: 'Forberedelse levering',
    internalName: 'Internt navn',
    internalDescription: 'Intern beskrivelse',
    externalName: 'Eksternt navn',
    externalDescription: 'Ekstern beskrivelse',
    allowFlexDelivery: 'Tillat fleksibel levering',
    timeWindow: 'Tidsvindu',
    serviceMappingType: 'Type',
    serviceLevel: 'Servicenivå',
    service: 'Tjeneste',
    vas: 'VAS',
    stopsBeforeShowEta: 'ETA stopp',
    minutesUntilDelivery: 'ETA Minutter',
    sendAutomaticEtaSmsHeading: 'ETA SMS',
    createNew: 'Lag ny',
    serviceAndVasCodes: 'Tjenester og VAS-koder',
    successfullyAdded: 'Tjenestekartlegging ble lagt til listen',
    successfullyUpdated: 'Tjenestekartlegging ble oppdatert',
    successfullyDeleted: 'Tjenestekartlegging ble slettet',
    editService: 'Rediger tjeneste',
    createNewService: 'Opprett ny tjeneste',
    settingsHeading: 'Innstillinger for tjeneste eller VAS',
    selectLevel: 'Velg nivå',
    standardLevel: 'Standard',
    customerLevel: 'Kunde',
    customerSpecific: 'Kunde spesifikk',
    selectServiceType: 'Velg tjenestetype',
    vasToolTip: 'Verditjeneste, f.eks. ID-kontroll',
    customerNumber: 'Kundenummer',
    pickupTimeInSeconds: 'Servicetid for henting (sekunder)',
    pickupPreparationTime: 'Forberedelsestid for henting (sekunder)',
    deliveryTimeInSeconds: 'Servicetid for levering (sekunder)',
    deliveryPreparationTime: 'Forberedelsestid for levering (sekunder)',
    pickupDurationSecondsApartment: 'Hentetid for leiligheter (sekunder)',
    deliveryDurationSecondsApartment: 'Leveransetid for leiligheter (sekunder)',
    deliveryDurationApartmentHeading: 'Leveransetid for leiligheter (for øyeblikket kun for H2)',
    timeWindowInMinutes: 'Tidsvindu (minutter)',
    stopsLeftHeading: 'Når vil du at eksakt ETA skal vises for kunden?',
    stopsLeftDescription: 'Hvis dette feltet er tomt, vil tidsvinduet vises',
    amountOfStops: 'Antall stopp',
    flexibleDelivery: 'Fleksibel levering',
    flexibleDeliveryDescription: 'Tillat mottakeren å velge at pakken blir levert utenfor døren',
    flexibleDeliveryCheckboxText: 'Ja, mottakeren skal kunne velge',
    flexOptions: 'Flex-alternativer',
    flexOptionsDescription:
      'Vi tilbyr kundene to ulike Flex-leveringsalternativer. Det første alternativet, Utvidet Flex, lar sjåføren legge varene på ulike avtalte steder på leveringsadressen. Det andre alternativet, Flex, er et enklere alternativ der varene kun plasseres ved eiendomsgrensen. Utvidet Flex er standardalternativet, men kunder kan velge å bytte til det enklere Flex-alternativet om ønskelig.',
    unattendedFlex: 'Flex (Uovervåket)',
    extendedFlex: 'Utvidet Flex (Flex)',
    linkTextToService: 'Lenk tekst til tjeneste',
    linkTextToServiceDescription: 'Hvis ingen tekst er valgt, vil standardtekst bli brukt',
    defaultText: 'Standardtekst',
    listOfServicesAndVases: 'Liste over tjenester og VAS-koder',
    searchService: 'Søk etter tjeneste, VAS eller kundenummer',
    customizedText: 'Egendefinert tekst',
    deleteModalTitle: 'Slett Tjenestekartlegging',
    deleteModalDescription: 'Denne handlingen kan ikke angres',
    infoModal: {
      title: 'Hva som vises hvor i Glow',
      subHeading1: 'Planleggere og sjåfører',
      description1: 'Internt navn: Navnet på tjenesten, f.eks. "Hjemmelevering"',
      description2:
        'Intern beskrivelse: Utvidet informasjon om tjenesten, f.eks. "Denne skal bæres inn i mottakerens valgte rom."',
      subHeading2: 'Kunder og mottakere',
      description3: 'Eksternt navn: Navnet på tjenesten, f.eks. "Hjemmelevering"',
      description4:
        'Ekstern beskrivelse: Utvidet informasjon om tjenesten, f.eks. "Varene dine vil bli brakt til et rom du velger".'
    },
    routeOptimizing: 'Ruteplanlegging',
    routeOptimizingDescription:
      'Informasjonen du oppgir her vil overstyre standardtiden og påvirke ruteoptimaliseringen. Forberedelsestid kan brukes for tjenester der mange forsendelser leveres til samme mottaker. Den første forsendelsen vil da ha en leveringstid som er forberedelsestiden pluss leveringstiden kombinert, mens ytterligere forsendelser til samme mottaker vil ha en leveringsvarighet som tilsvarer leveringstiden. <br><br>Standardoppsett for henting er 15 sekunders forberedelsestid og 1 sekund per sending.<br>Standardoppsett for leveringer er 180 sekunders forberedelsestid og 10 sekunder per sending.<br><strong>Vennligst merk at det kan ta opptil 10 minutter før eventuelle endringer vises i systemet.</strong>',
    settingsRecipientTrackingPage: 'Mottakers sporingsside',
    etaComponentHeading: 'Vis eksakt ETA på mottakers side',
    etaComponentDescription:
      'Ved å aktivere dette kan du velge når eksakt ETA skal vises for mottakeren i stedet for tidsvinduet.',
    displayExactEta: 'Ja, vis eksakt ETA',
    stopsLeftSelected: 'Antall stopp igjen til levering',
    minutesLeftSelected: 'Antall minutter igjen til levering',
    numberOfMinutes: 'Antall minutter',
    numberOfStops: 'Antall stopp',
    sendAutomaticEtaSmsTitle: 'Send automatisk SMS til mottakeren',
    sendAutomaticEtaSmsDescription:
      'Ved å aktivere dette, vil funksjonen for at sjåføren kan sende SMS fra sjåførappen også bli deaktivert.',
    sendAutomaticEtaSms: 'Send SMS automatisk',
    missingNumberOfStops: 'Vennligst oppgi et gyldig antall stopp når "Send SMS automatisk" er valgt',
    missingNumberOfMinutes: 'Vennligst oppgi et gyldig antall minutter når "Send SMS automatisk" er valgt',
    minutesNotInRange: 'Vennligst sett antall minutter mellom {{from}} og {{to}}',
    serviceDeliveryType: 'Tjenesteleveringstype',
    noServiceDeliveryTypeSelected: 'Ikke valgt',
    serviceDeliveryTypes: { Delivery: 'Levering', Return: 'Retur', PickupPoint: 'Hentepunkt' },
    Delivery: 'Levering',
    Pickup: 'Opphenting',
    Return: 'Retur',
    PickupPoint: 'Hentepunkt',
    courierApp: 'Sjåførapp',
    allowCourierDescription: 'Tillat sjåføren å akseptere eller avvise forsendelser med denne tjenestekoden',
    allowCourierCheckbox: 'Ja, sjåføren skal kunne velge',
    none: 'Ingen'
  },
  matrix: {
    title: 'Matris',
    id: 'ID',
    pageTitle: 'Matriseadministrasjon',
    name: 'Navn',
    filename: 'Filnavn',
    uploaded: 'Opplastet',
    uploadedBy: 'Opplastet av',
    downloadTemplate: 'Last ned mal',
    byUser: 'Av bruker',
    country: 'Land',
    ROUTING: 'Ruting',
    LINEHAUL: 'Linehaul',
    HUB: 'Hub',
    DELIVERY: 'Levering',
    VAS: 'VAS',
    DEPARTMENT: 'Avdeling',
    CUTOFF: 'Cutoff',
    PARCEL_DELIVERY: 'Pakkelevering',
    parcelDelivery: {
      searchLabel: 'Søk etter postnummer, avdeling eller hub',
      noRouting: 'Ingen ruting i denne matrisen ennå'
    },
    terminals: 'Terminaler',
    searchLabel: 'Søk etter navn eller kundenummer',
    bookingLimitsSearchLabel: 'Søk etter terminalnavn',
    'baggage-delivery': 'Bagasje',
    baggage: {
      title: 'Bagasjematriser',
      name: 'Bagasje {{country}}',
      legend: "Hvis du vil oppdatere eksisterende bagasjematriser, gjør du dette ved å velge 'last opp matrise data'.",
      uploadTitle: 'for {{country}}',
      custom: 'Egendefinert DS-kodematris',
      uploadCustomTitle: 'for egendefinerte DS-koder',
      status: 'Status',
      uploadFail:
        '{{label}} ble ikke akseptert på grunn av feil informasjon. Endre informasjonen og last opp matrisen på nytt.',
      statuses: { accepted: 'Akseptert', pending: 'Venter', rejected: 'Avvist' }
    },
    cutoff: {
      departments: 'Pakkeavdelinger ({{count}})',
      searchDepartment: 'Søk etter avdeling eller hub',
      hubCount: '{{count}} hub',
      hubCount_other: '{{count}} huber',
      department: 'Pakkeavdeling',
      selectDepartment: 'Velg en pakkeavdeling',
      noDepartments: 'Fant ingen pakkeavdelinger',
      hubName: 'Hubnavn',
      hubId: 'Hub-ID',
      addHub: 'Legg til hub',
      sameDay: 'Levering samme dag',
      noHubs: 'Ingen huber er registrert på denne avdelingen ennå',
      saved: 'Cutoff-tidene ble lagret',
      deleted: 'Huben ble slettet',
      delete: {
        question: 'Slette {{hubName}}?',
        description: 'Huben og cutoff-tiden fjernes fra denne avdelingen.'
      },
      unsaved: {
        question: 'Forkaste ulagrede cutoff-tider?',
        description: 'Endringene dine på denne avdelingen er ikke lagret. Bytter du avdeling, blir de forkastet.',
        discard: 'Forkast endringer'
      }
    },
    terminalDetails: {
      details: 'Detaljer',
      alystraDepartmentId: 'Alystra avdelings-ID',
      matrices: 'Matriser',
      type: 'Type',
      noMatrices: 'Denne terminalen er ikke referert til i noen matriser',
      aliases: 'Aliaser',
      departmentId: 'Avdelings-ID',
      createdAt: 'Opprettet',
      noAliases: 'Denne terminalen har ingen aliaser'
    },
    bookingLimits: {
      title: 'Bokningsgrenser',
      header: '{{name}} - Rediger bokningsgrenser',
      rules: '#Regler',
      total: 'Totalt',
      rank: 'Prioritet',
      customer: 'Kunde',
      customerNo: 'Kundenr',
      serviceCode: 'Tjeneste',
      timeWindow: 'Tidsvindu',
      selectTimeWindow: 'Velg tidsvindu',
      noTimeWindow: 'Ingen tidsvindu',
      noCustomer: 'Ingen kunde',
      bookingLimit: 'Bokningsgrense',
      removeLimit: 'Fjern grense',
      addMoreLimits: 'Legg til flere grenser',
      delete: 'Slett bokningsgrenser',
      deleteModalDescription: 'Du vil ikke kunne gjenopprette denne handlingen',
      deleted: 'Bokningsgrenser ble slettet',
      updated: 'Bokningsgrenser ble oppdatert'
    },
    master: 'Master',
    select: 'Velg {{matrix}} matrise...',
    overflow: '+{{overflow}} flere..',
    vasCodes: 'VAS-koder',
    connectedCustomers: {
      title: 'Koblede kunder',
      button: 'Se {{connectedCustomers}} koblede kunder',
      search: 'Søk etter kundens navn eller nummer',
      subcustomer: 'Underkunde'
    },
    upload: {
      success: 'Matrixdata ble lastet opp',
      question: 'Last opp matrise data',
      text: 'Last opp Excel',
      description: 'Last opp Excel-regneark med data for denne matrisen',
      error: 'Feil ved opplasting av data til {{name}}. {{error}}',
      invalidformat: 'Ugyldig filformat'
    },
    delete: {
      question: 'Slett matrise {{name}}',
      description: 'Dette kan ikke angres',
      success: 'Matrisen {{name}} ble slettet',
      error: 'Feil ved sletting av {{name}}. {{error}}'
    },
    new: {
      question: 'Lag ny matrise',
      description: 'Oppretter en ny matrise',
      success: 'Matrisen {{name}} ble opprettet',
      error: 'Feil ved oppretting av matrise. {{error}}'
    },
    edit: {
      question: 'Rediger matrise {{name}}',
      error: 'Feil ved oppdatering av {{name}}. {{error}}',
      success: 'Matrisen {{name}} ble lagret'
    },
    type: 'Velg type',
    day: {
      monday: 'Man',
      tuesday: 'Tir',
      wednesday: 'Ons',
      thursday: 'Tor',
      friday: 'Fre',
      saturday: 'Lør',
      sunday: 'Søn'
    },
    leadTime: 'Ledetid',
    terminal: 'Terminal',
    terminalFrom: 'Terminal fra',
    terminalTo: 'Terminal til',
    postalCode: 'Postnummer',
    postalCodeFrom: 'Fra postnummer',
    postalCodeTo: 'Til postnummer',
    offsetDays: 'offsetdager',
    cutoffTime: 'Cutoff-tid',
    city: 'By',
    error: {
      duplicateName: 'Duplikat navn',
      duplicateServiceCode:
        'Bestillingsbegrensninger er allerede definert for denne kombinasjonen av kunde og tjenestekode',
      duplicateTimeWindow: 'Duplikat tidsvindu'
    }
  },
  shipmentDetailsBilling: {
    finanicalStakeholder: 'Finansielle interessenter',
    item: 'Vare',
    customerTotal: 'Kundens total',
    unitTotal: 'Enhetstotal',
    orderTotal: 'Ordretotal',
    disconnectToOrginalOrder: 'Koble fra opprinnelig forsendelsesnummer'
  },
  upsalesRulesAdmin: {
    title: 'Oppsalgsregler',
    titleSingular: 'Oppsalgregel',
    name: 'Navn',
    type: 'Type',
    searchPlaceholder: 'Søk i oppsalgsregler',
    settings: 'Innstillinger',
    successfullyAdded: '{{name}} ble lagt til i listen',
    successfullyUpdated: '{{name}} ble oppdatert',
    createNewRule: 'Opprett ny regel for mersalg',
    edit: 'Rediger',
    serviceUpgrade: 'Tjensteoppgradering',
    SERVICE_UPGRADE: '$t(upsalesRulesAdmin.serviceUpgrade)',
    shorterTimeWindow: 'Kortere tidsvindu',
    SHORTER_TIME_WINDOW: '$t(upsalesRulesAdmin.shorterTimeWindow)',
    ruleName: 'Navn på mersalgsregel',
    serviceUpgradeDescription1: 'Tjenesten oppgraderes fra 3123 til 2870.',
    serviceUpgradeDescription2: 'VAS 1381 vil automatisk bli lagt til for å sikre at sjåføren får korrekt betaling.',
    zipCodeRangeTitle: 'Postnummer',
    zipCodeRangeDescription:
      'Velg hvilke postnumre du vil inkludere eller ekskludere i regelen. Hvis du trenger å fjerne et spesifikt postnummer eller et område fra et inkludert område, bruk ekskluderingsalternativet for å finjustere valget ditt.',
    fromZipCode: 'Postnummer fra',
    toZipCode: 'Postnummer til',
    addRange: 'Legg til postnummerområde',
    addZipCode: 'Legg til postnummer',
    noZipCodeRangesAdded: 'Du må oppgi et postnummerområde',
    zipCodeRangeError: '"Postnummer fra" må ikke være større enn "Postnummer til"',
    deleteModalTitle: 'Slett mersalgsregel',
    deleteModalDescription: 'Du vil ikke kunne angre denne handlingen',
    successfullyDeleted: 'Mersalgsregel ble slettet',
    shorterTimeWindowDescription1: 'Kortere tidsvindu er tilgjengelig for 3332',
    windowOnlyInEvening: 'Kortere tidsvindu skal bare være tilgjengelig på kvelden',
    timeWindowOffer: 'Hvilket tidsvindu skal tilbys mottakeren?',
    oneHour: '1 time',
    twoHours: '2 timer',
    threeHours: '3 timer',
    mustSelectTimeWindow: 'Du må oppgi tidsvinduet som tilbys mottakeren',
    include: 'Inkluder',
    exclude: 'Ekskluder',
    zipCodeRangeType: 'Type',
    exactZipCode: 'Eksakt',
    zipCodeRange: 'Område',
    zipCode: 'Postnummer',
    mustSelectCountry: 'Du må velge et land først',
    includedZipCodes: 'Inkluderte postnumre ({{count}})',
    excludedZipCodes: 'Ekskluderte postnumre ({{count}})',
    noZipCodesAddedYet: 'Ingen postnumre er lagt til ennå',
    noMatchOnZipCodeSearch: 'Ingen postnummer funnet. Prøv å filtrere med et annet postnummerområde.',
    zipCodesFound: '{{count}} postnummer funnet',
    zipCodesFound_other: '{{count}} postnumre funnet',
    filterOnDepartments: 'Filtrer på avdelinger',
    UPSALES_RULE_COLLISION_OCCURRED:
      'Regelen eksisterer allerede! Vennligst fjern enten følgende avdelinger: {{departments}} eller følgende kunder: {{customers}}',
    status: 'Status',
    active: 'Aktiv',
    paused: 'Pauset',
    pauseRule: 'Pause regel',
    activateRule: 'Aktiver regel',
    activateRuleModalDescription:
      'Du er i ferd med å aktivere regelen. Dette betyr at oppsalg vil være tilgjengelig for mottakerne. Ønsker du å fortsette?',
    pauseRuleModalDescription:
      'Du er i ferd med å pause regelen. Dette betyr at oppsalg ikke vil være tilgjengelig for mottakerne. Ønsker du å fortsette?',
    successfullyActivated: 'Oppsalgregelen ble aktivert',
    successfullyPaused: 'Oppsalgregelen ble pauset'
  },
  billingOrder: {
    create: 'Opprett faktureringsordre',
    copyTo: 'Kopier til faktureringsordre',
    copyToBillingOrder: 'Kopier til faktureringsordre',
    keepConnection: 'Behold tilknytning',
    disconnect: 'Koble fra',
    creditMode: 'Kredit',
    debitMode: 'Debet',
    createCredit: 'Opprett kreditnota',
    credit: 'Kreditnota',
    done: 'Faktureringsordre ble opprettet. Forsendelse-ID: {{shipmentId}}',
    invalidOrderForEdit:
      'Denne ordren kan ikke redigeres. Kun fakturerings- eller kreditordrer som ikke er fakturert kan redigeres.',
    cannotBeCredited: 'Du kan ikke kreditere en ordre som er fakturert i {{systemId}}.',
    invalidOrderForCopy: 'Kan ikke kopiere kreditnota.',
    standaloneInvoice: 'Separat faktura',
    standaloneInvoiceLabel:
      'Jeg vil at denne orderen skal behandles individuelt og ikke grupperes med andre ordre for fakturering.',
    noUnitNotSelfBilled: 'Ordre uten enhet vil ikke bli avregnet.',
    manualInvoiceInformation: {
      label: 'Manuell fakturahåndtering',
      descriptionText: 'Hvis dette feltet er fylt ut vil ordren måtte faktureres manuelt'
    },
    expensive: 'Den innskrevne prisen ser ut til å være uvanlig høy',
    creditInvoiceText: 'Kreditering for forsendelse {{shipmentId}}',
    creditInvoiceLegText: {
      CUSTOMER_ORDER: 'Kundekreditering for forsendelse {{shipmentId}}',
      PICKUP_LEG: 'Kreditering for henting av forsendelse {{shipmentId}}',
      DELIVERY_LEG: 'Kreditering for levering av forsendelse {{shipmentId}}'
    },
    legSelectionLabel: 'Velg transportben',
    legSelectionError: 'Velg hvilket transportben som skal krediteres',
    legSelection: {
      NONE: 'Ingen',
      CUSTOMER_ORDER: 'Kundeordre',
      PICKUP_LEG: 'Henting',
      DELIVERY_LEG: 'Levering'
    },
    wrongPageWarning: 'Faktureringsordrer kan ikke åpnes fra denne siden',
    wrongPageLink: 'Gå til siden med faktureringsordre-detaljer',
    type: {
      Invoice: 'Fakturaordre',
      Invoice_other: 'Fakturaordrer',
      Credit: 'Kreditnota',
      Credit_other: 'Kreditnotaer',
      InternalTrade: 'Intern handelsordre',
      InternalTrade_other: 'Interne handelsordrer'
    }
  },
  welcomeToGlowWithName: 'Velkommen til Glow, {{name}}!',
  welcomeToGlowDescription: 'Bruk navigasjonen til venstre for å starte arbeidet ditt!',
  glowGlobeImage: 'Glow globusbilde',
  latestUpdatesHere: 'Her er de siste oppdateringene',
  formValidation: {
    mustProvideName: 'Du må oppgi navn',
    mustProvideDescription: 'Du må oppgi beskrivelse',
    mustProvideServiceCode: 'Du må oppgi tjenestekode',
    mustProvideCalendarDays: 'Du må oppgi kalenderdager',
    mustProvideCutOffTime: 'Du må oppgi stoppetidspunkt',
    mustProvideCutOffMinutes: 'Du må oppgi stoppminutter',
    mustProvideDeliveryAttempts: 'Du må oppgi antall leveringsforsøk',
    mustProvideCustomer: 'Du må oppgi en kunde',
    mustProvideQuantity: 'Du må oppgi en mengde',
    mustProvideArticle: 'Du må oppgi en artikkel',
    mustProvideDate: 'Du må oppgi en dato',
    mustProvideTime: 'Du må oppgi et tidspunkt',
    mustProvideDuration: 'Du må oppgi en varighet',
    mustProvideCustomerOrUnitAmount: 'Du må oppgi kunde- eller enhetsbeløp',
    allowedRangeIs: 'Tillatt område er {{min}} - {{max}}'
  },
  units: {
    title: 'Enheter',
    new: 'Opprett ny enhet',
    connectFromOtherDepartments: 'Koble til fra andre avdelinger',
    connect: {
      title: 'Koble enheter til nåværende avdeling',
      description: 'Du kan bare søke etter enheter i avdelinger du har tilgang til',
      selected: 'Valgte enheter',
      noneSelected: 'Ingen enheter',
      submit: 'Koble til'
    },
    assigned: 'Enhet(er) ble koblet til'
  },
  productionTimeWindow: {
    addNew: 'Legg til nytt produksjonstidsvindu',
    search: 'Søk etter produksjonstidsvindu',
    description:
      'Her kan du sette et produksjonstidsvindu for ordre som har en mottaker-ID. Du kan søke på mottaker-ID eller postnummerintervall - ved søk på postnummerintervall må du også velge land. For å legge til et produksjonstidsvindu, klikk på "Legg til nytt" eller søk opp et eksisterende for å redigere.',
    addNewDescription:
      'Legg til et tidsvindu for når vi kan levere pakker til en mottaker-ID. Hvis produksjonstidsvinduet er lagt til, vil denne informasjonen bli brukt når vi ruter, i stedet for tjenestetidsvinduet.',
    recipientId: 'Mottaker-ID',
    searchForRecipientId: 'Søk etter mottaker-ID',
    recipientName: 'Mottakernavn',
    address: 'Adresse',
    postalCode: 'Postnummer',
    country: 'Land',
    selectCountry: 'Velg land',
    addedSuccess: 'Produksjonstidsvindu for {{recipientId}} ble lagt til.',
    recipientIdValidation: 'Du må oppgi mottaker-ID',
    timeWindowValidation: 'Du må oppgi et tidsrom',
    invalidRecipientId: 'Ugyldig mottaker-ID',
    postalCodeRangeRequiredTogether: 'Postnummer fra og til må begge fylles ut',
    postalCodeRangeRequiresCountry: 'Velg et land for å søke på postnummerintervall',
    createdAt: 'Opprettet den',
    from: 'Fra',
    to: 'Til',
    editSuccess: 'Produksjonstidsvinduet for {{recipientId}} ble endret.',
    delete: 'Slette produksjonstidsvindu for {{recipientId}}?',
    deleteDescription:
      'Sletting av produksjonstidsvinduet betyr at tjenestetidsvinduet vil bli brukt ved ruting for denne mottaker-ID-en. Ønsker du å fortsette?',
    deleteSuccess: 'Produksjonstidsvinduet for {{recipientId}} ble slettet.',
    noResults: 'Ingen produksjonstidsvindu funnet',
    noResultsDescription:
      'Prøv å søke med en annen mottaker-ID, eller søk på postnummerintervall i stedet. Du kan også opprette et nytt produksjonstidsvindu ved å trykke på knappen øverst i høyre hjørne.',
    noResultsPostalCodeDescription:
      'Ingen produksjonstidsvindu samsvarer med dette postnummerintervallet. Prøv å søke på mottaker-ID uten postnummerintervall i stedet.',
    fromTimeAfterToTime: "'Fra'-tid må være før 'til'-tid"
  },
  loadCarrierModal: {
    title: 'Lastbærergruppe: {{loadCarrierId}}',
    description: 'Leveranser i gruppen'
  },
  routesOverview: {
    palletRuleOverridden: 'Pallregel overstyrt',
    routeNotFoundTitle: 'Fant ikke ruten',
    routeNotFoundDescription: 'Den kan være slettet.',
    shipmentStatus: {
      CREATED: 'Opprettet',
      ASSIGNED: 'Tildelt',
      UNASSIGNED: 'Ikke tildelt',
      COLLECTED: 'Plukket opp',
      DELIVERED: 'Levert',
      DEVIATED: 'Avvik',
      COMMENT: 'Kommentar',
      RESOLVED: 'Løst',
      UNRESOLVED: 'Uløst',
      OFFERED: 'Tilbudt',
      REJECTED: 'Avvist',
      ACCEPTED: 'Akseptert',
      RETURNED: 'Returnert',
      DELETED: 'Slettet',
      UNCONFIRMED: 'Ubekreftet',
      REFUSED: 'Avvist'
    },
    offeredAtTime: 'Ordre tilbudt kl. {{time}}',
    plannedRoute: 'Planlagt rute',
    routes: 'Ruter',
    routesCount: '{{filtered}} av {{total}} ruter',
    searchRouteOrDriver: 'Søk etter rutens navn eller sjåførnavn',
    manuallyAdjustRoute: 'Justér ruten manuelt',
    changeRoute: 'Endre rute',
    plannedRouteTime: 'Planlagt rutetid',
    notOptimized: {
      title: 'Ruten er ikke optimalisert',
      optimizationFailed:
        'Ruteoptimaliseringen feilet, så ruten bruker en ikke-optimalisert fallback. ETA og ETD er ikke tilgjengelig.',
      manuallyPlanned: 'Ruten ble planlagt manuelt uten optimalisering, så ETA og ETD er ikke tilgjengelig.'
    },
    statusOfRoute: 'Rutestatus',
    incorrectETA: 'Mottakers sporingsside viser feil ETA‑tider',
    adjustedFinishTime: 'Juster tid for siste levering: {{time}}',
    driverIsDelayed: 'Sjåføren er {{delayed}} min {{suffix}}.',
    deviations: '{{count}} avvik',
    deviations_other: '{{count}} avvik',
    successfullyDeleted: 'Slettet {{name}} med suksess',
    successfullyReversedDeliveryOrder: 'Leveringsrekkefølgen ble snudd med suksess',
    colorPicker: 'Fargevelger',
    deleteAllRoutesConfirmDialogText: 'Er du sikker på at du vil slette alle ruter?',
    stops: 'Stopp',
    stop: 'Stopp',
    waitingTime: 'Ventetid',
    totalWaitingTime: 'Total ventetid',
    stopsAfterPlannedEndTime: '{{count}} levering etter planlagt rutetid ({{time}}).',
    stopsAfterPlannedEndTime_other: '{{count}} leveringer etter planlagt rutetid ({{time}}).',
    unassignShipmentFromRoute: 'Fjern forsendelse fra ruten',
    unassign: 'Fjern',
    priceInformation: 'Prisinformasjon',
    billingOrderShipment: 'Faktureringsordre',
    trips: 'Turene',
    routeSettings: 'Ruteinnstillinger',
    driverPhoneNumber: 'Sjåførens telefonnummer',
    selectVehicle: 'Velg kjøretøy',
    nameOfRoute: 'Navn på ruten',
    setStartTime: 'Sett starttid',
    setEndDate: 'Sluttdato',
    setEndTime: 'Sett sluttid',
    endDateValidationError: 'Sluttdato må være rutedatoen eller dagen etter',
    endTimeValidationError: 'Sluttid må være etter starttid',
    addMapArea: 'Legg til kartområde',
    editMapArea: 'Rediger kartområde',
    areaWasUpdated: 'Kartområdet på {{name}} ble oppdatert med suksess',
    areaWasCreated: 'Kartområde lagt til på {{name}} med suksess',
    areaWasDeleted: 'Kartområde slettet på {{name}} med suksess',
    addAreaRoute: 'Legg område til rute',
    updateAreaRoute: 'Oppdater område for rute',
    deleteMapArea: 'Slett kartområde',
    templates: 'Malene',
    loadTemplate: 'Last mal',
    deleteTemplate: 'Slett mal',
    saveAsTemplate: 'Lagre som mal',
    saveTemplate: 'Lagre mal',
    templateWasCreated: '{{name}} ble opprettet med suksess',
    templateWasLoaded: '{{name}} ble lastet inn med suksess',
    templateWasDeleted: '{{name}} ble slettet med suksess',
    loadTemplateSubHeading: 'Velg malen du vil legge til.',
    createANew: 'Opprett ny',
    orUpdateExisting: 'eller oppdater eksisterende',
    saveTemplateRulesNote:
      'Bare postnumre som er tilknyttet en ruteregel tas med i malen. Frittstående postnumre lagres ikke.',
    saveTemplateDepartmentGroupNote:
      'Denne visningen omfatter flere avdelinger. Ruteregler fra andre avdelinger tas ikke med i denne malen.',
    deleteTemplateSubHeading: 'Velg malen du vil slette.',
    defaultTemplate: 'Standardmal',
    defaultTemplateSubHeading:
      'Velg malen du vil bruke som standard. Denne malen kan deretter brukes til automatisk oppretting av ruter, som aktiveres i menyvalget Avdelinger under Administrasjon.',
    setDefaultTemplates: 'Angi standardmal',
    selectDefaultTemplate: 'Velg standardmal for {{department}}',
    defaultTemplates: 'Standardmaler',
    normalTemplates: 'Vanlige maler',
    templateDefaultsSet: 'Standardmaler satt',
    selectTemplate: 'Velg mal',
    selectTemplateToOverride: 'Velg mal som skal overstyres',
    nameOfTemplate: 'Navn på malen',
    templateIsRequired: 'Mal må velges',
    templateOrNameIsRequired: 'Mal eller navn må velges',
    areYouDonePlanning: 'Er du ferdig med ruteplanlegging',
    noBackPage: 'Nei, tilbake til siden',
    yesDone: 'Ja, jeg er ferdig',
    manageRouteRules: 'Administrer ruteregler',
    eligibleForAutoDispatch: 'Kvalifisert for auto-dispatch av opphentingsordrer',
    postalCodeRangesSet: 'Postnummerområder er satt',
    unsavedPostalCodeRule: 'Legg til postnummerregelen før du lagrer',
    applyToConnectedRule: 'Bruk disse endringene på den tilknyttede ruteregelen "{{name}}"',
    serviceExclusionDescription:
      'Ordre med en av disse tjenestekodene blir aldri tildelt denne ruten av auto-dispatch.',
    postalCodeRulesSaved: 'Postnummerreglene ble oppdatert med suksess',
    postalCodeRulesSavedAndApplied: 'Postnummerreglene ble oppdatert med suksess og også brukt på regelen "{{name}}"',
    postalCodesTab: 'Postnumre',
    routeRuleTab: 'Ruteregel',
    connectRouteRuleSubHeading:
      'Knytt en ruteregel til denne ruten. Postnummerreglene på ruten overskrives med reglene fra den valgte ruteregelen.',
    selectRouteRule: 'Velg ruteregel',
    routeRuleIsRequired: 'Ruteregel må velges',
    routeRuleConnected: 'Postnummerreglene ble overskrevet fra ruteregelen "{{name}}"',
    postalCodeRuleType: 'Regeltype',
    includePostalCodes: 'Inkluder',
    excludePostalCodes: 'Ekskluder',
    postalCodeRange: 'Område',
    exactPostalCode: 'Eksakt postnummer',
    postalCodeFrom: 'Fra postnummer',
    postalCodeTo: 'Til postnummer',
    addPostalCodeRule: 'Legg til postnummerregel',
    noPostalCodeRules: 'Ingen lagt til ennå',
    savedPostalCodeRules: 'Lagrede postnummerregler',
    postalCodeRuleRequired: 'Postnummer er påkrevd',
    postalCodeRuleConflict: {
      duplicate: 'Denne postnummerregelen finnes allerede',
      overlap: 'Regelen overlapper den eksisterende regelen "{{rule}}"',
      excludeNotContained: 'Ekskluderingsregelen "{{rule}}" må være innenfor et inkluderingsområde',
      excludeCoversInclude: 'En ekskluderingsregel kan ikke dekke hele inkluderingsområdet "{{rule}}"'
    },
    skipAutoDispatch: 'Deaktiver auto-dispatch',
    enableAutoDispatch: 'Aktiver auto-dispatch',
    skipAutoDispatchSuccess: '{{name}} ble deaktivert for auto-dispatch med suksess',
    enableAutoDispatchSuccess: '{{name}} ble aktivert for auto-dispatch med suksess',
    completedRoute: '{{name}} er fullført',
    routeCreatedMessage: 'Ruten ble lagret og lagt til rutelisten',
    createRoute: 'Opprett rute',
    saveAndCreateRoute: 'Lagre og opprett ny rute',
    routeWasDeleted: 'Ruten ble slettet med suksess',
    routeWasUpdated: 'Ruten ble oppdatert med suksess',
    routeWasUpdated_other: 'Rutene ble oppdatert med suksess',
    routeWasDeleted_other: 'Rutene ble slettet med suksess',
    sendPrePickupSms: 'Forhånds‑send sporing SMS',
    deleteAllRoutes: 'Slett alle ruter',
    routesNotStarted: 'Ruter ikke startet',
    noRoutes: 'Ingen ruter er opprettet ennå',
    viewStopsGrouped: 'Grupper stopp',
    showCompletedDeliveries: 'Vis fullførte',
    showRemainingDeliveries: 'Vis gjenværende',
    orders: 'Ordrer',
    onlyUnaccepted: 'kun ikke-aksepterte',
    onlyRoutesWithUnacceptedOrders: 'Vis kun ruter med ikke-aksepterte ordrer',
    activeFilters: 'Aktive filtre',
    clearFilters: 'Fjern filter',
    clearSearch: 'Tøm søk',
    removeFilter: 'Fjern filteret {{name}}',
    selectedCount: '{{count}} valgt',
    selectedCount_other: '{{count}} valgt',
    selectedCount_zero: 'ingen valgt',
    routeState: 'Rutetilstand',
    routeLabels: 'Ruteetiketter',
    state: 'Tilstand',
    routeNameAZ: 'Rutenavn A–Å',
    routeNameZA: 'Rutenavn Å–A',
    routeStartedAZ: 'Rute startet A-Å',
    routeNotStartedAZ: 'Rute ikke startet A-Å',
    deletePlannedStopFromSlot: 'Slett planlagt stopp fra ruten',
    deleteBreakFromSlot: 'Slett pausetid fra ruten',
    plannedStopDeletedFromSlot: 'Planlagt stopp ble slettet fra ruten',
    movedOrderToRouteSuccess: 'Ordre ble flyttet til rute {{routeName}}',
    movedOrderToRouteSuccess_other: '{{count}} ordrer ble flyttet til rute {{routeName}}',
    moveOrderToRouteQuestion: 'Flytt ordre til rute {{routeName}}?',
    moveOrderToRouteQuestion_other: 'Flytt {{count}} ordrer til rute {{routeName}}?',
    couldNotMoveOrderToRoute: 'Kunne ikke flytte ordre til rute {{routeName}}',
    failedToOptimizeSlotAfterDeletingPlannedStop: 'Kunne ikke optimalisere ruten etter sletting av planlagt stopp',
    actionsForAllShipments: 'Handlinger for alle forsendelser',
    removePlannedStopFromRouteAndReoptimize:
      'Det planlagte stoppet vil bli fjernet fra ruten og ruten vil automatisk bli re-optimalisert.',
    unassignShipmentFromRouteAndReoptimize:
      'Forsendelsen vil bli fjernet fra ruten og ruten vil automatisk bli re-optimalisert.',
    unassignShipmentFromRouteAndReoptimize_other:
      'Forsendelsene vil bli fjernet fra ruten og ruten vil automatisk bli re-optimalisert.',
    quickEditDisabledTooltip: 'Du mangler tilgang til avdelingen for denne ordren.',
    routeLabel: 'Ruteetikett',
    selectRouteLabel: 'Velg ruteetikett',
    labelFilter: {
      title: 'Filtrer ruter etter etikett',
      description:
        'Denne avdelingen har ruteetiketter. Velg én eller flere etiketter for å begrense hvilke ruter som vises.',
      selectLabels: 'Velg etiketter',
      apply: 'Bruk filter',
      showAll: 'Vis alle ruter',
      or: 'ELLER',
      and: 'OG'
    },
    mustSelectVehicle: 'Du må velge et kjøretøy'
  },
  reports: {
    serviceTimeWindow: 'Levert innenfor servicetidsvindu',
    estimatedTimeWindow: 'Levert innenfor estimert tid',
    correctLocation: 'Levert på riktig sted',
    withinSTW: 'Innenfor STW',
    withinETD: 'Innenfor ETD',
    withinPAW: 'Innenfor PAW',
    followedRoutes: 'Fulgte ruter',
    departmentTitle: 'Rapporter for {{name}}',
    serviceWindow: 'Servicevindu',
    estimatedWindow: 'Estimert vindu',
    quality: 'Kvalitet',
    scrollToStop: 'Rull til stopp',
    stopGraphLabel: 'Stoppdata',
    hiddenStopsTooltip: 'Denne grafen inneholder skjulte stopp. Klikk for å se hvilke stopp',
    graphContainsHiddenStops: 'Denne grafen inneholder skjulte stopp',
    stopWasHiddenDueToDeliveryDateSetTo: 'Stopp {{stopNumber}} ble skjult fordi leveringsdato var {{date}}',
    stopWasHiddenDueToDeliveryDateNotSet: 'Stopp {{stopNumber}} ble skjult fordi det ikke ble fullført',
    productionAccuracy: 'Produksjonsvindu',
    productionAccuracyTimeWindow: 'Levert innenfor produksjonsvinduet',
    actualStop: 'Faktisk stopprekkefølge',
    plannedStop: 'Planlagt stopprekkefølge',
    serviceTimeWindowTooltip: '{{number}} stopp levert innen servicetidsvinduet.',
    estimatedTimeWindowTooltip: '{{number}} stopp levert innen det estimerte tidsvinduet.',
    correctLocationTooltip: '{{number}} stopp levert til riktig sted.',
    followedRoutesTooltipStops: '{{number}} stopp gjennomført i riktig rekkefølge.',
    followedRoutesTooltipOrders: '{{number}} ordre levert i riktig rekkefølge.',
    productionAccuracyTooltip: '{{number}} stopp levert innen produksjonsvinduet.'
  },
  settings: {
    profile: 'Profil',
    departmentsSaved: 'Avdelingene dine ble lagret'
  },
  iamOnboarding: {
    description:
      'Det ser ut som du ikke har noen avdelinger koblet til kontoen din ennå. Du kan legge til avdelingene du trenger tilgang til via Innstillinger i menyen til venstre.',
    goToSettings: 'Gå til Innstillinger'
  },
  iamMigrationModal: {
    title: 'Handling kreves: søk om Glow One Identity-rollen',
    body: 'Som Posten & Bring-ansatt trenger du nå rollen nedenfor for å logge inn i Glow. Søk om denne rollen i One Identity.',
    instructions:
      'Gå til <a>{{iamUrl}}</a> og søk om rollen. Når søknaden er godkjent, kan du logge inn i Glow med Posten-kontoen din.',
    roleLabel: 'Rolle du må søke om',
    copyRole: 'Kopier rollenavn',
    copied: 'Kopiert',
    applyForRole: 'Søk om rollen',
    confirmCheckbox: 'Jeg bekrefter at jeg har søkt om rollen F_APP_S55475-GLOW_USR',
    confirm: 'Fortsett'
  }
}
export default nb
